export const SEU_FALLBACK_CONFIG: unknown = {
  'fan.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'targetValues',
        type: 'SUBTITLE',
      },
      {
        name: 'isFreeOutlet',
        type: 'INPUT',
        inputType: 'select',
        options: ['isFreeOutletOptions'],
        default: 'False',
      },
      {
        name: 'pressure_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'pressureGain',
            checked: true,
            items: [
              {
                name: 'pressureGainInput',
                type: 'INPUT',
                inputType: 'number',
                units: ['PressureAbs'],
              },
            ],
          },
          {
            name: 'totalPressure',
            items: [
              {
                name: 'totalPressureInput',
                type: 'INPUT',
                inputType: 'number',
                units: ['Pressure'],
              },
            ],
          },
        ],
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'fanSettings',
        type: 'SUBTITLE',
      },
      {
        name: 'tolerance',
        type: 'INPUT',
        inputType: 'number',
        units: ['Percent'],
        default: 10,
      },
      {
        name: 'frequencyDrop',
        type: 'INPUT',
        inputType: 'select',
        options: ['frequency'],
        default: '50.0',
      },
      {
        name: 'fuDrop',
        type: 'INPUT',
        inputType: 'select',
        options: ['fuMode'],
        default: 'False',
      },
      {
        name: 'conveyingMedium',
        type: 'INPUT',
        inputType: 'select',
        options: ['conveyingMediumOptions'],
        default: '5.0',
      },
      {
        name: 'autoDirectRadio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'autoMode',
            checked: true,
          },
          {
            name: 'directMode',
            items: [
              {
                name: 'productKey',
                type: 'INPUT',
                inputType: 'text',
              },
              {
                name: 'shorteningFactor',
                type: 'INPUT',
                inputType: 'number',
                default: 1,
              },
              {
                name: 'rotationSpeed',
                type: 'INPUT',
                inputType: 'number',
                units: ['RotationSpeed'],
              },
            ],
          },
        ],
      },
    ],
  },
  'pipe_simple.svg':
    '<svg width="538" height="312" viewBox="0 0 538 312" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" overflow="hidden">\n    <defs>\n        <clipPath id="clip0_pipe"><rect x="399" y="2004" width="538" height="312"/></clipPath>\n        <image width="308" height="233" xlink:href="data:image/png;base64,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" preserveAspectRatio="none" id="img1"></image>\n    </defs>\n    <g clip-path="url(#clip0_pipe)" transform="translate(-399 -2004)">\n        <path d="M509.891 2014.5 544.489 2014.5C565.28 2014.5 584.596 2023.66 600.618 2039.35L610.435 2051.09 723.158 2051.57 733.381 2039.35C749.404 2023.66 768.719 2014.5 789.511 2014.5L824.109 2014.5C879.553 2014.5 924.5 2079.64 924.5 2160 924.5 2240.36 879.553 2305.5 824.109 2305.5L789.511 2305.5C761.789 2305.5 736.691 2289.21 718.524 2262.88L718.08 2262.1 615.92 2262.1 615.476 2262.88C597.309 2289.21 572.211 2305.5 544.489 2305.5L509.891 2305.5C454.447 2305.5 409.5 2240.36 409.5 2160 409.5 2079.64 454.447 2014.5 509.891 2014.5Z" stroke="#0094DA" stroke-width="20.625" stroke-miterlimit="8" fill="#5B9BD5" fill-rule="evenodd"/>\n        <path d="M410.5 2158C410.5 2077.64 455.271 2012.5 510.5 2012.5 565.728 2012.5 610.5 2077.64 610.5 2158 610.5 2238.36 565.728 2303.5 510.5 2303.5 455.271 2303.5 410.5 2238.36 410.5 2158Z" stroke="#0094DA" stroke-width="4.58333" stroke-miterlimit="8" fill="#CDEAF8" fill-rule="evenodd"/>\n        <path d="M449.5 2159C449.5 2078.64 494.495 2013.5 550 2013.5 605.505 2013.5 650.5 2078.64 650.5 2159 650.5 2239.36 605.505 2304.5 550 2304.5 494.495 2304.5 449.5 2239.36 449.5 2159Z" stroke="#0094DA" stroke-width="6.875" stroke-miterlimit="8" fill="#CDEAF8" fill-rule="evenodd"/>\n        <use width="100%" height="100%" xlink:href="#img1" fill="none" transform="translate(496 2041)"></use>\n        <path d="M691.5 2163C691.5 2082.64 736.495 2017.5 792 2017.5 847.505 2017.5 892.5 2082.64 892.5 2163 892.5 2243.36 847.505 2308.5 792 2308.5 736.495 2308.5 691.5 2243.36 691.5 2163Z" stroke="#0094DA" stroke-width="6.875" stroke-miterlimit="8" fill="#CDEAF8" fill-rule="evenodd"/>\n        <path d="M731 2163.5C731 2083.14 775.995 2018 831.5 2018 887.005 2018 932 2083.14 932 2163.5 932 2243.86 887.005 2309 831.5 2309 775.995 2309 731 2243.86 731 2163.5Z" stroke="#0094DA" stroke-width="10.3125" stroke-miterlimit="8" fill="#CDEAF8" fill-rule="evenodd"/>\n        <path d="M763.5 2161.5C763.5 2100.75 795.512 2051.5 835 2051.5 874.488 2051.5 906.5 2100.75 906.5 2161.5 906.5 2222.25 874.488 2271.5 835 2271.5 795.512 2271.5 763.5 2222.25 763.5 2161.5Z" stroke="#0094DA" stroke-width="6.875" stroke-miterlimit="8" fill="#CDEAF8" fill-rule="evenodd"/>\n    </g>\n</svg>',
  'uit201_RadioinRadio.json': {
    items: [
      {
        name: '201_RadioinRadio',
        type: 'TITLE',
      },
      {
        name: 'EINS',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'A',
            items: [
              {
                name: 'eins_A_Input',
                type: 'INPUT',
                inputType: 'text',
              },
            ],
          },
          {
            name: 'B',
          },
          {
            name: 'C',
            checked: true,
            items: [
              {
                name: 'eins_C_Radio',
                type: 'RADIO_GROUP',
                radioItems: [
                  {
                    name: 'A2',
                    items: [
                      {
                        name: 'eins_C_Radio_A2_Radio',
                        type: 'RADIO_GROUP',
                        radioItems: [
                          {
                            name: 'A3',
                            checked: true,
                            items: [
                              {
                                name: 'eins_C_Radio_A2_Radio_A3_Input_1',
                                type: 'INPUT',
                                inputType: 'number',
                                units: ['schlauchlaenge'],
                                default: 7.0,
                              },
                            ],
                          },
                          {
                            name: 'B3',
                            items: [
                              {
                                name: 'eins_C_Radio_A2_Radio_B3_Input_1',
                                type: 'INPUT',
                                inputType: 'number',
                                units: ['PressureAbs'],
                                default: -98.765,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    name: 'B2',
                    checked: true,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  'uit101_Number.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="58.5" y="50" fill="red">101</text>\n</svg>\n',
  'uit303_ListinList.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'htmlTranslations.json': {
    items: [
      {
        type: 'TITLE',
        name: 'htmlTranslationsTitle',
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'randomSubtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'selectWithHtmls',
        type: 'INPUT',
        inputType: 'select',
        options: ['option1'],
      },
      {
        name: 'multiSelectWithHtmls',
        type: 'INPUT',
        inputType: 'multi-select',
        options: ['option1'],
      },
      {
        name: 'searchWithHtmls',
        type: 'INPUT',
        inputType: 'search',
        data: ['zz_UI_TestHtmlSearch'],
      },
      {
        name: 'inputWithHtml',
        type: 'INPUT',
        inputType: 'text',
        importance: 'optional',
        hoverText: 'hoverTextWithHtml',
        mouseOver: 'mouseOverWithHtml',
      },
      {
        name: 'throwError',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'no',
            checked: true,
          },
          {
            name: 'yes',
          },
        ],
      },
    ],
  },
  'uit100_Text.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'pipe.svg':
    '<svg width="538" height="312" viewBox="0 0 538 312" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" overflow="hidden">\n    <defs>\n        <clipPath id="clip0_pipe"><rect x="399" y="2004" width="538" height="312"/></clipPath>\n        <image width="308" height="233" xlink:href="data:image/png;base64,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" preserveAspectRatio="none" id="img1"></image>\n    </defs>\n    <g clip-path="url(#clip0_pipe)" transform="translate(-399 -2004)">\n        <path d="M509.891 2014.5 544.489 2014.5C565.28 2014.5 584.596 2023.66 600.618 2039.35L610.435 2051.09 723.158 2051.57 733.381 2039.35C749.404 2023.66 768.719 2014.5 789.511 2014.5L824.109 2014.5C879.553 2014.5 924.5 2079.64 924.5 2160 924.5 2240.36 879.553 2305.5 824.109 2305.5L789.511 2305.5C761.789 2305.5 736.691 2289.21 718.524 2262.88L718.08 2262.1 615.92 2262.1 615.476 2262.88C597.309 2289.21 572.211 2305.5 544.489 2305.5L509.891 2305.5C454.447 2305.5 409.5 2240.36 409.5 2160 409.5 2079.64 454.447 2014.5 509.891 2014.5Z" stroke="#0094DA" stroke-width="20.625" stroke-miterlimit="8" fill="#5B9BD5" fill-rule="evenodd"/>\n        <path d="M410.5 2158C410.5 2077.64 455.271 2012.5 510.5 2012.5 565.728 2012.5 610.5 2077.64 610.5 2158 610.5 2238.36 565.728 2303.5 510.5 2303.5 455.271 2303.5 410.5 2238.36 410.5 2158Z" stroke="#0094DA" stroke-width="4.58333" stroke-miterlimit="8" fill="#CDEAF8" fill-rule="evenodd"/>\n        <path d="M449.5 2159C449.5 2078.64 494.495 2013.5 550 2013.5 605.505 2013.5 650.5 2078.64 650.5 2159 650.5 2239.36 605.505 2304.5 550 2304.5 494.495 2304.5 449.5 2239.36 449.5 2159Z" stroke="#0094DA" stroke-width="6.875" stroke-miterlimit="8" fill="#CDEAF8" fill-rule="evenodd"/>\n        <use width="100%" height="100%" xlink:href="#img1" fill="none" transform="translate(496 2041)"></use>\n        <path d="M691.5 2163C691.5 2082.64 736.495 2017.5 792 2017.5 847.505 2017.5 892.5 2082.64 892.5 2163 892.5 2243.36 847.505 2308.5 792 2308.5 736.495 2308.5 691.5 2243.36 691.5 2163Z" stroke="#0094DA" stroke-width="6.875" stroke-miterlimit="8" fill="#CDEAF8" fill-rule="evenodd"/>\n        <path d="M731 2163.5C731 2083.14 775.995 2018 831.5 2018 887.005 2018 932 2083.14 932 2163.5 932 2243.86 887.005 2309 831.5 2309 775.995 2309 731 2243.86 731 2163.5Z" stroke="#0094DA" stroke-width="10.3125" stroke-miterlimit="8" fill="#CDEAF8" fill-rule="evenodd"/>\n        <path d="M763.5 2161.5C763.5 2100.75 795.512 2051.5 835 2051.5 874.488 2051.5 906.5 2100.75 906.5 2161.5 906.5 2222.25 874.488 2271.5 835 2271.5 795.512 2271.5 763.5 2222.25 763.5 2161.5Z" stroke="#0094DA" stroke-width="6.875" stroke-miterlimit="8" fill="#CDEAF8" fill-rule="evenodd"/>\n    </g>\n</svg>',
  'operationalExpenditures.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'template_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'templateSearch',
        type: 'INPUT',
        inputType: 'search',
        data: ['opex_templateSearch'],
        importance: 'optional',
      },
      {
        name: 'general_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'energy_cost',
        type: 'INPUT',
        inputType: 'number',
        units: ['Cost_energy'],
      },
      {
        name: 'water_cost',
        type: 'INPUT',
        inputType: 'number',
        units: ['Cost_volume_mass'],
      },
      {
        name: 'gas_cost',
        type: 'INPUT',
        inputType: 'number',
        units: ['Cost_energy'],
      },
      {
        name: 'anschaffungskosten_list',
        type: 'LIST',
        importance: 'optional',
        initItemCount: 0,
        maxItemCount: 25,
        listItems: [
          {
            name: 'anschaffungSpecies',
            type: 'INPUT',
            inputType: 'search',
            data: ['opex_AdditivSearch'],
          },
          {
            name: 'anschaffungValue',
            type: 'INPUT',
            inputType: 'number',
            units: ['Cost_volume_mass'],
          },
        ],
      },
      {
        name: 'entsorgungskosten_list',
        type: 'LIST',
        importance: 'optional',
        initItemCount: 0,
        maxItemCount: 25,
        listItems: [
          {
            name: 'entsorgungSpecies',
            type: 'INPUT',
            inputType: 'search',
            data: ['opex_EntsorgungSearch'],
          },
          {
            name: 'entsorgungValue',
            type: 'INPUT',
            inputType: 'number',
            units: ['Cost_volume_mass'],
          },
        ],
      },
    ],
  },
  'uit101_Number.json': {
    items: [
      {
        name: 'number_title',
        type: 'TITLE',
      },
      {
        name: 'EINS',
        type: 'INPUT',
        inputType: 'number',
      },
      {
        name: 'ZWEI',
        type: 'INPUT',
        inputType: 'number',
        disabled: true,
        default: 2.71,
      },
      {
        name: 'DREI',
        type: 'INPUT',
        inputType: 'number',
        disabled: false,
      },
      {
        name: 'VIER',
        type: 'INPUT',
        inputType: 'number',
        importance: 'optional',
      },
      {
        name: 'FÜNF',
        type: 'INPUT',
        inputType: 'number',
        importance: 'mandatory',
      },
      {
        name: 'SECHS',
        type: 'INPUT',
        inputType: 'number',
        default: 3.14,
      },
      {
        name: 'SIEBEN',
        type: 'INPUT',
        inputType: 'number',
        units: ['Length'],
      },
      {
        name: 'ACHT',
        type: 'INPUT',
        inputType: 'number',
        units: ['Percent'],
      },
      {
        name: 'NEUN',
        type: 'INPUT',
        inputType: 'number',
        units: ['Length', 'aufstellungshoehe'],
      },
      {
        name: 'ELF',
        type: 'INPUT',
        inputType: 'number',
        units: ['Length'],
        importance: 'optional',
      },
      {
        name: 'DREIZEHN',
        type: 'INPUT',
        inputType: 'number',
        units: ['Length'],
        defaultUnit: 'mm',
        default: 3.14,
      },
      {
        name: 'VIERZEHN',
        type: 'INPUT',
        inputType: 'number',
        units: ['Percent'],
        importance: 'optional',
      },
      {
        name: 'SECHSZEHN',
        type: 'INPUT',
        inputType: 'number',
        units: ['Length'],
        disabled: true,
        default: 2.71,
        defaultUnit: 'mm',
      },
    ],
  },
  'DE.json': {
    hierarchy: {
      drySorb: 'Entschwefelung',
      dummy: 'Sonstiges',
      dust: 'Entstaubung',
      fluidFlow: 'Mischer & Splitter',
      nox: 'Entstickung',
      pressure: 'Druck',
      sources: 'Wärmeübertrager',
      zzUiTests: 'UiTests',
      streamModifier: 'Stream-Modifier',
      zzCodes: 'zzCodes',
    },
    sorbensReactor: {
      componentName: 'Trockensorption',
      form: {
        saureKomponenten_title: 'Saure Komponenten',
        saureZielwerte_List: 'weitere Zielwerte',
        saureZielwerte_species: '',
        saureZielwerte_value: '',
        saureAdditiv_radio: '',
        keineVorauswahl_radioItem: 'keine Vorauswahl',
        Vorauswahl_radioItem: 'Vorauswahl',
        feasibleAdditiv_MS: '',
        Vorgabe_radioItem: 'Vorgabe Additiv',
        saureAdditiv_Vorgabe_select: '',
        saureAdditiv_Vorgabe_radio: '',
        calcStoechMassFlow_radioItem: 'Passende Stöchiometrie/Massenstrom',
        setStoech_radioItem: 'Stöchiometrie (bezogen Inlet) vorgeben',
        setStoech_input: '',
        setMassFlow_radioItem: 'Massenstrom (bezogen Inlet) vorgeben',
        setMassFlow_input: '',
        Aktivkohle_Schadstoffe_title: 'Sonstige Komponenten',
        ACZielwerte_Liste: 'Zielwerte',
        ACZielwerte_species: '',
        ACZielwerte_value: '',
        Sonstiges: 'Sonstiges',
        Kombidosierung_radio: 'Kombidosierung',
        Kombidosierung_yes: 'Ja',
        Kombidosierung_no: 'Nein',
        Lagerdauer_input: 'Gewünschte Lagerdauer',
        expertMode_radio: '',
        expertMode_no: 'Nein',
        expertMode_yes: 'Ja',
        berucksichtigungErwarteteReingaswerte_radio:
          'Berücksichtigung erwarteter Reingaswerte',
        berucksichtigungErwarteteReingaswerte_yes: 'Ja',
        berucksichtigungErwarteteReingaswerte_no: 'Nein',
        Kalkhydrat_expert_subtitle: 'Kalkhydrat',
        reserveZuschlag_Kalkhydrat_input: 'Reserve',
        DichteUberschreiben_Kalkhydrat_input: 'Dichte überschreiben',
        Bicar_expert_subtitle: 'Bicar',
        reserveZuschlag_Bicar_input: 'Reserve',
        DichteUberschreiben_Bicar_input: 'Dichte überschreiben',
        Aktivkohle_expert_subtitle: 'Aktivkohle',
        reserveZuschlag_Aktivkohle_input: 'Reserve',
        DichteUberschreiben_Aktivkohle_input: 'Dichte überschreiben',
        Reststoff_expert_subtitle: 'Reststoff',
        DichteUberschreiben_Reststoff_input: 'Dichte',
        HF_Out: 'HF',
        acdosierung_keineVorauswahl: 'keine Vorauswahl',
        acdosierung_vorauswahl_input: '',
        HCl_Out: 'HCl',
        acdosierung_Vorauswahl: 'Vorauswahl',
        SOx_Out: 'SOx',
        SOx_Tooltip:
          'SOx = SO2 + <a href="https://www.netural.com" target="_blank">SO3</a> (sofern SO3 im Inlet vorhanden ist) lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
        Zielwerte_subtitle: 'Zielwerte',
        ACDosierung_radio: '',
        expertMode_subtitle: 'Experten Modus',
        volFlowAirStreamGes_input: 'Luftzugabe (Additiv)',
        saureAdditive_subtitle: 'Additiv',
        ACDosierung_subtitle: 'Aktivkohle Dosierung',
        Hg_Out: 'Hg',
        PCDD_PCDF_Out: 'PCDD/F',
      },
      solutions: {
        '{key_}UILabel': '',
        sorbensFailureInfoUILabel: 'Additiv Grenzen',
        LuftzugabeUILabel: 'Luftzugabe',
        OPEXEntsorgungUILabel: 'Entsorgungskosten',
        'eta_{schadstoff_}UILabel': '',
        VerbrauchUILabel: 'Verbrauch',
        OPEXTotalUILabel: 'Gesamt OPEX',
        OPEXAnschaffungUILabel: 'Anschaffungskosten',
        VerbrauchGarantieUILabel: 'Verbrauch (Garantie)',
        generalUILabel: 'Allgemein',
        OPEX_title_UILabel: 'Betriebskosten',
        nestedSorbensFailureSolutionUILabel: 'Additiv',
        AdditivUILabel: 'Additiv',
        '{sorbens_}UILabel': '',
        StoechiometrieUILabel: 'Stöchiometrie λ',
        TemperaturUILabel: 'Temperatur',
        lambdaUILabel: 'Stöchiometrie λ',
        roh_HClUILabel: 'HCl Rohgas',
        rein_HClUILabel: 'HCl Reingas',
        eta_HClUILabel: 'η(HCl)',
        HCl: 'HCl Reingas',
        roh_SO2UILabel: 'SO2 Rohgas',
        rein_SO2UILabel: 'SO2 Reingas',
        eta_SO2UILabel: 'η(SO2)',
        SO2: 'SO2 Reingas',
        roh_SO3UILabel: 'SO3 Rohgas',
        rein_SO3UILabel: 'SO3 Reingas',
        eta_SO3UILabel: 'η(SO3)',
        SO3: 'SO3 Reingas',
        roh_HFUILabel: 'HF Rohgas',
        rein_HFUILabel: 'HF Reingas',
        eta_HFUILabel: 'η(HF)',
        HF: 'HF Reingas',
        roh_HIUILabel: 'HI Rohgas',
        rein_HIUILabel: 'HI Reingas',
        eta_HIUILabel: 'η(HI)',
        HI: 'HI Reingas',
        roh_HBrUILabel: 'HBr Rohgas',
        rein_HBrUILabel: 'HBr Reingas',
        eta_HBrUILabel: 'η(HBr)',
        HBr: 'HBr Reingas',
        SOx: 'SOx Reingas',
        roh_SOxUILabel: 'SOx Rohgas',
        rein_SOxUILabel: 'SOx Reingas',
        eta_SOxUILabel: 'η(SOx)',
        SorbacalSPUILabel: 'Sorbacal SP',
        SorbacalSPSUILabel: 'Sorbacal SPS',
        stdHydLimeUILabel: 'std. Kalkhydrat',
        NaHCO3UILabel: 'Bicarbonat',
        PACUILabel: 'Aktivkohle',
        '{schadstoff_PAC}_eta_UILabel': 'η',
        kombidosierungUILabel: 'Kombidosierung',
        '{schadstoff_PAC}_clean_UILabel': 'Reingas',
        siloSize_PAC_UILabel: 'Silogröße (PAC)',
        siloSize_UILabel: 'Silogröße',
        reqPACUILabel: 'Benötigte Aktivkohle',
        reqPACGarantieUILabel: 'Benötigte Aktivkohle (Garantie)',
        LuftzugabeSauerUILabel: 'Luftzugabe (Bicar/Kalkhydrat)',
        LuftzugabePACUILabel: 'Luftzugabe (Aktivkohle)',
        SauerUILabel: 'Sauer',
        siloSize_SAUER_UILabel: 'Silogröße (Bicar/Kalkhydrat)',
        SonstUILabel: 'Sonstiges',
        Hg_eta_UILabel: 'η(Hg)',
        Hg_clean_UILabel: 'Hg Reingas',
        PCDD_PCDF_eta_UILabel: 'η(PCDD/PCDF)',
        PCDD_PCDF_clean_UILabel: 'PCDD/PCDF Reingas',
        OPEXAnschaffungSauerUILabel: 'Anschaffungskosten (Bicar/Kalkhydrat)',
        OPEXAnschaffungPACUILabel: 'Anschaffungskosten (Aktivkohle)',
        OPEXAnschaffungTotalUILabel: 'Anschaffungskosten (Gesamt)',
        siloSizeUILabel: 'Silogröße',
      },
      options: {
        saureAdditiv_options: {
          stdHydLime: 'Standard Kalkydrat',
          SorbacalSP: 'Sorbacal SP (Kalkhydrat)',
          SorbacalSPS: 'Sorbacal SPS (Kalkhydrat)',
          NaHCO3: 'Bicarbonat',
        },
        saureZielwerte_options: {
          HI: 'HI',
          HBr: 'HBr',
        },
        ACZielwerte_options: {
          Hg: 'Hg',
          PCDD_PCDF: 'PCDD/F',
        },
      },
    },
    bagFilter: {
      componentName: 'Gewebefilter',
      form: {
        bagFilter: 'Gewebefilter',
        targetValues: 'Zielwerte',
        FFB: 'Filterflächenbelastung',
        dustOut: 'Reingasstaubgehalt',
        preSelection: '',
        noSelection: 'Automatisch',
        filterParameters: 'Produktauswahl einschränken',
        category: 'Produktfamilie(n)',
        maxHoseLength: 'Max. Schlauchlänge',
        maxHoseLength_hover:
          'Tatsächliche Abmessung des Schlauchs, nicht die Kennzahl',
        maxWidth: 'Max. Breite',
        maxDepth: 'Max. Tiefe',
        productKey: 'Produktschlüssel',
        productKeyInput: '',
        expertMode_yes: 'Ja',
        expertMode_no: 'Nein',
        expertMode_radio: '',
        filterSelection: 'Produktauswahl',
        expertModeSubtitle: 'Experten Modus',
        verluste_subtitle: 'Verluste',
        pressVerlust_input: 'Druckverlust',
        tempVerlust_input: 'Temperaturverlust',
      },
      solutions: {
        StaubabscheidungUILabel: 'Staubabscheidung',
        baseAreaUILabel: 'Grundfläche',
        depthUILabel: 'Tiefe',
        filterSelectionUILabel: 'Filterauswahl',
        smallestPossibleFilterUILabel: 'Kleinster möglicher Gewebefilter',
        generalUILabel: 'Allgemein',
        filterAreaUILabel: 'Filterfläche',
        strengthClassUILabel: 'Festigkeitsklasse',
        ffbUILabel: 'Filterflächenbelastung (FFB)',
        ReingasstaubUILabel: 'Reingasstaubgehalt',
        possibleFiltersUILabel: 'Mögliche Filter',
        widthUILabel: 'Breite',
        strengthClassPlotUILabel: 'Druck-Temperatur Funktion',
        typeUILabel: 'Produktschlüssel',
        hoseLengthUILabel: 'Schlauchlänge',
        givenFilterUILabel: 'Angegebener Filter',
        filterPossibleUILabel: 'Filter erlaubt?',
        AbscheiderateUILabel: 'Abscheiderate',
      },
      options: {
        categories: {
          'fi pp': 'fipp',
          sf: 'sf',
          'fi m': 'fim',
        },
      },
    },
    cyclone: {
      componentName: 'Zyklon',
      form: {
        cyclone: 'Zyklon',
        particleDensity: 'Partikeldichte',
        bulkDensity: 'Schüttdichte',
        productSelection: 'Produktauswahl',
        inletGeometry: 'Einlassgeometrie',
        exhaustSpiral: 'Auslassspirale',
        productSelectionRadio: '',
        noSelection: 'Keine Voreinstellungen',
        productKey: 'Produktschlüssel',
        productKeyInput: '',
        cycloneType: 'Hauptgruppe',
        numberOfCyclones: 'Anzahl Zyklone',
        dustSeparation: 'Gewünschter Abscheidegrad',
        pressureDrop: 'Gewünschter Druckverlust',
        filterProducts: '',
        noFilter: 'Keine Voreinstellungen',
        filter: 'Produkte Filtern',
        totalHeight: 'Gesamthöhe',
        expertMode_yes: 'Ja',
        expertMode_no: 'Nein',
        expertMode_radio: 'Experten Modus',
      },
      solutions: {
        generalUILabel: 'Allgemein',
        pressureDropUILabel: 'Druckverlust',
        solidMassFlowOutUILabel: 'Massenfluss Feststoffe Output',
        dustSeparationUILabel: 'Abscheidegrad',
        numberOfCyclonesUILabel: 'Anzahl paralleler Zyklone',
        givenCycloneUILabel: 'Angegebener Zyklon',
        solidMassFlowSeparatedUILabel: 'Massenfluss Abscheidung',
        cycloneSelectionUILabel: 'Mögliche Zyklone',
        solidMassFlowInUILabel: 'Massenfluss Feststoffe Input',
        possibleDustSeparationUILabel: 'Möglicher Abscheidegrad',
        productSolutionsUILabel: 'Produktbezogene Ergebnisse',
        expectedPressureDropUILabel: 'Erwarteter Druckverlust',
        typeUILabel: 'Produktschlüssel',
        possibleVolflowUILabel: 'Möglich bei aktuellem Volumensfluss',
        solidVolFlowSepartedUILabel: 'Abscheidemenge',
        dUILabel: 'd (um)',
        partsUILabel: 'Anteil (Vol%)',
        kgvUILabel: 'Korngrößenverteilung',
      },
      options: {
        cycloneTypes: {
          zh: 'zh',
          zs: 'zs',
          zv: 'zv',
          zp: 'zp',
          'hd zy': 'hd zy',
        },
        exhaustSpiralOptions: {
          True: 'Ja',
          False: 'Nein',
        },
        inletGeometryOptions: {
          spiral: 'Spirale',
          tangential: 'Tangential',
        },
        numberOfCyclonesOptions: {
          '1.0': 1.0,
          '2.0': 2.0,
          '3.0': 3.0,
          '4.0': 4.0,
          '5.0': 5.0,
          '6.0': 6.0,
        },
        emptyOption: {
          '': '',
        },
      },
    },
    eFilter: {
      componentName: 'E-Filter',
      form: {
        eFilter_title: '',
        Zielwert: 'Zielwerte',
        reserve: 'Reserve',
        dust_eFilter_OUT: 'Reingasstaubgehalt',
        HS_aggregat: 'HS-Aggregat',
        expertMode_yes: 'Ja',
        expertMode_no: 'Nein',
        expertMode_radio: '',
        gluehverlust_in_flugasche: 'Glühverlust Asche',
        eFilterOldNew: 'E-Filter Gruppe(n)',
        productKeyInput: '',
        filterProducts: 'Produktauswahl einschränken',
        productKey: 'Produktschlüssel',
        auto: 'Automatisch',
        calcMode: 'Filterauswahl',
        Filter_subtitle: 'Produktauswahl',
        ExpertMode_subtitle: 'Experten Modus',
        productKeyOldInput: 'Typ',
        espOldSelect: 'ESP Groß',
        espNewSelect: 'ESP Neu',
        nEFieldsInput: 'Anzahl E-Felder',
        productKeyNewInput: 'Typ',
      },
      solutions: {
        FilterUILabel: 'ESP-Typ',
        elektrFelderUILabel: 'elektr. Felder',
        slightly_too_big_ESPUILabel: 'nächst größerer ESP-Typ',
        TaupunktUILabel: 'Wassertaupunkt',
        slightly_too_small_ESPUILabel: 'nächst kleinerer ESP-Typ',
        AuslegungUILabel: 'Auslegung',
        ReststoffUILabel: 'Reststoff',
        ReserveUILabel: 'Reserve',
        smallest_ESPUILabel: 'Kleinster ESP-Typ',
        reserve_reqUILabel: 'ber. Reserve',
        TypUILabel: 'ESP-Typ',
        AbscheiderateUILabel: 'Abscheiderate',
        AllgemeinUILabel: 'Allgemein',
        generalUILabel: 'Allgemein',
        StaubascheidungUILabel: 'Staubabscheidung',
        possibleFiltersUILabel: 'Zulässige ESP',
        filterSelectionUILabel: 'ESP Auswahl',
        gasVelocityUILabel: 'Gasgeschwindigkeit',
        smallestEspUILabel: 'Kleinster ESP-Typ',
        powerConsumptionUILabel: 'Strombedarf',
        givenReserveUILabel: 'Angegebene Reserve',
        gasVelocityMaxUILabel: 'maximale Gasgeschwindigkeit',
        SuccessUILabel: 'Erfolg',
        elektrFelderInputUILabel: 'elektr. Felder (Eingabe)',
        elektrFelderRequiredUILabel: 'elektr. Felder (berechnet)',
        setFilterTitleUILabel: 'vorgegebener E-Filter',
        FailureUILabel: 'Fehlschlag',
        setESPUILabel: 'ESP-Typ',
        FailureReserveUILabel: 'Überprüfung Reserve',
        FailureEFieldsUILabel: 'Überprüfung E-Felder',
        allESPsGroupUILabel: 'Alle ESP',
        feasibleESPsGroupUILabel: 'Zulässige ESP',
        allESPsUILabel: 'ESP Typ',
        feasibleESPsUILabel: 'ESP Typ',
        FailureVelocityUILabel: 'Überprüfung Gasgeschwindigkeit',
      },
      options: {
        HS_aggregate: {
          Rico: 'Rico',
          NWL: 'NWL',
          Kraft: 'Kraft',
          'Rico-3-Phasen': 'Rico-3-Phasen',
          'Kraft-3-Phasen': 'Kraft-3-Phasen',
        },
        oldNewOptions: {
          new: 'E-Filter Neu',
          old: 'E-Filter Groß',
        },
        nEFieldsOptions: {
          efields_1: 1.0,
          efields_2: 2.0,
          efields_3: 3.0,
        },
      },
    },
    fua: {
      componentName: 'Funkenabscheider',
      form: {
        fua: 'Funkenabscheider',
        dustSeparation: 'Abscheidegrad',
        pressureDrop: 'Druckverlust',
        autoDirectRadio: '',
        auto: 'Automatisch',
        direct: 'Produktschlüssel',
        productKeyInput: '',
        expertMode_yes: 'Ja',
        expertMode_no: 'Nein',
        expertMode_radio: '',
        targetValues: 'Zielwerte',
        productSelectionSubtitle: 'Produktauswahl',
        expertModeSubtitle: 'Experten Modus',
      },
      solutions: {
        generalUILabel: 'Allgemein',
        solidsSeparationMassflowUILabel: 'Staubabscheidung',
        solidsOutConcentrationUILabel: 'Reingasstaubgehalt',
        pressureDropUILabel: 'Druckverlust',
        gasVelocityUILabel: 'Gasgeschwindigkeit',
        productSolutionsUILabel: 'Funkenabscheider Auswahl',
        designVolumeFlowUILabel: 'Auswahlvolumenstrom',
        expectedPressureDropUILabel: 'Erwarteter Druckverlust',
        actualVolumeFlowUILabel: 'Tatsächlicher Volumenstrom',
        selectedFuaForCalculationUILabel:
          'Ausgewählter Funkenabscheider für Gasstrom Berechnung',
        possibleFuasUILabel: 'Mögliche Funkenabscheider',
        massUILabel: 'Gewicht',
        selectedFuaUILabel: 'Angegebener Funkenabscheider',
      },
      options: {
        products: {
          'fua-3-0355': 'fua-3-0355',
          'fua-3-0400': 'fua-3-0400',
          'fua-4-0450': 'fua-4-0450',
          'fua-4-0500': 'fua-4-0500',
          'fua-4-0560': 'fua-4-0560',
          'fua-4-0630': 'fua-4-0630',
          'fua-4-0710': 'fua-4-0710',
          'fua-4-0800': 'fua-4-0800',
          'fua-4-0900': 'fua-4-0900',
          'fua-4-1000': 'fua-4-1000',
          'fua-4-1120': 'fua-4-1120',
          'fua-4-1250': 'fua-4-1250',
          'fua-5-1400': 'fua-5-1400',
          'fua-5-1600': 'fua-5-1600',
          'fua-5-1800': 'fua-5-1800',
          'fua-5-2000': 'fua-5-2000',
          'fua-5-2240': 'fua-5-2240',
          'fua-6-2500': 'fua-6-2500',
        },
      },
    },
    pipe: {
      componentName: 'Rohrleitung',
      form: {
        GeometrieRadio: '',
        mitZetaItem: 'ζ-Wert',
        ZetaInput: 'ζ-Wert',
        RundItem: 'Durchmesser',
        DurchmesserInput: 'Durchmesser',
        KanalItem: 'Länge & Breite',
        KanalBreiteInput: 'Breite',
        KanalTiefeInput: 'Tiefe',
        QuerschnittItem: 'Querschnitt',
        GasGeschwindigkeitItem: 'Gasgeschwindigkeit',
        GasGeschwindigkeitInput: 'Gasgeschwindigkeit',
        QuerschnittRadio: 'Querschnitt',
        QuerschnittOderGasGeschw: 'Querschnitt/Gasgeschwindigkeit',
        RohrlaengeInput: 'Rohrlänge',
        RauigkeitInput: 'Rauigkeit',
        ohneZetaKanalTiefeInput: 'Tiefe',
        ohneZetaDurchmesserInput: 'Durchmesser',
        ohneZetaRundItem: 'Durchmesser',
        ohneZetaKanalBreiteInput: 'Breite',
        ohneZetaKanalItem: 'Länge & Breite',
        RohrlaengeUndRauigkeitItem: 'Rohrlänge & Rauheit',
        QuerschnittInput: 'Querschnittsfläche',
        pipeTitle: 'Rohrleitung',
        geometry: 'Geometrie',
      },
      solutions: {
        pressureDropUILabel: 'Druckverlust',
        generalUILabel: 'Allgemein',
        gasVelocityUILabel: 'Gasgeschwindigkeit',
        densityUILabel: 'Dichte',
        zetaUILabel: 'Zeta ζ',
      },
      options: {},
    },
    pipe_simple: {
      componentName: 'Rohrleitung (Einfach)',
      form: {
        Angabe_Title: 'Rohrleitung (Einfach)',
        DruckverlustInput: 'Druckverlust Δp',
        targetValues: 'Zielwerte',
      },
      solutions: {
        pressureDropUILabel: 'Druckverlust',
        generalUILabel: 'Allgemein',
      },
      options: {},
    },
    scr: {
      componentName: 'SCR',
      form: {
        scr: 'Selektive Katalytische Reduktion',
        targetValues: 'Zielwerte',
        NOx_out: 'Stickoxide NOx',
        NH3_out: 'Ammoniak-Schlupf',
        additiv_type: 'Ammoniak oder Harnstofflösung',
        useVorverdampferHead: 'Vorverdampfer',
        useVorverdampfer: 'Ja',
        notUseVorverdampfer: 'Nein',
        SCR_title: 'Selektive Katalytische Reduktion',
        Zielwerte_subtitle: 'Zielwerte',
        Garantiezeit: 'Garantiezeit [a]',
        useVorverdampfer_radio: 'Vorverdampfer',
        expertMode_radio: '',
        expertMode_no: 'Nein',
        expertMode_yes: 'Ja',
        sauerstoffkorrektur_radio: 'Sauerstoffkorrektur anwenden',
        sauerstoffkorrektur_yes: 'Ja',
        sauerstoffkorrektur_no: 'Nein',
        additionalReserve: 'zusätzliche Reserve (nach Deaktivierung)',
        reserveAdditivOverwrite: 'Additiv Reserve',
        modultyp_select: 'Modultyp',
        ModultypGeometrie_Radio: 'Geometrie',
        ModultypGeometrie_standard: 'Standard',
        ModultypGeometrie_sonder: 'Sonder',
        Geometrie_subtitle: 'Geometrie',
        geometrie_length: 'Länge',
        geometry_width: 'Breite',
        reserveStockwerk_radio: 'Reserve Stockwerk',
        reserveStockwerk_auto: 'Auto',
        reserveStockwerk_no: 'Nein',
        reserveStockwerk_yes: 'Ja',
        zelligkeit_select: 'Zelligkeit',
        ReaktionsEnthalpie_radio: 'Reaktionsenthalpie berücksichtigen',
        ReaktionsEnthalpie_no: 'Nein',
        ReaktionsEnthalpie_yes: 'Ja',
        ExpertMode_subtitle: 'Experten Modus',
        Einstellungen_subtitle: 'Einstellungen',
      },
      solutions: {
        chosen_additiveUILabel: 'Ausgewähltes Additiv',
        AdditivUILabel: 'Additiv',
        VerweilzeitUILabel: 'Verweilzeit',
        AdditivverbrauchUILabel: 'Additivverbrauch',
        AllgemeinUILabel: 'Allgemein',
        StöchiometrischerAdditivverbrauchUILabel:
          'Stöchiometrischer Additivverbrauch',
        AuslegungUILabel: 'Auslegung',
        SonstigesUILabel: 'Sonstiges',
        FlächenbelasttungUILabel: 'Flächenbelastung',
        VolumenKatalysatorUILabel: 'Volumen Katalysator (theoretisch)',
        spezifischeOberflächeUILabel: 'spezifische Oberfläche',
        ZellzahlUILabel: 'Zellzahl',
        eta_NH3UILabel: 'η NH3',
        ReserveUILabel: 'Reserve',
        K0UILabel: 'K0',
        eta_NOxUILabel: 'η NOx',
        RaumgeschwindigkeitUILabel: 'Raumgeschwindigkeit',
        OberflächeKatalysatorUILabel: 'Oberfläche Katalysator',
        'Benötigte Lagen_UILabel': 'Anzahl Lagen',
        Bezeichnung_UILabel: 'Modulbezeichnung',
        ModulauswahlUILabel: 'SCR & Modul Auswahl',
        'Benötigte Etagen_UILabel': 'Anzahl Stockwerke',
        'Module gesamt_UILabel': 'Anzahl Module gesamt',
        Hersteller_UILabel: 'x',
        'Benötigte KatLänge_UILabel': 'Benötigte Katalysator Länge',
        Längenüberschuss_UILabel:
          'Längenüberschuss - Katalysator Länge vs. Benötigte Länge',
        Typ_UILabel: 'SCR Typ',
        extraLageSuggested_UILabel: 'Extra Lage empfohlen',
        Modullänge_UILabel: 'Modullänge Katalysator',
        'Gesamte KatLänge_UILabel': 'Gesamtlänge Katalysator',
        GasgeschwindigkeitUILabel: 'Gasgeschwindigkeit',
        tMinSCR_CERAM_UILabel: 'minimale Betriebstemperatur (CERAM)',
        tMinSCR_JM_UILabel: 'minimale Betriebstemperatur (J&M)',
        verbautesVolumen_UILabel: 'Volumen Katalysator (tatsächlich)',
        extraEtageSuggested_UILabel: 'zusätzliches Stockwerk empfohlen',
        cost_UILabel: 'Kosten Katalysator',
        Modultyp_UILabel: 'Modultyp',
        modultyp_kassette: 'Kassetten',
        modultyp_standard: 'Klein-Module (Standard)',
      },
      options: {
        garantie_options: {
          garantie_1: 1.0,
          garantie_2: 2.0,
          garantie_3: 3.0,
          garantie_4: 4.0,
          garantie_5: 5.0,
        },
        modultyp_options: {
          modultyp_standard: 'Klein-Module (Standard)',
          modultyp_kassette: 'Kassetten',
        },
        solvents: {
          'Ammoniakwasser 24.5%': 'Ammoniakwasser 24.5%',
          'Ammoniakwasser 19%': 'Ammoniakwasser 19%',
          'Harnstofflösung 40%': 'Harnstofflösung 40%',
        },
        zelligkeit_options: {
          keineVorgabe: 'keine Vorgabe',
          Zelligkeit_10: 10.0,
          Zelligkeit_15: 15.0,
          Zelligkeit_18: 18.0,
          Zelligkeit_20: 20.0,
          Zelligkeit_25: 25.0,
          Zelligkeit_30: 30.0,
          Zelligkeit_35: 35.0,
          Zelligkeit_40: 40.0,
          Zelligkeit_47: 47.0,
        },
      },
    },
    fan: {
      componentName: 'Ventilator',
      form: {
        fan_title: 'Ventilator',
        pressure: 'Druck',
        isFreeOutlet: '',
        pressure_radio: '',
        pressureGain: 'Druckerhöhung',
        pressureGainInput: '',
        totalPressure: 'Absolutdruck nach Ventilator',
        totalPressureInput: '',
        otherSettingsSubtitle: 'Weitere Einstellwerte',
        negativeIntakePressure: 'Unterdruck am Saugstutzen',
        maxTemperature: 'Max. Mediumstemperatur',
        tolerance: 'Toleranz',
        frequencyDrop: 'Frequenz',
        fuDrop: 'Frequenzumformer',
        overrideDensity: 'Dichte überschreiben',
        autoDirectRadio: 'Produktauswahl',
        autoMode: 'Automatisch',
        directMode: 'Produktschlüssel',
        productKey: 'Produktschlüssel',
        shorteningFactor: 'Kürzungsfaktor',
        rotationSpeed: 'Drehzahl',
        conveyingMedium: 'Fördermedium',
        fanSettings: 'Einstellungen Produktauswahl',
        targetValues: 'Zielwerte',
      },
      solutions: {
        shorteningFactorUILabel: 'Kürzungsfaktor',
        fanSelectionUILabel: 'Typenauswahl',
        negativePressureIntakeUILabel: 'Unterdruck am Saugstutzen',
        rotationSpeedUILabel: 'Drehzahl',
        bestFanUILabel: 'Bester Ventilator',
        efficiencyUILabel: 'Wirkungsgrad',
        lPasUILabel: 'Lpas',
        calculatedPressureIncreaseUILabel: 'Berechnete Druckerhöhung',
        ambientPressureUILabel: 'Umgebungsdruck',
        temperatureDifferenceUILabel: 'Wärmeentwicklung durch Ventilator',
        enthalpyGainUILabel: 'Enthalpieänderung',
        powerAtWheelUILabel: 'Leistungsbedarf am Laufrad',
        pressureIncreaseUILabel: 'Totaldruckerhöhung',
        possibleFansUILabel: 'Mögliche Ventilatoren',
        pressureIncreaseFreeOutletUILabel: 'Druckerhöhung frei ausblasend',
        fanWorksUILabel: 'Ventilator funktioniert?',
        lPauUILabel: 'LpAu',
        conveyingMediumUILabel: 'Fördermedium',
        generalUILabel: 'Allgemein',
        lPadUILabel: 'Lpad',
        densityAtFanUILabel: 'Dichte für Ventilatorauslegung',
        frequencyUILabel: 'Frequenz',
        numberOfPolesUILabel: 'Pole',
        shortenedDiameterUILabel: 'Gekürzter Laufraddurchmesser',
        powerAtFanUILabel: 'Leistungsbedarf am Ventilator',
        capexUILabel: 'Anschaffungskosten',
        opexUILabel: 'Betriebskosten',
        volumeFlowUILabel: 'Fördervolumen',
        toleranceUILabel: 'Toleranz',
        driveCategoryUILabel: 'Antriebsart',
        fuModeUILabel: 'Frequenzumformer',
        radialFanInputUILabel: 'Radial Fan Eingaben',
        seriesUILabel: 'Baureihe',
        autoModeUILabel: 'Auto Mode',
        maxMediumTemperatureUILabel: 'max. Mediumstemperatur',
        isFreeOutletUILabel: 'Frei-ausblasend',
        impellerTypeUILabel: 'Laufradtyp',
        nominalWidthUILabel: 'Nennweite',
        fanDensityUILabel: 'Spezielle Dichte',
        normDensityUILabel: 'Normdichte',
      },
      options: {
        frequency: {
          '50.0': '50 Hz',
          '60.0': '60 Hz',
        },
        isFreeOutletOptions: {
          False: 'Totaldruckerhöhung',
          True: 'Frei-ausblasend',
        },
        fuMode: {
          True: 'mit FU',
          False: 'ohne FU',
        },
        conveyingMediumOptions: {
          '1.0': 'Materialtransport',
          '2.0': 'Reinluft',
          '3.0': 'Staubhaltige Luft',
          '5.0': 'Spezielles Gas',
        },
      },
    },
    eco: {
      componentName: 'ECO',
      form: {
        ECO: 'ECO',
        ECO_TypLabel: 'Typ',
        Wasserseite_Subtitle: 'Wasserseite',
        WasserTemperatur_Eintritt_label: 'Temperatur Eintritt',
        WasserVolumenstrom_label: 'Volumenstrom [m³/h]',
        Rohrmaterial_label: 'Werkstoff (Rohr)',
        productSelectionRadio: 'Produktauswahl',
        noSelection: 'Automatisch',
        productKey: 'Produktschlüssel',
        preSelectionSubtitle: 'Einstellungen Produktauswahl',
        powerReserve: 'Leistungsreserve',
        expertMode_no: 'Nein',
        expertMode_radio: '',
        expertMode_yes: 'Ja',
        expertModeSubtitle: 'Experten Modus',
        Teilung_vertikal: 'Teilung (Vertikal)',
        Rohre_pro_Buendel: 'Rohre je Bündel',
        d_außen: 'Rohrdurchmesser (außen)',
        Buendelanordnung: 'Bündelanordnung',
        Dicke_Schmutz: 'Dicke Schmutz',
        Druckklasse_PN: 'Druckklasse',
        Buendelanzahl: 'Bündelanzahl',
        Rohre_nebeneinander: 'Rohre nebeneinander',
        Rohrrauhigkeit: 'Rohrrauigkeit',
        RohranschlussId: 'Rohranschluss',
        Rohrlaenge: 'Rohrlänge',
        Wege_pro_Buendel: 'Wege je Bündel',
        manualSelection: 'Manuelle Auswahl',
        Teilung_horizontal: 'Teilung (Horizontal)',
        Wand_Rohr_s: 'Rohrwanddicke',
        Umlenkung: 'Umlenkung',
      },
      solutions: {
        'ECO TYP_UILabel': 'ECO Typ',
        Feuchte_UILabel: 'Feuchte',
        'Thermische Leistung_UILabel': 'Thermische Leistung',
        G_Austrittstemperatur_UILabel: 'Gas Austrittstemperatur',
        W_Druckverlust_UILabel: 'Wasser Druckverlust',
        G_Druckverlust_UILabel: 'Gas Druckverlust',
        W_Austrittstemperatur_UILabel: 'Wasser Austrittstemperatur',
        WasserVolumenstrom_UILabel: 'Wasser Volumenstrom',
        WasserTemperatur_Eintritt_UILabel: 'Wasser Eintrittstemperatur',
        bestTypeUILabel: 'Bester Typ',
        allTypesUILabel: 'Alle Typen',
        typesSelectionUILabel: 'Typenauswahl',
        G_Eintrittstemperatur_UILabel: 'Gas Eintrittstemperatur',
        Graedigkeit_UILabel: 'Grädigkeit',
        Waermeleistung_UILabel: 'Wärmeleistung',
        waterUILabel: 'Wasserseite',
        generalUILabel: 'Allgemein',
        gasUILabel: 'Rauchgasseite',
        dewPointH2O_UILabel: 'Wassertaupunkt',
        dewPointH2SO4_UILabel: 'Schwefelsäuretaupunkt',
        Heizleistung_UILabel: 'Heizleistung',
      },
      options: {
        ECO_TypListe: {
          'SHR-V84': 'SHR-V84',
          'SHR-V120': 'SHR-V120',
          'SHR-V176': 'SHR-V176',
          'SHR-V241': 'SHR-V241',
          'SHR-V290': 'SHR-V290',
          'SHR-V399': 'SHR-V399',
          'SHR-V479': 'SHR-V479',
        },
        RohrMaterial_liste: {
          '1.4571': 1.4571,
          '1.4462': 1.4462,
          '1.4539': 1.4539,
          '1.4529': 1.4529,
          P235GH: 'P235GH',
        },
        RohranschlussOptions: {
          'DN15(1,7m³/h)': 'DN15(1,7m³/h)',
          'DN20(3,0m³/h)': 'DN20(3,0m³/h)',
          'DN25(5,0m³/h)': 'DN25(5,0m³/h)',
          'DN32(8,3m³/h)': 'DN32(8,3m³/h)',
          'DN40(11,1m³/h)': 'DN40(11,1m³/h)',
          'DN50(18m³/h)': 'DN50(18m³/h)',
          'DN65(29m³/h)': 'DN65(29m³/h)',
          'DN80(41m³/h)': 'DN80(41m³/h)',
          'DN100(69m³/h)': 'DN100(69m³/h)',
          'DN125(104m³/h)': 'DN125(104m³/h)',
          'DN150(152m³/h)': 'DN150(152m³/h)',
          'DN200(261m³/h)': 'DN200(261m³/h)',
          'DN250(409m³/h)': 'DN250(409m³/h)',
          'DN300(578m³/h)': 'DN300(578m³/h)',
        },
        UmlenkungOptions: {
          Kammern: 'Kammern',
          Rohrboegen: 'Rohrbögen',
        },
        BuendelanordnungOptions: {
          '1 Stk. horizontal': '1 Stk. horizontal',
          '2 Stk. vertikal': '2 Stk. vertikal',
          '3 Stk. vertikal': '3 Stk. vertikal',
        },
      },
    },
    heatSource: {
      componentName: 'Wärmetauscher',
      form: {
        heatExchanger: 'Wärmetauscher',
        airToAirHeatExchanger: '',
        heatSourceLabel: 'Wärmeleistung',
        heatSource: '',
        ToutLabel: 'Temperatur',
        Tout: '',
        targetValues: 'Zielwerte',
      },
      solutions: {
        generalUILabel: 'Allgemein',
        WärmeentwicklungUILabel: 'Wärmeentwicklung',
        TemperaturdifferenzUILabel: 'Temperaturdifferenz',
        Heizleistung_UILabel: 'Heizleistung',
        Waermeleistung_UILabel: 'Wärmeleistung',
        h2oDewpointUILabel: 'Wassertaupunkt',
        h2so4DewpointUILabel: 'Schwefelsäuretaupunkt',
      },
      options: {},
    },
    streamModifier: {
      componentName: 'Stream-Modifier',
      form: {
        pressure_radio: '',
        deltaPressure: 'Druckdifferenz',
        deltaPressure_Input: 'Δp',
        newPressure: 'Druck überschreiben',
        newPressure_Input: 'neuer Druck',
        temperature_radio: '',
        deltaTemperature: 'Temperaturdifferenz',
        deltaTemperature_Input: 'ΔT',
        newTemperature: 'Temperatur überschreiben',
        newTemperature_Input: 'neue Temperatur',
        Flow_radio: '',
        deltaFlow: 'Änderung des Massen- oder Volumenstroms',
        deltaFlow_Input: 'Änderung',
        newFlow: 'Massen- oder Volumenstrom überschreiben',
        newFlow_Input: 'neuer Wert',
        Konz_list: 'Schadstoffe',
        loadSpecies: 'Gasspezies',
        konz_radio: '',
        deltaConc: 'Änderung',
        delteConc_Input: '',
        newConc: 'neuer Wert',
        newConc_Input: '',
        expertMode_yes: 'Ja',
        expertMode_no: 'Nein',
        expertMode_radio: '',
        flow_subtitle: 'Massen- oder Volumenstrom',
        ExpertMode_subtitle: 'Experten Modus',
        press_subtitle: 'Druck',
        temp_subtitle: 'Temperatur',
      },
      solutions: {},
      options: {},
    },
    addCodes: {
      componentName: 'Codes Hinzufügen',
      form: {
        addCodesTitle: 'Codes Generator',
        codes_list: 'Codes',
        codes_select: 'Code',
      },
      solutions: {},
      options: {
        codeTypeOptions: {
          code_info: 'Info',
          code_warning: 'Warnung',
          code_crit: 'krit. Warnung',
          code_error: 'Error',
        },
      },
    },
    htmlTranslations: {
      componentName: 'HTML Translations',
      form: {
        randomSubtitle: 'adv <b>Subtitle</b> vdsa',
        selectWithHtmls: 'Select <b>Bold</b>',
        yes: 'Yes',
        no: 'No',
        throwError: 'Throw Error',
        htmlTranslationsTitle: '<b>Bold</b> Title',
        inputWithHtml: 'Text <b>input</b>',
        hoverTextWithHtml: 'Hovertext <b>Bold</b>',
        mouseOverWithHtml: 'Mouse over <b>Bold</b>',
        multiSelectWithHtmls: 'Multiselect',
        searchWithHtmls: 'Search',
      },
      solutions: {
        generalUILabel: 'Allgemein <b>Allgemein</b>',
        secondUILabel: 'Second',
        firstUILabel: 'First',
        thirdUILabel: 'Third <sub>Third</sub>',
      },
      options: {
        option1: {
          one: '<b>One</b>',
          two: 'vol%<sub>tr</sub>',
        },
      },
    },
    uit000_basicSolutions: {
      componentName: '000_basicSolutions',
      form: {
        MyTitle: 'Keine Eingabe notwendig!',
        myInput: 'Keine Eingabe notwendig!',
      },
      solutions: {},
      options: {},
    },
    uit001_nestedSolutions: {
      componentName: '0001_nestedSolutions',
      form: {
        MyTitle: 'keine Eingabe notwendig',
        myInput: 'keine Eingabe notwendig',
      },
      solutions: {
        generalUILabel: 'Zusammenfassung',
        nestedUILabel: 'nestedUILabel',
        normalSolutionBeforeNestedUILabel: 'Normal solution before nested',
        mixedNestedSolutionUILabel: 'Mixed nested and not nested solutions',
        normalSolutionAfterNestedUILabel: 'Normal solution after nested',
        secondNestedUILabel: 'Second nested solution',
      },
      options: {},
    },
    uit100_Text: {
      componentName: '100_Text',
      form: {
        DREI: 'DREI',
        '100_Text': '100_Text',
        FÜNF: 'FÜNF',
        VIER: 'VIER',
        SIEBEN: 'SIEBEN',
        SECHS: 'SECHS',
        ZWEI: 'ZWEI',
        EINS: 'EINS',
      },
      solutions: {
        generalUILabel: 'Zusammenfassung',
        inputUILabel: 'Inputs',
      },
      options: {},
    },
    uit101_Number: {
      componentName: '101_Number',
      form: {
        DREIZEHN: 'DREIZEHN',
        ELF: 'ELF',
        VIERZEHN: 'VIERZEHN',
        DREI: 'DREI',
        FÜNF: 'FÜNF',
        number_title: '101_Number',
        VIER: 'VIER',
        SIEBEN: 'SIEBEN',
        NEUN: 'NEUN',
        SECHSZEHN: 'SECHSZEHN',
        SECHS: 'SECHS',
        ZWEI: 'ZWEI',
        EINS: 'EINS',
        ACHT: 'ACHT',
      },
      solutions: {
        generalUILabel: 'Allgemein',
        inputUILabel: 'Inputs',
        summaryUILabel: 'Zusammenfassung',
      },
      options: {},
    },
    uit102_Select: {
      componentName: '102_Select',
      form: {
        '102_Select': '102_Select',
        DREI: 'DREI',
        FÜNF: 'FÜNF',
        VIER: 'VIER',
        SIEBEN: 'SIEBEN',
        SECHS: 'SECHS',
        ZWEI: 'ZWEI',
        EINS: 'EINS',
        ACHT: 'ACHT',
      },
      solutions: {
        generalUILabel: 'Zusammenfassung',
        inputUILabel: 'Inputs',
      },
      options: {
        option1: {
          element1: 'element1',
          element2: 'element2',
        },
        optionSingleElement: {
          singleElement: 'singleElement',
        },
        emptyOption: {
          '': '',
        },
      },
    },
    uit103_MultiSelect: {
      componentName: '103_MultiSelect',
      form: {
        '103_MultiSelect': '103_MultiSelect',
        EINS: 'EINS',
        ZWEI: 'ZWEI',
        DREI: 'DREI',
        VIER: 'VIER',
        FÜNF: 'FÜNF',
        SECHS: 'SECHS',
        SIEBEN: 'SIEBEN',
        ACHT: 'ACHT',
        NEUN: 'NEUN',
      },
      solutions: {
        generalUILabel: 'Zusammenfassung',
        inputUILabel: 'Inputs',
      },
      options: {
        categories: {
          fipp: 'fipp',
          sf: 'sf',
          fim: 'fim',
          fr: 'fr',
        },
        optionSingleElement: {
          testi: 'testi',
        },
      },
    },
    uit104_Search: {
      componentName: '104_Search',
      form: {
        uit104_Search: '104_Search',
        EINS: 'EINS',
        ZWEI: 'ZWEI',
        DREI: 'DREI',
        VIER: 'VIER',
        FÜNF: 'FÜNF',
        SECHS: 'SECHS',
        SIEBEN: 'SIEBEN',
        ACHT: 'ACHT',
      },
      solutions: {
        generalUILabel: 'Zusammenfassung',
        inputUILabel: 'Inputs',
      },
      options: {},
    },
    uit200_RadioGroup: {
      componentName: '200_RadioGroup',
      form: {
        '200_RadioGroup': '200_RadioGroup',
        EINS: 'EINS',
        A: 'A',
        eins_A_Input1: 'Input1',
        B: 'B',
        C: 'C',
        eins_C_Input1: 'Input2',
        ZWEI: 'ZWEI',
        A2: 'A2',
        B2: 'B2',
        DREI: 'DREI',
        A3: 'A3',
        B3: 'B3',
        C3: 'C3',
        ZWEI_B2_Input1: 'B2 Input',
        ZWEI_A2_Input1: 'A2 Input',
        ZWEI_B2_Input2: 'B2 Input 2',
      },
      solutions: {
        generalUILabel: 'Zusammenfassung',
        inputUILabel: 'Inputs',
      },
      options: {},
    },
    uit201_RadioinRadio: {
      componentName: '201_RadioInRadio',
      form: {
        '201_RadioinRadio': '201_RadioInRadio',
        EINS: 'EINS',
        A: 'A',
        eins_A_Input: 'eins_A_Input',
        B: 'B',
        C: 'C',
        eins_C_Radio: 'eins_C_Radio',
        A2: 'A2',
        eins_C_Radio_A2_Radio: 'eins_C_Radio_A2_Radio',
        A3: 'A3',
        eins_C_Radio_A2_Radio_A3_Input_1: 'eins_C_Radio_A2_Radio_A3_Input_1',
        B3: 'B3',
        eins_C_Radio_A2_Radio_B3_Input_1: 'eins_C_Radio_A2_Radio_B3_Input_1',
        B2: 'B2',
      },
      solutions: {
        inputUILabel: 'Inputs',
        generalUILabel: 'Zusammenfassung',
      },
      options: {},
    },
    uit202_ListinRadio: {
      componentName: '202_ListInRadio',
      form: {
        '202_ListinRadio': '202_ListInRadio',
        EINS: 'EINS',
        A: 'A',
        eins_Radio_A_list: 'eins_Radio_A_list',
        eins_Radio_A_list_Input1: 'eins_Radio_A_list_Input1',
        B: 'B',
        eins_Radio_B_list: 'eins_Radio_B_list',
        eins_Radio_B_list_Input1: 'eins_Radio_B_list_Input1',
        eins_Radio_B_list_Input2: 'eins_Radio_B_list_Input2',
        C: 'C',
        eins_Radio_C_Input: 'eins_Radio_C_Input',
      },
      solutions: {
        generalUILabel: 'Zusammenfassung',
        inputUILabel: 'Inputs',
      },
      options: {},
    },
    uit300_List: {
      componentName: '300_List',
      form: {
        uit300_List: '300_List',
        EINS: 'EINS',
        EINS_numberInput: 'EINS_numberInput',
        ZWEI: 'ZWEI',
        ZWEI_numberInputFirst: 'ZWEI_numberInputFirst',
        ZWEI_numberInputSecond: 'ZWEI_numberInputSecond',
        DREI: 'DREI',
        DREI_searchInputSpecies: 'DREI_searchInputSpecies',
        DREI_numberInputConcentration: 'DREI_numberInputConcentration',
        VIER: 'VIER',
        VIER_mandatoryInput: 'VIER_mandatoryInput',
        VIER_optionalInput: 'VIER_optionalInput',
      },
      solutions: {
        inputUILabel: 'Inputs',
      },
      options: {},
    },
    uit301_RadioInList_1: {
      componentName: '301_RadioInList_1',
      form: {
        '301_RadioInList_1': '301_RadioInList_1',
        EINS: 'EINS',
        list: 'list',
        radio: 'radio',
        A: 'A',
        text: 'text',
        B: 'B',
        C: 'C',
        number: 'number',
      },
      solutions: {
        inputUILabel: 'Inputs',
      },
      options: {},
    },
    uit302_RadioInList_2: {
      componentName: '302_RadioInList_2',
      form: {
        '302_RadioInList_2': '302_RadioInList_2',
        EINS: 'EINS',
        list: 'list',
        radio: 'radio',
        A: 'A',
        list2: 'list2',
        text1: 'text1',
        number1: 'number1',
        B: 'B',
        C: 'C',
        text2: 'text2',
        D: 'D',
      },
      solutions: {
        inputUILabel: 'Inputs',
      },
      options: {},
    },
    uit303_ListinList: {
      componentName: '303_ListInList',
      form: {
        '303_ListinList': '303_ListInList',
        EINS: 'EINS',
        eins_select: 'eins_select',
        eins_search: 'eins_search',
        eins_List: 'eins_List',
        eins_List_Input1: 'eins_List_Input1',
        eins_List_Input2: 'eins_List_Input2',
        eins_List_RadioGroup: 'eins_List_RadioGroup',
        'Ohne Input': 'Ohne Input',
        'Mit Input': 'Mit Input',
        eins_List_RG_Input: 'eins_List_RG_Input',
      },
      solutions: {
        inputUILabel: 'Inputs',
      },
      options: {
        massPercent: {
          mass_percent: 'Gew.-%',
        },
        volumePercent: {
          vol_tr: 'Vol.-%<sub>tr.</sub>',
          vol_fe: 'Vol.-%<sub>fe.</sub>',
        },
      },
    },
    uit400_Transtlations: {
      componentName: '400_Translations',
      form: {
        x_untranslatedRadioItem1: '',
        x_translatedNumber2: 'Number2',
        x_untranslatedLabel: '',
        x_translatedRadio: 'Radio',
        x_translatedText: 'Text',
        x_translatedSearch: 'Search',
        x_mysubtitle: 'Subtitle',
        x_translatedSelect: 'Select',
        x_translatedMultiSearch: 'Multi-Select',
        x_translatedNumber: 'Number',
        x_translatedList: 'List',
        x_translatedRadioItem2: 'RadioItem2',
        x_translatedRadioItem1: 'RadioItem1',
        x_translatedTextInList: 'TextInList',
        x_mytitle: 'Title',
        x_untranslatedList: '',
        x_untranslatedRadio: '',
        x_translatedRadioItem2_secondRadio: 'RadioItem2',
        x_translatedRadioItem1_secondRadio: 'RadioItem1',
        x_untranslatedRadioItem1_secondRadio: '',
        x_translatedTextInList_secondList: 'TextInList',
      },
      solutions: {
        inputUILabel: '',
      },
      options: {
        uit400_MS: {
          ms_key1: 'Key1',
          ms_key2: 'Key2',
          ms_key3: 'Key3',
          ms_key4: 'Key4',
        },
        uit400_Select: {
          s_key1: 'Key1',
          s_key2: 'Key2',
          s_key3: 'Key3',
        },
      },
    },
    inputStream: {
      componentName: '',
      form: {
        stream: 'Rohgasstrom',
        primaryData: 'Allgemein',
        flow: 'Massen- oder Volumenstrom',
        pressure: 'Druck',
        temperature: 'Temperatur',
        gasComponents: '',
        air: 'Luft',
        gasComponentUnits_air: 'Einheit',
        N2_air: 'N<sub>2</sub>',
        O2_air: 'O<sub>2</sub>',
        H2O_air: 'H<sub>2</sub>O',
        notAir: 'Rauchgas',
        gasComponentUnits: 'Einheit Hauptkomponenten',
        N2: 'N<sub>2</sub>',
        O2: 'O<sub>2</sub>',
        H2O: 'H<sub>2</sub>O',
        CO2: 'CO<sub>2</sub>',
        concentrations: 'Schadstoffe',
        loadSpecies: 'Gasspezies',
        loadValue: '',
        Ar_air: 'Ar',
        gasComponentsSubtitle: 'Gaszusammensetzung',
      },
      solutions: {},
      options: {
        volumePercent: {
          vol_tr: 'Vol.-%<sub>tr.</sub>',
          vol_fe: 'Vol.-%<sub>fe.</sub>',
        },
        massPercent: {
          mass_percent: 'Gew.-%',
        },
      },
    },
    globalSettings: {
      componentName: '',
      form: {
        globals: 'Globale Einstellungen',
        general: 'Allgemein',
        ambientTemp: 'Umgebungstemperatur',
        height: 'Aufstellungshöhe über Meeresspiegel',
        fracO2Ref: 'Bezugssauerstoff',
        humidity: 'Luftfeuchte',
        allowO2Transformation_radio: 'O2 Korrektur erlauben',
        allowO2Transformation_yes: 'Ja',
        allowO2Transformation_no: 'Nein',
        O2RefVolTr: 'Bezugssauerstoff',
      },
      solutions: {},
      options: {},
    },
    operationalExpenditures: {
      componentName: '',
      form: {
        opex_title: 'Betriebsmittelkosten',
        general_subtitle: 'Allgemein',
        energy_cost: 'Strom',
        water_cost: 'Wasser',
        gas_cost: 'Gas/Öl',
        anschafffungskosten_subtitle: 'Anschaffung',
        anschaffungskosten_list: 'Anschaffungskosten',
        anschaffungSpecies: 'Betriebsmittel',
        anschaffungValue: '',
        entsorgungskosten_subtitle: 'Entsorgung',
        entsorgungskosten_list: 'Entsorgungskosten',
        entsorgungSpecies: 'Reststoff',
        entsorgungValue: '',
        template_subtitle: 'Vorlage',
        templateSearch: 'Vorlage',
      },
      solutions: {},
      options: {},
    },
    emissionLimit: {
      componentName: '',
      form: {
        templateSearch: '',
        species_list: 'Grenzwerte',
        limits_title: 'Grenzwerte',
        template_subtitle: 'Vorlagen',
        limitValue: '',
        limitSpecies: 'Gasspezies',
        speciesSearch: null,
      },
      solutions: {},
      options: {},
    },
    codes: {
      E099000: 'Interner Fehler',
      W099001: 'Interne Warnung',
      E004000: 'interner Fehler',
      E004003: 'Additiv-Reaktion Fehlgeschlagen',
      W004001: 'interne Warnung',
      W004002: 'Kein zulässiges Additiv gefunden!',
      W004004: 'Warnung bei Berechnung der Betriebsmittelkosten',
      W004005:
        'Warnung bei Berechnung der Luftzugabe. Standardwert für Luftmenge verwendet.',
      W004006:
        'Keine positiven Abscheidegrade gefunden. (es muss nichts abgeschieden werden (?))',
      E001000: 'Berechnung von Gewebefilter fehlgeschlagen!',
      E001101: 'Filterflächenbelastung (FFB) nicht angegeben!',
      E001102: 'Filterflächenbelastung (FFB) darf nicht negativ sein!',
      W001001: 'Warnung bei Gewebefilter aufgetreten!',
      W001103: 'Reingasstaubgehal unter standardmäßigen 2 mg/Nm³ tr, bezO2!',
      W001104: 'Rohgas-Staubgehalt sehr hoch. (über 500 g/Bm³ fe, betO2)!',
      W001201:
        'Kein Filter für die angegebene Filterflächenbelastung (FFB) gefunden!',
      W001202:
        'Kein Filter für die angegebene maximale Schlauchlänge gefunden!',
      W001203: 'Kein Filter für die angegebene maximale Breite gefunden!',
      W001204: 'Kein Filter für die angegebene maximale Tiefe gefunden!',
      W001205: 'Kein Filter für die angegebene Kategorie(n) gefunden!',
      W001105: 'Im Abgas kondensiert etwas! Einsatz von Gewebefilter prüfen',
      W001106: 'Zu hohe Temperatur! Kein Dauerbetrieb möglich.',
      W001107:
        'Zu hohe Temperature! Nur Heißgasfilter im Dauerbetrieb möglich.',
      W001109: 'Rohgas-Staubgehalt > 100 g/m³: Nur SFD und FI PP möglich',
      W001110: 'Rohgas-Staubgehalt > 500 g/m³: Nur FI PP möglich',
      W001111:
        'Sehr geringe FFB - Filter ist ggf. überdimensioniert. FFB < 0,5 [m/min] bzw. 30 [m/h]',
      W001112: 'Sehr hohe FFB. FFB > 2 [m/min] bzw. 120 [m/h]',
      W001114: 'Filter sollten generell im Unterdruck betrieben werden!',
      W001206:
        'Statik Auslegung nicht erfüllt! Temperatur und Druck überprüfen!',
      W001207: 'Unbekannter Produkschlüssel!',
      W001115: 'Sehr niedrige Temperatur!',
      E006000: 'Berechnung von Zyklon fehlgeschlagen!',
      W006001: 'Warnung bei Zyklon aufgetreten!',
      E006101:
        'Es konnte kein Zyklon mit dem angegebenen Produktschlüssel gefunden werden!',
      W006102: 'Standard KGV wird verwendet!',
      W006103: 'Maximal Anzahl von parallelen Zyklonen überschritten (6)!',
      W006104: 'Sehr hohe Staubkonzentration im Abgas!',
      W006201:
        'Es konnte kein passender Zyklon gefunden werden! Bitte Abscheidegrad/Druckverlust anpassen!',
      E002000: 'Berechnung von ESP fehlgeschlagen!',
      E002101: 'Maximale Betriebstemperatur überschritten!',
      E002202: 'Fehler während der Berechnung der Zielwerte!',
      W002001: 'Warnung bei ESP aufgetreten!',
      W002002: 'Betriebstemperatur-Grenze überschritten!',
      W002003: 'CO-Grenze überschritten!',
      W002004: 'Staub-Grenze überschritten!',
      W002005: 'Reingasstaub-Grenze unterschritten!',
      W002006: 'Gasgeschwindigkeit-Grenze überschritten!',
      W002007: 'Gasgeschindigkeit > max Gasgeschwindigkeit!',
      W002201: 'Anzahl der E-Felder konnte nicht berechnet werden!',
      W002203: 'Kein zulässiger ESP-Typ gefunden!',
      E013000: 'Berechnung von Funkenabscheider fehlgeschlagen!',
      W013001: 'Warnung bei Funkenabscheider aufgetreten!',
      C013002: 'Kritische Warnung bei Funkenabscheider aufgetreten!',
      C013103:
        'Kein passender Funkenabscheider gefunden! Standardwert für Druckverlust verwendet.',
      E013102: 'Angegebenen Funkenabscheider funktioniert nicht gefunden!',
      W013101:
        'Sehr hohe Gasgeschwindigkeit! Größeren Funkenabscheider verwenden!',
      E011000: 'Berechnung von ECO fehlgeschlagen!',
      W011001: 'Warnung bei ECO Berechnung aufgetreten!',
      E011002: 'Keine Angabe (Druckverlust, Zeta, Geometrie) erkannt',
      E011003: 'Etwas ist im Reingas kondensiert!',
      E011004: 'Etwas ist im Rohgas kondensiert!',
      E003000: 'Interner Fehler',
      W003001: 'Interne Warnung',
      E003002: 'kein NH3 Slip gefunden',
      E003003: 'kein NOx Reingaswert gefunden',
      E003004: 'unbekanntes Additiv!',
      W003101: 'maximale Betriebstemperatur überschritten',
      W003102: 'Gasgeschwindigkeit zu gering',
      W003103: 'Gasgeschwindigkeit zu hoch',
      W003104:
        'Minimale Betriebstemperatur von Hersteller CERAM unterschritten. Gewährleistung von J&M ggf. möglich!',
      W003105:
        'Minimale Betriebstemperatur unterschritten! Betrieb der SCR nicht möglich! Keine Gewährleistung gegeben.',
      W003106:
        'NOx Reingaswert <  50 mg/Nm³ tr, 11% O2. Sehr geringer NOx Grenzwert. Bitte Eingabe prüfen!',
      W003107:
        'NOx Reingaswert > 400 mg/Nm³ tr, 11% O2. Sehr hoher NOx Reingaswert. Bitte Eingabe prüfen!',
      W003108:
        'Falls Harnstofflösung & T < 240 °C → Umwandlung von Harnstofflösung in Isocyansäure muss sichergestellt werden! ggf. mehr Kat Volumen notwendig.',
      W003200: 'Kein Additiv benötigt!',
      W003201: 'Benötigtes Additiv < NH3 Slip',
      W003202: 'Angestrebter Reingaswert > Rohgaswert',
      W003203: 'Angestrebter Reingaswert > Rohgaswert',
      I003206:
        'Abscheidegrad > 90% → Gegebenfalls eine gestufte Eindüsung von Additiv notwendig',
      W003207:
        'Abscheidegrad < 50% UND PCCD/F vorhanden → Auslegung Katvolumen kann zur Katalysatorhersteller Auslegung abweichen, da Hersteller PCCD/F Abscheidung nicht berücksichtigt',
      W003300: 'Fehler bei Reserveberechnung',
      W003301: 'Fehler bei spez. Oberflächenberechnung.',
      W003302: 'Fehler bei KanalTiefe. Volumenstrom [Bm³ fe/h] zu groß!',
      W003303:
        'Zellzahl zu klein für Low-Dust Anwendungen. Staubgehalt zu groß!',
      W003304: 'Fehler bei Zellzahl Berechnung. Staubgehalt zu groß!',
      I003305: 'Zweite Lage wird benötigt, da η(NOx) groß ist',
      I003306: 'zweite Lage wird benötigt, da NH3 Slip gering ist',
      W003307: 'kein legaler SCR Typ gefunden (zu großer Volumenstrom!)',
      W003308: 'kein legaler SCR Typ gefunden (zu kleiner Volumenstrom!)',
      W003309: 'kein Modell für k0 gefunden, Zellzahl zu klein! K0 geschätzt!',
      W003310: 'kein Modell für k0 gefunden, Zellzahl zu groß! K0 geschätzt!',
      W003311: 'kein Modell für k0 für diese Zellzahl gefunden!',
      W003314:
        'Garantiezeit hoch. Reserve kann ggf. zu Katalysatorhersteller Auslegung abweichen.',
      W003315:
        'Garantiezeit gering. Werden die gesetzlichen Vorgaben eingehalten?',
      W003316:
        'Geringer NH3-Slip. Reserve kann überproportional ansteigen! Berechnetes Volumen kann zur Auslegung des Katalysatorhersteller abweichen',
      W003318: 'Volumenstrom unterschritten. Standardisierung nicht anwendbar!',
      W003319: 'Volumenstrom überschritten. Standardisierung nicht anwendbar!',
      I003208:
        'Abscheidegrad < 50% → Katalysatorvolumen kann im Vergleich zur Auslegung des Herstellers ggf. überdimensioniert sein.',
      W003109:
        'Geringer NH3-Slip. Reserve kann überproportional ansteigen! Berechnetes Volumen kann zur Katalysatorhersteller Auslegung abweichen',
      C003110:
        'Sehr geringer NH3-Slip. Reserve kann überproportional ansteigen!',
      C003111: 'Sehr hoher NH3-Slip.',
      C003204: 'Abscheidegrad zu gering! (< 10%)',
      C003205: 'Abscheidegrad zu hoch! (>99%)',
      E007000: 'Berechnung von Ventilator fehlgeschlagen!',
      E007101: 'Negative Druckerhöhung ist nicht möglich!',
      E007110: 'Maximaler Druck überschritten!',
      W007001: 'Warnung bei Ventilator aufgetreten!',
      W007102: 'Sehr geringer Volumenfluss (min. 500 Bm³fe/h)!',
      W007103: 'Sehr großer Volumenfluss (max. 250.000 Bm³fe/h)!',
      W007104: 'Druckerhöhung ist zu gering (min. 500 Pa)!',
      W007105: 'Druckerhöhung ist zu hoch (max. 20.000 Pa)!',
      W007106: 'Soderausführung für hohe Temperatur nötig (max. 250 °C)!',
      W007107:
        'Max. Temperatur geringer als Rohgastemperatur (max. Temperatur wurde auf Temperatur von Rohgas erhöht)!',
      W007108: 'Minimalen Kürzungsfaktor unterschritten (min. 0.95)!',
      W007109: 'Maximalen Kürzungsfaktor überschritten (max. 1.05)!',
      W007111:
        'Gasstrom Druckberechnung und Ventilatorauslegung stimmt nicht überein (An einer Lösung wird bereits gearbeitet)!',
      W007201:
        'Unbekannter interner Fehler - Es konnten keine Ventilatoren geladen werden!',
      W007202:
        'Benötigte Drehzahl ist niedriger als die maximal Drehzahl von langsameren Laufrad!',
      W007203: 'Angegebene Drehzahl ist ohne FU nicht möglich!',
      W007204:
        'Angegebener Ventilator funktioniert bei aktuellen Betriebszustand nicht!',
      W007205:
        'Angegebene Drehzahl ist höher als maximal erlaubte Drehzahl von Ventilatortyp (Bitte vorher abstimmen)!',
      E005000: 'Berechnung von Wärmetauscher fehlgeschlagen!',
      E005002: 'Maximale Betriebstemperatur überschritten!',
      E005003: 'Minimale Betriebstemperatur unterschritten!',
      W005001: 'Warnung bei Wärmetauscher aufgetreten!',
      E012000: '',
      W012001: '',
      E077000: 'Fehler bei OPEX ConfigTest',
      W077001: 'Warnung bei OPEX ConfigTest',
      E000001: 'Interner Fehler (unbekannte Quelle)!',
      E000004: 'Einheit bei Gaszusammensetzung unbekannt!',
      E000100: 'Plausibilitätsprüfung fehlgeschlagen!',
      E000101: 'Ungültige Stoffe angegeben!',
      E000102: 'Minimale Betriebstemperatur unterschritten!',
      E000103: 'Maximale Betriebstemperatur überschritten!',
      E000104: 'Minimaler Druck unterschritten!',
      E000105: 'Maximaler Druck überschritten!',
      E000107: 'Massenfluss eines Stoffes ist negativ!',
      E000108: 'Unbekannte Komponente in der Verschaltung!',
      E000109: 'Keine Komponeteneingabe erhalten!',
      E000110: 'Eine Komponente in der Verschaltung hat keinen Eingangsstrom!',
      E000111: 'Eine Komponente in der Verschaltung hat keinen Ausgangsstrom!',
      E000112:
        'Ein Gastrom ist mit mehreren Komponenten gleichzeitig verbunden!',
      E000113: 'Mehrere Komponenten haben den gleichen Ausgangsstrom!',
      E000114: 'Ein Gasstrom ist mit keiner Komponente verbunden!',
      E000115: 'Die Verschaltung hat mehrere Ausgangsströme!',
      E000116: 'Das Ergebnis beinhaltet weniger Gasströme als bei der Eingabe!',
      E000117: 'Eine Komponete fehlt beim Ergebnis!',
      E000119:
        'Verschaltungs Matrix stimmt nicht mit den übergebenen Komponenten überein!',
      E000200: 'Interner Fehler beim Interpretieren der Daten',
      E000201: 'Interner Fehler beim Interpretieren der Daten',
      I000000: 'Berechnung erfolgreich!',
      W000002: 'Interne Warnung (unbekannte Quelle)!',
      W000003: 'Eine Umrechenfunktion ist fehlgeschlagen!',
      W000106: 'Ein Stoff in der Zusammensetzung ist kondensiert!',
      W000118: 'Globale Einstellungen von der Eingabe fehlen bei der Ausgabe!',
      E000300: 'Allgemeiner Fehler beim Umrechnen von Komponenten Eingaben!',
      E000301: 'Fehler beim Umrechnen einer Druck-Einheit.',
      E000302: 'Fehler beim Umrechnen einer Leistungs-Einheit.',
      E000303: 'Fehler beim Umrechnen einer Temperatur-Einheit.',
      E000304: 'Fehler beim Umrechnen einer Volumen-Konzentrations-Einheit.',
      E000305: 'Fehler beim Umrechnen einer Massen-Konzentrations-Einheit.',
      E000306: 'Fehler beim Umrechnen einer Längen-Einheit.',
      E000307: 'Fehler beim Umrechnen einer Massen-Einheit.',
      E000308: 'Fehler beim Umrechnen einer Massenfluss-Einheit.',
      E000309: 'Fehler beim Umrechnen einer Zeit-Einheit.',
      E000310: 'Fehler beim Umrechnen einer Volumenfluss-Einheit.',
      E000311: 'Fehler beim Umrechnen einer Dichte-Einheit.',
      E000312: 'Fehler beim Umrechnen einer Volumens-Einheit.',
      E000313: 'Fehler beim Umrechnen einer FFB-Einheit.',
      E000399: 'Einheit nicht in der Einheiten-Datenbank hinterlegt!.',
      E000005: 'Keine Hauptgaskomponenten gefunden!',
      E000121:
        'Sehr hoher Sauerstoffwert! Umrechnungen Betriebssauerstoff ↔ Bezugssauerstoff ungültig!',
      W000120:
        'Hoher Sauerstoffwert! Umrechnungen Betriebssauerstoff ↔ Bezugssauerstoff sind zu hinterfragen!',
      E000401: 'Interner Fehler beim Interpretieren der Daten',
      E000402:
        'Berechnung von Kondensation bei Eingabe von Massenfluss und Gew.-% noch nicht möglich.',
      E000404:
        'Ungültige Einheiten bei Massen-/Volumensfluss und Hauptkomponenten!',
      W000006: 'Werte konnte nicht in Datenbank gefunden werden.',
      W000403:
        'Ein Stoff in der Zusammensetzung ist kondensiert! Ergebnis möglicherweise Fehlerhaft!',
      E000405: 'Fehler bei Kondensation. Maximale Iterationsanzahl erreicht!',
      W000406:
        'Sauerstoffwert [Volumen-% trocken] überschreitet Maximum. Umrechnung Bezugsauerstoff ↔ Betriebssauerstoff nicht möglich!',
      W000122:
        'Feststoff in der Gaszusammensetzung schmilzt bei der aktuellen Temperatur! Er wird jedoch weiterhin als Feststoff behandelt!',
      W000407:
        'Erhöhter Temperaturebereich (zwischen 400°C und 800°C)! Berechnung oder Eingabe prüfen!',
      W000408:
        'Erweiterter Druckbereich (außerhalb ±25.000 Pa Relativdruck)! Berechnung oder Eingabe prüfen!',
      W000409: 'Probleme mit Wasser kondensation in diesem Bereich!',
      W000410:
        'Sehr große Beladung entdeckt! Abweichungen durch Konzentrationsumrechnungen möglich bitte Eingaben und Ergebnisse prüfen.',
      I000411: 'Abweichung der eingegebenen N2-Konzentration kleiner als 0.5%',
      W000412:
        'Abweichung der eingegebenen N2-Konzentration zwischen 0.5% und 0.75%',
      W000413:
        'Abweichung der eingegebenen N2-Konzentration zwischen 0.75% und 1%',
      W000414: 'Abweichung der eingegebenen N2-Konzentration größer als 1%',
      C000415: 'Abweichung der eingegebenen N2-Konzentration größer als 3%',
      I000416: 'Abweichung vom eingegebenen Volumenstrom kleiner als 0.5%',
      W000417: 'Abweichung vom eingegebenen Volumenstrom zwischen 0.5% und 1%',
      W000418: 'Abweichung vom eingegebenen Volumenstrom größer als 1%',
      C000419: 'Abweichung vom eingegebenen Volumenstrom größer als 3%',
      E000124: 'maximale Umgebungstemperatur überschritten!',
      W000123:
        'Umgebungstemperatur hoch, Magnus-Formel für Luftfeuchte nicht mehr akkurat.',
      C000503:
        'Sauerstoffkorrektur erlaubt aber aufgrund der hohen O2-Konzentration nicht möglich!',
      I000501:
        'Sauerstoffkorrektur für diese Komponente nicht zulässig. Grenzwerte unterscheiden sich von der Eingabe!',
      I000502: 'Sauerstoffkorrektur für diese Komponente zulässig.',
      W003312: 'Zu diesem Modultyp wurde keine Information gefunden.',
      C098002: '',
      E098003: 'Dies ist ein Error!',
      I098000: 'Dies ist eine Information!',
      W098001: 'internal Warning (CODES)',
      E098000: 'internal Error (CODES)',
      W098004: 'Dies ist eine Warnung!',
      C003313: 'Abstand zwischen Katalysator und Kanalwand zu groß',
      E010000: 'Berechnung von Rohrleitung fehlgeschlagen!',
      W010001: 'Warnung bei Rohrleitung aufgetreten!',
      E010101: 'Ungültige Eingabe!',
      E010003: 'Druckverlustberechnung fehlgeschlagen!',
      C004002: 'interne kritische Warnung',
      W004007: 'Kein zulässiges Additiv gefunden!',
      C001002: 'Kritische Warnung bei Gewebefilter aufgetreten!',
      C006002: 'interne kritische Warnung',
      C002002: 'interne kritische Warnung',
      C010002: 'Kritische Warnung bei Rohrleitung aufgetreten!',
      C011002: 'Kritische Warnung bei ECO Berechnung aufgetreten!',
      C003002: 'interne kritische Warnung',
      E003005: 'kein NH3-Slip gegeben',
      C007002: 'Kritische Warnung bei Ventilator aufgetreten!',
      E005004: 'Maximale Betriebstemperatur überschritten!',
      C005002: 'Kritische Warnung bei Wärmetauscher aufgetreten!',
      C012002: '',
      C099002: 'Interne kritische Warnung',
      W000007: 'Umrechnungsfunktion fehlgeschlagen',
      C000003: 'interne kritische Warnung',
      C098301: 'Crit. Warning Code 1',
      E098402: 'Error Code 2',
      E098401: 'Error Code 1',
      W098201: 'Warning Code 1',
      W098202: 'Warning Code 2',
      C098302: 'Crit. Warning Code 2',
      I098102: 'Info Code 1',
      I098101: 'Info Code 2',
      C098306: 'Crit. Warning Code 6',
      E098406: 'Error Code 6',
      C098304: 'Crit. Warning Code 4',
      I098103: 'Info Code 3',
      I098104: 'Info Code 4',
      I098105: 'Info Code 5',
      E098403: 'Error Code 3',
      W098206: 'Warning Code 6',
      W098205: 'Warning Code 5',
      W098204: 'Warning Code 4',
      W098203: 'Warning Code 3',
      I098106: 'Info Code 6',
      C098303: 'Crit. Warning Code 3',
      E098405: 'Error Code 5',
      E098404: 'Error Code 4',
      C098305: 'Crit. Warning Code 5',
      W007206:
        'Zugriff auf RadialFan fehlgeschlagen! Produktauswahl nicht möglich!',
      W007207:
        'Der aktuelle Benutzer ist für den RadialFan nicht berechtigt! Produktauswahl nicht möglich!',
      W011005: 'Fehler bei der Berechnung einzelner ECO Typen!',
      E011006: 'Fehler bei der Berechnung von angegebenen ECO Typ!',
      E011007: 'Alle ECO Typen Berchnungen im Automatikmodus fehlgeschlagen!',
      W007208:
        'Ungültiger Produktschlüssel (Max. Drehzahlkennzahl ist ungültig)',
      E004201: 'Fehler bei Einheitentransformation von PAC Komponenten',
      W004202: 'Keine positiven Abscheidegrade (PAC) gefunden.',
      C004203: 'Angegebene Aktivkohle Dosierung nicht ausreichend!',
      C000900: 'interne kritische Warnung (C000900)',
      I007209: 'Keine Energiekosten zur Berechnung angegeben!',
      E011101: 'Ungültige Eingabe!',
      C004301:
        'Keine zulässige Menge für Additive gefunden. Bitte die Eingabe prüfen!',
      I004204: 'Angegebene PAC Dosierung ausreichend für Abscheidung.',
      W002204:
        'Ausgewählter ESP-Typ funktioniert bei aktuellem Betriebszustand nicht.',
      W002105: 'Grenze des Reingasstaubgehalts unterschritten!',
      W002111:
        'E-Filter Groß - Zu großer Unterdruck! Sonderkonstruktion notwendig!',
      W002102:
        'E-Filter Groß - Sehr hohe Betriebstemperatur (>300°C)! Sonderkonstruktion notwendig!',
      W002103: 'Maximal erlaubte CO Konzentration überschritten!',
      W002109: 'Glühverlust > 20 Gew.-%',
      W002104: 'Grenze des Rohgasstaubgehalts überschritten!',
      W002106: 'Gasgeschwindigkeit zu hoch!',
      W002114: 'Taupunkt > 65°C!',
      W002113: 'Taupunkt < 32°C!',
      W002107: 'Gasgeschwindigkeit zu hoch!',
      W002108: 'Kein CO im Abgas vorhanden!',
      C002206: 'Vorgegebener E-Filter nicht zulässig!',
      W002112:
        'E-Filter Groß - Grenze des Überdrucks überschritten! Sonderkonstruktion notwendig!',
      C002204: 'Vorgegebener E-Filter nicht zulässig!',
      W007210:
        'Keinen passenden Ventilator für aktuellen Betriebszustand gefunden',
      W011100: 'Hohe Staubkonzentration im Rohgas! (>= 30 mg/Nm3 tr @8%O2)',
      W011102: 'Sehr hoher Druckverlust beim Rauchgas!',
      W011101: 'Sehr hohe Rauchgastemperatur!',
      W011106: 'H2SO4 Taupunkt unterschritten!',
      C011109: 'Minimale Leistungsreserve unterschritten! (5%)',
      W011104: 'Maximalen Wasserdruckverlust überschritten! (1 Bar)',
      C011110: 'Wassertemperatur ist höher als Rauchgastemperatur',
      W011103: 'Minimalen Wasserdruckverlust unterschritten! (0.2 Bar)',
      C011107: 'Maximale Wassertemperatur überschritten! (110°C)',
      W011105: 'H2O Taupunkt unterschritten!',
      C011108: 'Wassertemperatur beim Eingang - Wassertaupunkt <= 15 °C!',
      W011111: 'Unter dem Wassertaupunkt ist nur Edelstahl zulässig!',
      W001301:
        'Keine Entsorgungskosten für kalkhydrathaltigen Staub gefunden. OPEX können nicht berechnet werden!',
      W001302:
        'Keine Entsorgungskosten für bicarbonathaltigen Staub gefunden. OPEX können nicht berechnet werden!',
      W001300:
        'Keine Entsorgungskosten für Staub gefunden. OPEX können nicht berechnet werden!',
      W004401:
        'Keine Preise für Aktivkohle gefunden, OPEX werden nicht berechnet',
      W004400:
        'Keine Preise für das Additiv gefunden, OPEX werden nicht berechnet',
      W005005:
        'keine Energiekosten gefunden, OPEX konnten nicht berechnet werden!',
      E014101: 'Ungültige Eingabe!',
      C014002: 'Kritische Warnung bei Rohrleitung aufgetreten!',
      E014000: 'Berechnung von Rohrleitung fehlgeschlagen!',
      W014001: 'Allgemeine Warnung bei Rohrleitung aufgetreten!',
      C001115: 'Sehr niedrige Temperatur!',
      C001103: 'Reingasstaubgehalt unter standardmäßigen 2 mg/Nm³ tr, bezO2!',
      C001105: 'Im Abgas kondensiert etwas! Einsatz von Gewebefilter prüfen!',
      C001107: 'Zu hohe Temperatur! Nur Heißgasfilter im Dauerbetrieb möglich.',
      C013003: 'Funkenabscheider Auslegung ist nicht validiert!',
      W007209: 'Keine Energiekosten zur Berechnung angegeben!',
      E000010: 'Fehler bei einer Komponente!',
      E000901: 'interner Fehler (E000901)',
      W000008: 'Warnung bei einer Komponente!',
      C000009: 'Kritische Warnung bei einer Komponente!',
      E012901: 'E012901: Interner Fehler',
      E012900: 'E012901: Interner Fehler',
      E012100:
        'Die Konzentration eines Schadstoffes ist nun negativ. Dies ist nicht erlaubt.',
      E012101: 'Neuer Druck nicht in zulässigem Bereich',
      C012104: 'Neue Schadstoffkonzentration negativ → wird auf 0 gesetzt.',
      E012102: 'Neue Temperatur nicht in zulässigem Bereich',
      E012103: 'Neuer Massen-/Volumenstrom nicht in zulässigem Bereich',
      E000125:
        'Hoher Sauerstoffwert und bezugssauerstoff in Einheiten der Schadstoffkonzentrationen. Diese Kombination ist unzulässig.',
      E000126:
        'Hoher Sauerstoffwert und bezugssauerstoff in Einheiten einer Komponente. Diese Kombination ist unzulässig.',
      C000137:
        'Umgebungstemperatur hoch, Magnus-Formel für Luftfeuchte nicht mehr akkurat.',
      E000140: 'Bezugssauerstoff sehr hoch!',
      E000128: 'Negative Schadstoffkonzentration!',
      E000130: 'Negative Betriebsmittelkosten!',
      E000138: 'Bezugssauerstoff sehr gering!',
      W000139: 'Bezugssauerstoff hoch!',
      E000134: 'Bezugssauerstoff sehr gering!',
      C000136: 'Umgebungstemperatur äußerst hoch!',
      E000135: 'Sehr geringe Luftfeuchte!',
      E000131: 'Negative Emissionsgrenzwerte!',
      E000133:
        'Umgebungsdruck außerhalb erlaubter Grenzen. Bitte Aufstellungshöhe prüfen!',
      E000127: 'Negative Konzentration einer Trägergaskomponente!',
      E000129: 'Negativer Massen-/Volumenstrom!',
      E000132: 'Umgebungstemperatur außerhalb erlaubter Grenzen!',
      W002115:
        'E-Filter Neu - Sehr hohe Betriebstemperatur (>250°C)! Sonderkonstruktion notwendig!',
      W002117:
        'E-Filter Neu - Grenze des Überdrucks überschritten! Sonderkonstruktion notwendig!',
      W002116:
        'E-Filter Neu - Zu großer Unterdruck! Sonderkonstruktion notwendig!',
      W001208: 'Angegebener Filter ist zu klein für die gewünschte FFB!',
      W000314:
        'Emissionsgrenzwerte konnten wegen eines Fehlers bei der Verschaltungsberechnung nicht umgerechnet werden!',
      W004008: '(temporär) interne Warnung.',
      W011112:
        'Der Stoff Hg wird bei der ECO Berechnung zur Zeit noch nicht berücksichtigt!',
      C011010: 'sehr hoher Druckverlust (Rauchgas)! ECO zu klein?',
      C011008:
        'Kein Standard-ECO-Typ gefunden, für welchen der Druckverlust (Rauchgas) im erlaubten Bereich liegt!',
      C011009: 'sehr niedriger Druckverlust (Rauchgas)! ECO zu groß?',
      E000141: 'Kein Sauerstoff im Abgas! Eingaben prüfen!',
      C000142: 'Kein Wasser im Abgas! Eingaben prüfen!',
      I004402:
        'Keine Preise für das Additiv gefunden, OPEX werden nicht berechnet',
      I004403:
        'Keine Preise für Aktivkohle gefunden, OPEX werden nicht berechnet',
      C004009:
        'Eingegebene Additivmenge unzureichend, um die Schadstoffe abzuscheiden.',
      I001303:
        'Keine Entsorgungskosten für Staub gefunden. OPEX können nicht berechnet werden!',
      I001305:
        'Keine Entsorgungskosten für bicarbonathaltigen Staub gefunden. OPEX können nicht berechnet werden!',
      I001304:
        'Keine Entsorgungskosten für kalkhydrathaltigen Staub gefunden. OPEX können nicht berechnet werden!',
      I007211: 'Keine Energiekosten zur Berechnung angegeben!',
      I005006:
        'keine Energiekosten gefunden, OPEX konnten nicht berechnet werden!',
      W002300: 'Interne Warnung (sollte nicht angezeigt werden)',
      C002115: 'obsolete interne kritische Warnung',
      I002117:
        'E-Filter Neu - Grenze des Überdrucks überschritten! Sonderkonstruktion notwendig!',
      I002111:
        'E-Filter Groß - Zu großer Unterdruck! Sonderkonstruktion notwendig!',
      C002101: 'Maximale Betriebstemperatur überschritten!',
      I002116:
        'E-Filter Neu - Zu großer Unterdruck! Sonderkonstruktion notwendig!',
      I002112:
        'E-Filter Groß - Grenze des Überdrucks überschritten! Sonderkonstruktion notwendig!',
      I002115:
        'E-Filter Neu - Sehr hohe Betriebstemperatur (>250°C)! Sonderkonstruktion notwendig!',
      I002102:
        'E-Filter Groß - Sehr hohe Betriebstemperatur (>300°C)! Sonderkonstruktion notwendig!',
      W000902: 'interne Warnung (W000902)',
      W000143:
        'Hoher Sauerstoffwert und bezugssauerstoff in Einheiten der Schadstoffkonzentrationen. Diese Kombination kann zu unerwarteten Ergebnissen führen.',
      W000144:
        'Hoher Sauerstoffwert und bezugssauerstoff in Einheiten einer Komponente. Diese Kombination kann zu unerwarteten Ergebnissen führen.',
      W000601:
        'Referenzsauerstoff bei den Globalen Einstellungen höher als 20 vol%tr! Umrechnung zwischen Betriebssauerstoff und Bezugssauerstoff kann zu unerwarteten Ergebnissen führen!',
      E000600:
        'Referenzsauerstoff bei den Globalen Einstellungen außerhalb der Grenzen! (1 vol%tr < O2 < 21 vol%tr)',
      W000605:
        'Sauerstoffgehalt bei Gasstrom geringer als 1 vol%tr! Umrechnung zwischen Betriebssauerstoff und Bezugssauerstoff kann zu unerwarteten Ergebnissen führen!',
      W000604:
        'Sauerstoffgehalt bei Gasstrom höher als 20 vol%tr! Umrechnung zwischen Betriebssauerstoff und Bezugssauerstoff kann zu unerwarteten Ergebnissen führen!',
      E000602: 'Sauerstoffgehalt bei Gasstrom höher als 21 vol%tr!',
      E000603: 'Kein Sauerstoff im Abgas! Eingaben prüfen!',
      C097005:
        'kritische Warning <b>Code</b> vol%<sub>tr</sub> vol%<sup>fe</sup>',
      E097006: 'Error <b>Code</b> vol%<sub>tr</sub> vol%<sup>fe</sup>',
      W097004: 'Warning <b>Code</b> vol%<sub>tr</sub> vol%<sup>fe</sup>',
      I097003: 'Info <b>Code</b> vol%<sub>tr</sub> vol%<sup>fe</sup>',
    },
    generalTranslations: {
      target: 'Zielwerte',
    },
    outputStream: {
      Temperature: 'Temperatur',
      VolumeFlow: 'Volumenstrom',
      Pressure: 'Druck',
      MassFlow: 'Massenstrom',
      Enthalpy: 'Enthalpiestrom',
      Density: 'Dichte',
      Conductivity: 'Leitfähigkeit',
      DynamicViscosity: 'dyn. Viskosität',
      KinematicViscosity: 'kin. Viskosität',
      HeatCapacityMixture: 'Wärmekapazität',
      H2ODewpoint: 'Wassertaupunkt',
      H2SO4Dewpoint: 'Schwefelsäuretaupunkt',
      solids: 'Feststoffe',
      Ar: 'Ar',
      CH2O: 'CH2O',
      CH4: 'CH4',
      CO: 'CO',
      HBr: 'HBr',
      HCl: 'HCl',
      HF: 'HF',
      HI: 'HI',
      Hg: 'Hg',
      N2O: 'N2O',
      NH3: 'NH3',
      NOx: 'NOx',
      PCDD_PCDF: 'PCDD_PCDF',
      SOx: 'SOx',
    },
    zz_UI_TestSingleSearch: [
      {
        pythonName: 'Staub',
        displayName: 'Staub',
        synonyms: ['Staub'],
      },
    ],
    zz_UI_TestHtmlSearch: [
      {
        pythonName: 'Staub',
        displayName: '<b>Staub</b>',
        synonyms: ['Staub'],
      },
      {
        pythonName: 'H2O',
        displayName: 'H<sub>2</sub>O',
        synonyms: ['H2O'],
      },
    ],
    speciesSearch: [
      {
        displayName: 'Feststoffe',
        pythonName: 'solids',
        synonyms: ['Feststoffe solids Staub dust'],
      },
      {
        pythonName: 'Ar',
        displayName: 'Ar',
        synonyms: ['Argon Ar'],
      },
      {
        pythonName: 'CH2O',
        displayName: 'CH2O',
        synonyms: ['Formaldehyd CH2O'],
      },
      {
        pythonName: 'CH4',
        displayName: 'CH4',
        synonyms: ['Methan CH4'],
      },
      {
        pythonName: 'CO',
        displayName: 'CO',
        synonyms: ['Kohlenmonoxid CO'],
      },
      {
        pythonName: 'HBr',
        displayName: 'HBr',
        synonyms: ['Bromwasserstoff HBr'],
      },
      {
        pythonName: 'HCl',
        displayName: 'HCl',
        synonyms: ['Chlorwasserstoff HCl'],
      },
      {
        pythonName: 'HF',
        displayName: 'HF',
        synonyms: ['Fluorwasserstoff HF'],
      },
      {
        pythonName: 'HI',
        displayName: 'HI',
        synonyms: ['Iodwasserstoff HI'],
      },
      {
        pythonName: 'Hg',
        displayName: 'Hg',
        synonyms: ['Quecksilber Hg'],
      },
      {
        pythonName: 'N2O',
        displayName: 'N2O',
        synonyms: ['Distickstoffmonoxid N2O'],
      },
      {
        pythonName: 'NH3',
        displayName: 'NH3',
        synonyms: ['Ammoniak NH3'],
      },
      {
        displayName: 'NOx',
        pythonName: 'NOx',
        synonyms: [
          'NOx Stickstoffmonoxid stickoxid stickstoffoxid stickstoffdioxid stickdioxid Stickstoffdioxid NO2 Stickstoffmonoxid NO',
        ],
      },
      {
        pythonName: 'PCDD_PCDF',
        displayName: 'PCDD_PCDF',
        synonyms: [
          'Polychlorierte Dibenzo-p-dioxineund Dibenzofurane PCDD_PCDF',
        ],
      },
      {
        displayName: 'SOx',
        pythonName: 'SOx',
        synonyms: ['SOx SOx Schwefeldioxid SO2 Schwefeltrioxid SO3'],
      },
    ],
    units: {
      Density_Bm3: [
        {
          pythonName: 'kg_Bm3',
          displayName: 'kg/m<sup>3</sup><sub>B. </sub>',
          synonyms: ['kg m3B Bm3 m³B Bm³'],
        },
      ],
      MassFlow_kgX: [
        {
          pythonName: 'kg_h',
          displayName: 'kg/h',
          synonyms: ['kg h'],
        },
        {
          pythonName: 'kg_s',
          displayName: 'kg/s',
          synonyms: ['kg s'],
        },
      ],
      AdditiveUnitsPAC: [
        {
          pythonName: 'kg_h',
          displayName: 'kg/h',
          synonyms: ['kg h'],
        },
        {
          pythonName: 'mg_Nm3_tr_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Bm3_fe_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3B fe betrO2 Bm3 m³B Bm³'],
        },
      ],
      Temperature: [
        {
          pythonName: 'gradC',
          displayName: '°C',
          synonyms: ['°C C'],
        },
        {
          pythonName: 'gradK',
          displayName: 'K',
          synonyms: ['K'],
        },
      ],
      Cost_volume_mass: [
        {
          pythonName: 'euro_per_m3',
          displayName: '€/m<sup>3</sup>',
          synonyms: ['euro_per_m3'],
        },
        {
          pythonName: 'euro_per_t',
          displayName: '€/t',
          synonyms: ['euro_per_t'],
        },
        {
          pythonName: 'euro_per_liter',
          displayName: '€/l',
          synonyms: ['euro_per_liter'],
        },
      ],
      VFlowWet: [
        {
          pythonName: 'Nm3_fe_h',
          displayName: 'm<sup>3</sup><sub>N. fe.</sub>/h',
          synonyms: ['m3N fe h Nm3 m³N Nm³'],
        },
        {
          pythonName: 'Bm3_fe_h',
          displayName: 'm<sup>3</sup><sub>B. fe.</sub>/h',
          synonyms: ['m3B fe h Bm3 m³B Bm³'],
        },
        {
          pythonName: 'vol_fe',
          displayName: 'Vol.-%<sub>fe.</sub>',
          synonyms: ['vol fe'],
        },
      ],
      MassHeavy: [
        {
          pythonName: 'kg',
          displayName: 'kg',
          synonyms: ['kg'],
        },
        {
          pythonName: 't',
          displayName: 't',
          synonyms: ['t'],
        },
      ],
      volFlow_NormWetPerHour: [
        {
          pythonName: 'Nm3_fe_h',
          displayName: 'm<sup>3</sup><sub>N. fe.</sub>/h',
          synonyms: ['m3N fe h Nm3 m³N Nm³'],
        },
      ],
      ConcentrationMass_gkg: [
        {
          pythonName: 'g_kg',
          displayName: 'g/kg',
          synonyms: ['g kg'],
        },
      ],
      laengeKurz: [
        {
          pythonName: 'mm',
          displayName: 'mm',
          synonyms: ['mm'],
        },
      ],
      ConcentrationMassPercent: [
        {
          pythonName: 'mass_percent',
          displayName: 'Gew.-%',
          synonyms: ['mass percent'],
        },
      ],
      Cost_time: [
        {
          pythonName: 'euro_per_year',
          displayName: '€/a',
          synonyms: ['euro_per_year'],
        },
      ],
      FlowWet: [
        {
          pythonName: 'mg_Nm3_fe_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Nm3_fe_bezO2',
          displayName: 'mg/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['mg m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Bm3_fe_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'g_Nm3_fe_betrO2',
          displayName: 'g/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['g m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Nm3_fe_bezO2',
          displayName: 'g/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['g m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Bm3_fe_betrO2',
          displayName: 'g/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['g m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'µg_Nm3_fe_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Nm3_fe_bezO2',
          displayName: 'µg/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['µg m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Bm3_fe_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'ng_Nm3_fe_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Nm3_fe_bezO2',
          displayName: 'ng/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['ng m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Bm3_fe_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3B fe betrO2 Bm3 m³B Bm³'],
        },
      ],
      HeatCapacity: [
        {
          pythonName: 'kJ_kgK_isobar',
          displayName: 'kJ/kgK, isobar',
          synonyms: ['kJ kgK isobar'],
        },
        {
          pythonName: 'kappa',
          displayName: 'kappa',
          synonyms: ['kappa'],
        },
      ],
      Volume: [
        {
          pythonName: 'm3',
          displayName: 'm<sup>3</sup>',
          synonyms: ['m3 m³'],
        },
        {
          pythonName: 'l',
          displayName: 'l',
          synonyms: ['l'],
        },
      ],
      ConcentrationMassPpm: [
        {
          pythonName: 'ppm_m',
          displayName: 'ppm<sub>m</sub>',
          synonyms: ['ppm m'],
        },
      ],
      PressureRel: [
        {
          pythonName: 'Pa_rel',
          displayName: 'Pa<sub>rel.</sub>',
          synonyms: ['Pa rel'],
        },
        {
          pythonName: 'mbar_rel',
          displayName: 'mbar<sub>rel.</sub>',
          synonyms: ['mbar rel'],
        },
        {
          pythonName: 'mmH2O_rel',
          displayName: 'mmH2O<sub>rel.</sub>',
          synonyms: ['mmH2O rel'],
        },
      ],
      Currency: [
        {
          pythonName: 'euro',
          displayName: '€',
          synonyms: ['€ euro'],
        },
        {
          pythonName: 'dollar',
          displayName: '$',
          synonyms: ['dollar $'],
        },
      ],
      FFB: [
        {
          pythonName: 'm_min',
          displayName: 'm/min',
          synonyms: ['m min'],
        },
        {
          pythonName: 'm_h',
          displayName: 'm/h',
          synonyms: ['m h'],
        },
      ],
      Flow: [
        {
          pythonName: 'kg_h',
          displayName: 'kg/h',
          synonyms: ['kg h'],
        },
        {
          pythonName: 'kg_s',
          displayName: 'kg/s',
          synonyms: ['kg s'],
        },
        {
          pythonName: 'g_h',
          displayName: 'g/h',
          synonyms: ['g h'],
        },
        {
          pythonName: 'mg_Nm3_fe_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Nm3_fe_bezO2',
          displayName: 'mg/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['mg m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Nm3_tr_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Nm3_tr_bezO2',
          displayName: 'mg/m<sup>3</sup><sub>N. tr, refO<sub>2</sub></sub>',
          synonyms: ['mg m3N tr refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Bm3_fe_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'mg_Bm3_tr_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>B. tr, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3B tr betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'g_Nm3_fe_betrO2',
          displayName: 'g/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['g m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Nm3_fe_bezO2',
          displayName: 'g/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['g m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Nm3_tr_betrO2',
          displayName: 'g/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['g m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Nm3_tr_bezO2',
          displayName: 'g/m<sup>3</sup><sub>N. tr, refO<sub>2</sub></sub>',
          synonyms: ['g m3N tr refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Bm3_fe_betrO2',
          displayName: 'g/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['g m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'g_Bm3_tr_betrO2',
          displayName: 'g/m<sup>3</sup><sub>B. tr, betrO<sub>2</sub></sub>',
          synonyms: ['g m3B tr betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'µg_Nm3_fe_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Nm3_fe_bezO2',
          displayName: 'µg/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['µg m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Nm3_tr_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Nm3_tr_bezO2',
          displayName: 'µg/m<sup>3</sup><sub>N. tr, refO<sub>2</sub></sub>',
          synonyms: ['µg m3N tr refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Bm3_fe_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'µg_Bm3_tr_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>B. tr, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3B tr betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'ng_Nm3_fe_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Nm3_fe_bezO2',
          displayName: 'ng/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['ng m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Nm3_tr_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Nm3_tr_bezO2',
          displayName: 'ng/m<sup>3</sup><sub>N. tr, refO<sub>2</sub></sub>',
          synonyms: ['ng m3N tr refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Bm3_fe_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'ng_Bm3_tr_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>B. tr, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3B tr betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'ppm_m',
          displayName: 'ppm<sub>m</sub>',
          synonyms: ['ppm m'],
        },
        {
          pythonName: 'mass_percent',
          displayName: 'Gew.-%',
          synonyms: ['mass percent'],
        },
        {
          pythonName: 'g_kg',
          displayName: 'g/kg',
          synonyms: ['g kg'],
        },
        {
          pythonName: 'mg_s',
          displayName: 'mg/s',
          synonyms: ['mg s'],
        },
        {
          pythonName: 'mg_h',
          displayName: 'mg/h',
          synonyms: ['mg h'],
        },
      ],
      Area: [
        {
          pythonName: 'm2',
          displayName: 'm<sup>2</sup>',
          synonyms: ['m2 m²'],
        },
      ],
      Concentration: [
        {
          pythonName: 'mg_Nm3_fe_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Nm3_fe_bezO2',
          displayName: 'mg/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['mg m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Nm3_tr_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Nm3_tr_bezO2',
          displayName: 'mg/m<sup>3</sup><sub>N. tr, refO<sub>2</sub></sub>',
          synonyms: ['mg m3N tr refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Bm3_fe_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'mg_Bm3_tr_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>B. tr, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3B tr betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'g_Nm3_fe_betrO2',
          displayName: 'g/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['g m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Nm3_fe_bezO2',
          displayName: 'g/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['g m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Nm3_tr_betrO2',
          displayName: 'g/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['g m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Nm3_tr_bezO2',
          displayName: 'g/m<sup>3</sup><sub>N. tr, refO<sub>2</sub></sub>',
          synonyms: ['g m3N tr refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Bm3_fe_betrO2',
          displayName: 'g/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['g m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'g_Bm3_tr_betrO2',
          displayName: 'g/m<sup>3</sup><sub>B. tr, betrO<sub>2</sub></sub>',
          synonyms: ['g m3B tr betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'µg_Nm3_fe_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Nm3_fe_bezO2',
          displayName: 'µg/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['µg m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Nm3_tr_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Nm3_tr_bezO2',
          displayName: 'µg/m<sup>3</sup><sub>N. tr, refO<sub>2</sub></sub>',
          synonyms: ['µg m3N tr refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Bm3_fe_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'µg_Bm3_tr_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>B. tr, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3B tr betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'ng_Nm3_fe_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Nm3_fe_bezO2',
          displayName: 'ng/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['ng m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Nm3_tr_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Nm3_tr_bezO2',
          displayName: 'ng/m<sup>3</sup><sub>N. tr, refO<sub>2</sub></sub>',
          synonyms: ['ng m3N tr refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Bm3_fe_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'ng_Bm3_tr_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>B. tr, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3B tr betrO2 Bm3 m³B Bm³'],
        },
      ],
      Speed: [
        {
          pythonName: 'm_s',
          displayName: 'm/s',
          synonyms: ['m s'],
        },
      ],
      Pressure_Diffpressure: [
        {
          pythonName: 'Pa_abs',
          displayName: 'Pa<sub>abs.</sub>',
          synonyms: ['Pa abs'],
        },
        {
          pythonName: 'mbar_abs',
          displayName: 'mbar<sub>abs.</sub>',
          synonyms: ['mbar abs'],
        },
      ],
      aufstellungshoehe: [
        {
          pythonName: 'm',
          displayName: 'm',
          synonyms: ['m'],
        },
      ],
      Time_Days: [
        {
          pythonName: 'd',
          displayName: 'Tage',
          synonyms: ['T t d D Tage Days'],
        },
      ],
      PressureAbs: [
        {
          pythonName: 'Pa_abs',
          displayName: 'Pa<sub>abs.</sub>',
          synonyms: ['Pa abs'],
        },
        {
          pythonName: 'mbar_abs',
          displayName: 'mbar<sub>abs.</sub>',
          synonyms: ['mbar abs'],
        },
        {
          pythonName: 'atm',
          displayName: 'atm',
          synonyms: ['atm'],
        },
      ],
      ConcentrationVolumePercentDry: [
        {
          pythonName: 'vol_tr',
          displayName: 'Vol.-%<sub>tr.</sub>',
          synonyms: ['vol tr'],
        },
      ],
      Density_Solids: [
        {
          pythonName: 'kg_m3',
          displayName: 'kg/m<sup>3</sup>',
          synonyms: ['kg m3 m³ M³ M3'],
        },
      ],
      VolumeFlow: [
        {
          pythonName: 'Nm3_fe_h',
          displayName: 'm<sup>3</sup><sub>N. fe.</sub>/h',
          synonyms: ['m3N fe h Nm3 m³N Nm³'],
        },
        {
          pythonName: 'Bm3_fe_h',
          displayName: 'm<sup>3</sup><sub>B. fe.</sub>/h',
          synonyms: ['m3B fe h Bm3 m³B Bm³'],
        },
        {
          pythonName: 'Nm3_tr_h',
          displayName: 'm<sup>3</sup><sub>N. tr.</sub>/h',
          synonyms: ['m3N tr h Nm3 m³N Nm³'],
        },
        {
          pythonName: 'Bm3_tr_h',
          displayName: 'm<sup>3</sup><sub>B. tr.</sub>/h',
          synonyms: ['m3B tr h Bm3 m³B Bm³'],
        },
      ],
      schlauchlaenge: [
        {
          pythonName: 'm',
          displayName: 'm',
          synonyms: ['m'],
        },
        {
          pythonName: 'mm',
          displayName: 'mm',
          synonyms: ['mm'],
        },
      ],
      Concentration_mg: [
        {
          pythonName: 'mg_Nm3_fe_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Nm3_fe_bezO2',
          displayName: 'mg/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['mg m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Nm3_tr_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Nm3_tr_bezO2',
          displayName: 'mg/m<sup>3</sup><sub>N. tr, refO<sub>2</sub></sub>',
          synonyms: ['mg m3N tr refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'mg_Bm3_fe_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'mg_Bm3_tr_betrO2',
          displayName: 'mg/m<sup>3</sup><sub>B. tr, betrO<sub>2</sub></sub>',
          synonyms: ['mg m3B tr betrO2 Bm3 m³B Bm³'],
        },
      ],
      Power: [
        {
          pythonName: 'kW',
          displayName: 'kW',
          synonyms: ['kW'],
        },
        {
          pythonName: 'MW',
          displayName: 'MW',
          synonyms: ['MW'],
        },
      ],
      Percent: [
        {
          pythonName: 'percent',
          displayName: '%',
          synonyms: ['%'],
        },
      ],
      RotationSpeed: [
        {
          pythonName: 'u_min',
          displayName: 'U/min',
          synonyms: ['u min'],
        },
      ],
      Density: [
        {
          pythonName: 'kg_Nm3',
          displayName: 'kg/m<sup>3</sup><sub>N. </sub>',
          synonyms: ['kg m3N Nm3 m³N Nm³'],
        },
        {
          pythonName: 'kg_Bm3',
          displayName: 'kg/m<sup>3</sup><sub>B. </sub>',
          synonyms: ['kg m3B Bm3 m³B Bm³'],
        },
      ],
      Concentration_mug: [
        {
          pythonName: 'µg_Nm3_fe_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Nm3_fe_bezO2',
          displayName: 'µg/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['µg m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Nm3_tr_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Nm3_tr_bezO2',
          displayName: 'µg/m<sup>3</sup><sub>N. tr, refO<sub>2</sub></sub>',
          synonyms: ['µg m3N tr refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'µg_Bm3_fe_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'µg_Bm3_tr_betrO2',
          displayName: 'µg/m<sup>3</sup><sub>B. tr, betrO<sub>2</sub></sub>',
          synonyms: ['µg m3B tr betrO2 Bm3 m³B Bm³'],
        },
      ],
      Time: [
        {
          pythonName: 's',
          displayName: 's',
          synonyms: ['s'],
        },
        {
          pythonName: 'h',
          displayName: 'h',
          synonyms: ['h'],
        },
        {
          pythonName: 'min',
          displayName: 'm',
          synonyms: ['m'],
        },
        {
          pythonName: 'a',
          displayName: 'a',
          synonyms: ['a'],
        },
        {
          pythonName: 'd',
          displayName: 'Tage',
          synonyms: ['T t d D Tage Days'],
        },
      ],
      AdditiveUnit_kgh: [
        {
          pythonName: 'kg_h',
          displayName: 'kg/h',
          synonyms: ['kg h'],
        },
      ],
      Cost_energy: [
        {
          pythonName: 'euro_per_MWh',
          displayName: '€/MWh',
          synonyms: ['euro_per_MWh'],
        },
      ],
      Mass: [
        {
          pythonName: 'g',
          displayName: 'g',
          synonyms: ['g'],
        },
        {
          pythonName: 'mg',
          displayName: 'mg',
          synonyms: ['mg'],
        },
        {
          pythonName: 'kg',
          displayName: 'kg',
          synonyms: ['kg'],
        },
        {
          pythonName: 'µg',
          displayName: 'µg',
          synonyms: ['µg'],
        },
        {
          pythonName: 'ng',
          displayName: 'ng',
          synonyms: ['ng'],
        },
        {
          pythonName: 't',
          displayName: 't',
          synonyms: ['t'],
        },
      ],
      Energy: [
        {
          pythonName: 'kJ',
          displayName: 'kJ',
          synonyms: ['kJ'],
        },
        {
          pythonName: 'kWh',
          displayName: 'kWh',
          synonyms: ['kWh'],
        },
        {
          pythonName: 'MWh',
          displayName: 'MWh',
          synonyms: ['MWh'],
        },
      ],
      Enthalpy: [
        {
          pythonName: 'kW_kg',
          displayName: 'kW/kg',
          synonyms: ['kW kg'],
        },
      ],
      MassFlow: [
        {
          pythonName: 'kg_h',
          displayName: 'kg/h',
          synonyms: ['kg h'],
        },
        {
          pythonName: 'kg_s',
          displayName: 'kg/s',
          synonyms: ['kg s'],
        },
        {
          pythonName: 'g_h',
          displayName: 'g/h',
          synonyms: ['g h'],
        },
        {
          pythonName: 'mg_s',
          displayName: 'mg/s',
          synonyms: ['mg s'],
        },
        {
          pythonName: 'mg_h',
          displayName: 'mg/h',
          synonyms: ['mg h'],
        },
      ],
      VFlowParent: [
        {
          pythonName: 'Nm3_fe_h',
          displayName: 'm<sup>3</sup><sub>N. fe.</sub>/h',
          synonyms: ['m3N fe h Nm3 m³N Nm³'],
        },
        {
          pythonName: 'Bm3_fe_h',
          displayName: 'm<sup>3</sup><sub>B. fe.</sub>/h',
          synonyms: ['m3B fe h Bm3 m³B Bm³'],
        },
        {
          pythonName: 'Nm3_tr_h',
          displayName: 'm<sup>3</sup><sub>N. tr.</sub>/h',
          synonyms: ['m3N tr h Nm3 m³N Nm³'],
        },
        {
          pythonName: 'Bm3_tr_h',
          displayName: 'm<sup>3</sup><sub>B. tr.</sub>/h',
          synonyms: ['m3B tr h Bm3 m³B Bm³'],
        },
        {
          pythonName: 'ppm_V',
          displayName: 'ppm<sub>V</sub>',
          synonyms: ['ppm V'],
        },
        {
          pythonName: 'vol_fe',
          displayName: 'Vol.-%<sub>fe.</sub>',
          synonyms: ['vol fe'],
        },
        {
          pythonName: 'vol_tr',
          displayName: 'Vol.-%<sub>tr.</sub>',
          synonyms: ['vol tr'],
        },
      ],
      ConcentrationMass: [
        {
          pythonName: 'ppm_m',
          displayName: 'ppm<sub>m</sub>',
          synonyms: ['ppm m'],
        },
        {
          pythonName: 'g_kg',
          displayName: 'g/kg',
          synonyms: ['g kg'],
        },
      ],
      KinematicViscosity: [
        {
          pythonName: 'm2_s',
          displayName: 'm<sup>2</sup>/s',
          synonyms: ['m2 s m²'],
        },
      ],
      Conductivity: [
        {
          pythonName: 'W_mK',
          displayName: 'W/mK',
          synonyms: ['W mK'],
        },
      ],
      Pressure: [
        {
          pythonName: 'Pa_abs',
          displayName: 'Pa<sub>abs.</sub>',
          synonyms: ['Pa abs'],
        },
        {
          pythonName: 'Pa_rel',
          displayName: 'Pa<sub>rel.</sub>',
          synonyms: ['Pa rel'],
        },
        {
          pythonName: 'mbar_abs',
          displayName: 'mbar<sub>abs.</sub>',
          synonyms: ['mbar abs'],
        },
        {
          pythonName: 'mbar_rel',
          displayName: 'mbar<sub>rel.</sub>',
          synonyms: ['mbar rel'],
        },
        {
          pythonName: 'mmH2O_rel',
          displayName: 'mmH2O<sub>rel.</sub>',
          synonyms: ['mmH2O rel'],
        },
        {
          pythonName: 'atm',
          displayName: 'atm',
          synonyms: ['atm'],
        },
      ],
      SoundPressureLevel: [
        {
          pythonName: 'dB',
          displayName: 'dB',
          synonyms: ['Schalldruckpegel dB'],
        },
      ],
      Concentration_g: [
        {
          pythonName: 'g_Nm3_fe_betrO2',
          displayName: 'g/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['g m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Nm3_fe_bezO2',
          displayName: 'g/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['g m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Nm3_tr_betrO2',
          displayName: 'g/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['g m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Nm3_tr_bezO2',
          displayName: 'g/m<sup>3</sup><sub>N. tr, refO<sub>2</sub></sub>',
          synonyms: ['g m3N tr refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'g_Bm3_fe_betrO2',
          displayName: 'g/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['g m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'g_Bm3_tr_betrO2',
          displayName: 'g/m<sup>3</sup><sub>B. tr, betrO<sub>2</sub></sub>',
          synonyms: ['g m3B tr betrO2 Bm3 m³B Bm³'],
        },
      ],
      ConcentrationVolumePpm: [
        {
          pythonName: 'ppm_V',
          displayName: 'ppm<sub>V</sub>',
          synonyms: ['ppm V'],
        },
      ],
      ConcentrationVolumePercent: [
        {
          pythonName: 'vol_fe',
          displayName: 'Vol.-%<sub>fe.</sub>',
          synonyms: ['vol fe'],
        },
        {
          pythonName: 'vol_tr',
          displayName: 'Vol.-%<sub>tr.</sub>',
          synonyms: ['vol tr'],
        },
      ],
      DynamicViscosity: [
        {
          pythonName: 'Pas',
          displayName: 'Pas',
          synonyms: ['Pas'],
        },
      ],
      Length: [
        {
          pythonName: 'm',
          displayName: 'm',
          synonyms: ['m'],
        },
        {
          pythonName: 'mm',
          displayName: 'mm',
          synonyms: ['mm'],
        },
      ],
      Concentration_ng: [
        {
          pythonName: 'ng_Nm3_fe_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>N. fe, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3N fe betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Nm3_fe_bezO2',
          displayName: 'ng/m<sup>3</sup><sub>N. fe, refO<sub>2</sub></sub>',
          synonyms: ['ng m3N fe refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Nm3_tr_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>N. tr, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3N tr betrO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Nm3_tr_bezO2',
          displayName: 'ng/m<sup>3</sup><sub>N. tr, refO<sub>2</sub></sub>',
          synonyms: ['ng m3N tr refO2 Nm3 m³N Nm³'],
        },
        {
          pythonName: 'ng_Bm3_fe_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>B. fe, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3B fe betrO2 Bm3 m³B Bm³'],
        },
        {
          pythonName: 'ng_Bm3_tr_betrO2',
          displayName: 'ng/m<sup>3</sup><sub>B. tr, betrO<sub>2</sub></sub>',
          synonyms: ['ng m3B tr betrO2 Bm3 m³B Bm³'],
        },
      ],
    },
    opex_templateSearch: [
      {
        pythonName: 'DACH',
        displayName: 'DACH',
        synonyms: ['DACH'],
      },
      {
        pythonName: 'Frankreich',
        displayName: 'Frankreich',
        synonyms: ['Frankreich'],
      },
      {
        pythonName: 'BeNeLux',
        displayName: 'BeNeLux',
        synonyms: ['BeNeLux'],
      },
      {
        pythonName: 'Zentraleuropa',
        displayName: 'Zentraleuropa',
        synonyms: ['Zentraleuropa'],
      },
      {
        pythonName: 'Südeuropa',
        displayName: 'Südeuropa',
        synonyms: ['Südeuropa'],
      },
      {
        pythonName: 'Skandinavien',
        displayName: 'Skandinavien',
        synonyms: ['Skandinavien'],
      },
    ],
    opex_AdditivSearch: [
      {
        pythonName: 'Ammoniakwasser_24_5',
        displayName: 'Ammoniakwasser 24.5%',
        synonyms: ['Ammoniakwasser 24.5%'],
      },
      {
        pythonName: 'Ammoniakwasser_19',
        displayName: 'Ammoniakwasser 19%',
        synonyms: ['Ammoniakwasser 19%'],
      },
      {
        pythonName: 'SorbacalSPS',
        displayName: 'Sorbacal SPS',
        synonyms: ['Sorbacal SPS  CaOH2 Ca(OH)2'],
      },
      {
        pythonName: 'SorbacalSP',
        displayName: 'Sorbacal SP',
        synonyms: ['Sorbacal SP CaOH2 Ca(OH)2'],
      },
      {
        pythonName: 'NaHCO3',
        displayName: 'Natriumbicarbonat',
        synonyms: ['Natriumbicarbonat NaHCO3'],
      },
      {
        pythonName: 'SorbacalCDS',
        displayName: 'Sorbacal CDS',
        synonyms: ['Sorbacal CDS  CaOH2 Ca(OH)2'],
      },
      {
        pythonName: 'CaOH2',
        displayName: 'Kalkhydrat Ca(OH)2',
        synonyms: ['Kalkhydrat CaOH2 Ca(OH)2 '],
      },
      {
        pythonName: 'Aktivkohle',
        displayName: 'Aktivkohle',
        synonyms: ['Aktivkohle'],
      },
      {
        pythonName: 'Aktivkohle_bromiert',
        displayName: 'Aktivkohle (Bromiert)',
        synonyms: ['Aktivkohle Bromiert'],
      },
      {
        pythonName: 'Harnstoff_40',
        displayName: 'Harnstofflösung 40%',
        synonyms: ['Harnstofflösung 40 Urea'],
      },
    ],
    opex_EntsorgungSearch: [
      {
        pythonName: 'Staub',
        displayName: 'Staub',
        synonyms: ['Staub'],
      },
      {
        pythonName: 'Staub_Bicar',
        displayName: 'Staub (Bicarbonat)',
        synonyms: ['Staub Bicarbonat NaHCO3'],
      },
      {
        pythonName: 'Staub_Kalkhydrat',
        displayName: 'Staub (Kalkhydrat)',
        synonyms: ['Staub Kalkhydrat  CaOH2 Ca(OH)2'],
      },
    ],
    limits_templateSearch: [
      {
        pythonName: 'Vorlage 1',
        displayName: 'Vorlage 1',
        synonyms: ['Vorlage 1', 'Vorlage1'],
      },
      {
        pythonName: 'Vorlage 2',
        displayName: 'Vorlage 2',
        synonyms: ['Vorlage 2', 'Vorlage2'],
      },
      {
        pythonName: 'Vorlage 3',
        displayName: 'Vorlage 3',
        synonyms: ['Vorlage 3', 'Vorlage3'],
      },
    ],
    limits_SpeciesSearch: [
      {
        pythonName: 'NOx',
        displayName: 'NOx',
        synonyms: [
          'NOx Stickstoffmonoxid stickoxid stickstoffoxid stickstoffdioxid stickdioxid',
        ],
      },
      {
        pythonName: 'SOx',
        displayName: 'SOx',
        synonyms: ['SOx SOx'],
      },
      {
        pythonName: 'solids',
        displayName: 'Feststoffe',
        synonyms: ['Feststoffe solids Staub dust'],
      },
      {
        pythonName: 'C4H9Cl',
        displayName: 'C4H9Cl',
        synonyms: ['1-Chlorbutan C4H9Cl'],
      },
      {
        pythonName: 'C5H11Cl',
        displayName: 'C5H11Cl',
        synonyms: ['1-Chlorpentan C5H11Cl'],
      },
      {
        pythonName: 'C3H7Cl',
        displayName: 'C3H7Cl',
        synonyms: ['1-Chlorpropan C3H7Cl'],
      },
      {
        pythonName: 'C12H12',
        displayName: 'C12H12',
        synonyms: ['1-Ethylnaphthalin C12H12'],
      },
      {
        pythonName: 'C11H10',
        displayName: 'C11H10',
        synonyms: ['1-Methylnaphthalin C11H10'],
      },
      {
        pythonName: 'C2H4Cl2',
        displayName: 'C2H4Cl2',
        synonyms: ['1.1-Dichlorethan C2H4Cl2'],
      },
      {
        pythonName: 'C2H2Cl2',
        displayName: 'C2H2Cl2',
        synonyms: ['1.1-Dichlorethen C2H2Cl2'],
      },
      {
        pythonName: 'C2H3Cl3',
        displayName: 'C2H3Cl3',
        synonyms: ['1.1.1-Trichlorethan C2H3Cl3'],
      },
      {
        pythonName: 'C2H3F3',
        displayName: 'C2H3F3',
        synonyms: ['1.1.1-Trifluorethan  (R143a) C2H3F3'],
      },
      {
        pythonName: 'C3H2F4',
        displayName: 'C3H2F4',
        synonyms: ['1.1.1.2-Tetrafluorpropen (R1234yf) C3H2F4'],
      },
      {
        pythonName: 'C3H3F5',
        displayName: 'C3H3F5',
        synonyms: ['1.1.1.3.3-Pentafluorpropan (R245fa) C3H3F5'],
      },
      {
        pythonName: 'C2Cl3F3',
        displayName: 'C2Cl3F3',
        synonyms: ['1.1.2-Trichlortrifluorethan (R113) C2Cl3F3'],
      },
      {
        pythonName: 'C2Cl4F2',
        displayName: 'C2Cl4F2',
        synonyms: ['1.1.2.2-Tetrachlordifluor- ethan (R112) C2Cl4F2'],
      },
      {
        pythonName: 'C2H2Cl4',
        displayName: 'C2H2Cl4',
        synonyms: ['1.1.2.2-Tetrachlorethan C2H2Cl4'],
      },
      {
        pythonName: 'C2H4Br2',
        displayName: 'C2H4Br2',
        synonyms: ['1.2-Dibromethan C2H4Br2'],
      },
      {
        pythonName: 'C2H4Cl2_2',
        displayName: 'C2H4CL2',
        synonyms: ['1.2-Dichlorethan C2H4Cl2_2'],
      },
      {
        pythonName: 'C2Cl2F4',
        displayName: 'C2Cl2F4',
        synonyms: ['1.2-Dichlortetrafluorethan (R114) C2Cl2F4'],
      },
      {
        pythonName: 'C9H12',
        displayName: 'C9H12',
        synonyms: ['1.2.3-Trimethylbenzol C9H12'],
      },
      {
        pythonName: 'C10H14',
        displayName: 'C10H14',
        synonyms: ['1.2.3.4-Tetramethylbenzol C10H14'],
      },
      {
        pythonName: 'C10H14_2',
        displayName: 'C10H14',
        synonyms: ['1.2.3.5-Tetramethylbenzol C10H14_2'],
      },
      {
        pythonName: 'C9H12_2',
        displayName: 'C9H12',
        synonyms: ['1.2.4-Trimethylbenzol C9H12_2'],
      },
      {
        pythonName: 'C10H14_3',
        displayName: 'C10H14',
        synonyms: ['1.2.4.5-Tetramethylbenzol C10H14_3'],
      },
      {
        pythonName: 'C3H8O2',
        displayName: 'C3H8O2',
        synonyms: ['1.3-Propylenglykol C3H8O2'],
      },
      {
        pythonName: 'C9H12_3',
        displayName: 'C9H12',
        synonyms: ['1.3.5-Trimethylbenzol C9H12_3'],
      },
      {
        pythonName: 'C4H8O2',
        displayName: 'C4H8O2',
        synonyms: ['1.4-Dioxan C4H8O2'],
      },
      {
        pythonName: 'C12H12_2',
        displayName: 'C12H12',
        synonyms: ['2-Ethylnaphthalin C12H12_2'],
      },
      {
        pythonName: 'C5H12',
        displayName: 'C5H12',
        synonyms: ['2-Methylbutan C5H12'],
      },
      {
        pythonName: 'C11H10_2',
        displayName: 'C11H10',
        synonyms: ['2-Methylnaphthalin C11H10_2'],
      },
      {
        pythonName: 'C6H14',
        displayName: 'C6H14',
        synonyms: ['2-Methylpentan C6H14'],
      },
      {
        pythonName: 'C4H10',
        displayName: 'C4H10',
        synonyms: ['2-Methylpropan C4H10'],
      },
      {
        pythonName: 'C6H14_2',
        displayName: 'C6H14',
        synonyms: ['2.2-Dimethylbutan C6H14_2'],
      },
      {
        pythonName: 'C5H12_2',
        displayName: 'C5H12',
        synonyms: ['2.2-Dimethylpropan C5H12_2'],
      },
      {
        pythonName: 'C6H14_3',
        displayName: 'C6H14',
        synonyms: ['2.3-Dimethylbutan C6H14_3'],
      },
      {
        pythonName: 'C6H14_4',
        displayName: 'C6H14',
        synonyms: ['3-Methylpentan C6H14_4'],
      },
      {
        pythonName: 'C2H4O',
        displayName: 'C2H4O',
        synonyms: ['Acetaldehyd C2H4O'],
      },
      {
        pythonName: 'C3H6O',
        displayName: 'C3H6O',
        synonyms: ['Aceton C3H6O'],
      },
      {
        pythonName: 'C2H3N',
        displayName: 'C2H3N',
        synonyms: ['Acetonitril C2H3N'],
      },
      {
        pythonName: 'C8H8O',
        displayName: 'C8H8O',
        synonyms: ['Acetophenon C8H8O'],
      },
      {
        pythonName: 'C2H2',
        displayName: 'C2H2',
        synonyms: ['Acetylen C2H2'],
      },
      {
        pythonName: 'C3H3N',
        displayName: 'C3H3N',
        synonyms: ['Acrylnitril C3H3N'],
      },
      {
        pythonName: 'CH2O2',
        displayName: 'CH2O2',
        synonyms: ['Ameisensaeure CH2O2'],
      },
      {
        pythonName: 'C3H6O2',
        displayName: 'C3H6O2',
        synonyms: ['Ameisensaeureethylester C3H6O2'],
      },
      {
        pythonName: 'C2H4O2',
        displayName: 'C2H4O2',
        synonyms: ['Ameisensaeuremethylester C2H4O2'],
      },
      {
        pythonName: 'C4H8O2_2',
        displayName: 'C4H8O2',
        synonyms: ['Ameisensaeurepropylester C4H8O2_2'],
      },
      {
        pythonName: 'NH3',
        displayName: 'NH3',
        synonyms: ['Ammoniak NH3'],
      },
      {
        pythonName: 'C6H7N',
        displayName: 'C6H7N',
        synonyms: ['Anilin C6H7N'],
      },
      {
        pythonName: 'C7H6O',
        displayName: 'C7H6O',
        synonyms: ['Benzaldehyd C7H6O'],
      },
      {
        pythonName: 'C9H10O2',
        displayName: 'C9H10O2',
        synonyms: ['Benzoesaeureethylester C9H10O2'],
      },
      {
        pythonName: 'C8H8O2',
        displayName: 'C8H8O2',
        synonyms: ['Benzoesaeuremethylester C8H8O2'],
      },
      {
        pythonName: 'C6H6',
        displayName: 'C6H6',
        synonyms: ['Benzol C6H6'],
      },
      {
        pythonName: 'C7H5N',
        displayName: 'C7H5N',
        synonyms: ['Benzonitril C7H5N'],
      },
      {
        pythonName: 'C13H10O',
        displayName: 'C13H10O',
        synonyms: ['Benzophenon C13H10O'],
      },
      {
        pythonName: 'C7H8O',
        displayName: 'C7H8O',
        synonyms: ['Benzylalkohol C7H8O'],
      },
      {
        pythonName: 'C7H7Cl',
        displayName: 'C7H7Cl',
        synonyms: ['Benzylchlorid C7H7Cl'],
      },
      {
        pythonName: 'C12H10',
        displayName: 'C12H10',
        synonyms: ['Biphenyl C12H10'],
      },
      {
        pythonName: 'Br2',
        displayName: 'Br2',
        synonyms: ['Brom Br2'],
      },
      {
        pythonName: 'C6H5Br',
        displayName: 'C6H5Br',
        synonyms: ['Brombenzol C6H5Br'],
      },
      {
        pythonName: 'C2H5Br',
        displayName: 'C2H5Br',
        synonyms: ['Bromethan C2H5Br'],
      },
      {
        pythonName: 'CH3Br',
        displayName: 'CH3Br',
        synonyms: ['Brommethan CH3Br'],
      },
      {
        pythonName: 'HBr',
        displayName: 'HBr',
        synonyms: ['Bromwasserstoff HBr'],
      },
      {
        pythonName: 'C4H6',
        displayName: 'C4H6',
        synonyms: ['Butadien (1.3) C4H6'],
      },
      {
        pythonName: 'C4H6_2',
        displayName: 'C4H6',
        synonyms: ['Butadien(1.2) C4H6_2'],
      },
      {
        pythonName: 'C4H10_2',
        displayName: 'C4H10',
        synonyms: ['Butan C4H10_2'],
      },
      {
        pythonName: 'C4H10O',
        displayName: 'C4H10O',
        synonyms: ['Butanol C4H10O'],
      },
      {
        pythonName: 'C4H8',
        displayName: 'C4H8',
        synonyms: ['Buten (1) C4H8'],
      },
      {
        pythonName: 'C4H8O2_3',
        displayName: 'C4H8O2',
        synonyms: ['Buttersaeure C4H8O2_3'],
      },
      {
        pythonName: 'C6H12O2',
        displayName: 'C6H12O2',
        synonyms: ['Buttersaeureethylester C6H12O2'],
      },
      {
        pythonName: 'C5H10O2',
        displayName: 'C5H10O2',
        synonyms: ['Buttersaeuremethylester C5H10O2'],
      },
      {
        pythonName: 'C10H14_4',
        displayName: 'C10H14',
        synonyms: ['Butylbenzol C10H14_4'],
      },
      {
        pythonName: 'C10H20',
        displayName: 'C10H20',
        synonyms: ['Butylcyclohexan C10H20'],
      },
      {
        pythonName: 'C9H18',
        displayName: 'C9H18',
        synonyms: ['Butylcyclopentan C9H18'],
      },
      {
        pythonName: 'C4H7N',
        displayName: 'C4H7N',
        synonyms: ['Butyronitril C4H7N'],
      },
      {
        pythonName: 'C6H12O2_2',
        displayName: 'C6H12O2',
        synonyms: ['Capronsaeure C6H12O2_2'],
      },
      {
        pythonName: 'Cl2',
        displayName: 'Cl2',
        synonyms: ['Chlor Cl2'],
      },
      {
        pythonName: 'C6H5Cl',
        displayName: 'C6H5Cl',
        synonyms: ['Chlorbenzol C6H5Cl'],
      },
      {
        pythonName: 'CHClF2',
        displayName: 'CHClF2',
        synonyms: ['Chlordifluormethan (R22) CHClF2'],
      },
      {
        pythonName: 'C2H5Cl',
        displayName: 'C2H5Cl',
        synonyms: ['Chlorethan C2H5Cl'],
      },
      {
        pythonName: 'CH3Cl',
        displayName: 'CH3Cl',
        synonyms: ['Chlormethan CH3Cl'],
      },
      {
        pythonName: 'C2ClF3',
        displayName: 'C2ClF3',
        synonyms: ['Chlortrifluorethen C2ClF3'],
      },
      {
        pythonName: 'CClF3',
        displayName: 'CClF3',
        synonyms: ['Chlortrifluormethan (R13) CClF3'],
      },
      {
        pythonName: 'HCl',
        displayName: 'HCl',
        synonyms: ['Chlorwasserstoff HCl'],
      },
      {
        pythonName: 'ClCN',
        displayName: 'ClCN',
        synonyms: ['Cyanchlorid ClCN'],
      },
      {
        pythonName: 'HCN',
        displayName: 'HCN',
        synonyms: ['Cyanwasserstoff HCN'],
      },
      {
        pythonName: 'C4H8_2',
        displayName: 'C4H8',
        synonyms: ['Cyclobutan C4H8_2'],
      },
      {
        pythonName: 'C6H12',
        displayName: 'C6H12',
        synonyms: ['Cyclohexan C6H12'],
      },
      {
        pythonName: 'C6H12O',
        displayName: 'C6H12O',
        synonyms: ['Cyclohexanol C6H12O'],
      },
      {
        pythonName: 'C6H10',
        displayName: 'C6H10',
        synonyms: ['Cyclohexen C6H10'],
      },
      {
        pythonName: 'C5H10',
        displayName: 'C5H10',
        synonyms: ['Cyclopentan C5H10'],
      },
      {
        pythonName: 'C5H8',
        displayName: 'C5H8',
        synonyms: ['Cyclopenten C5H8'],
      },
      {
        pythonName: 'C3H6',
        displayName: 'C3H6',
        synonyms: ['Cyclopropan C3H6'],
      },
      {
        pythonName: 'C10H22',
        displayName: 'C10H22',
        synonyms: ['Decan C10H22'],
      },
      {
        pythonName: 'CH2Br2',
        displayName: 'CH2Br2',
        synonyms: ['Dibrommethan CH2Br2'],
      },
      {
        pythonName: 'CCl2F2',
        displayName: 'CCl2F2',
        synonyms: ['Dichlordifluormethan (R12) CCl2F2'],
      },
      {
        pythonName: 'C2H2Cl2O2',
        displayName: 'C2H2Cl2O2',
        synonyms: ['Dichloressigsaeure C2H2Cl2O2'],
      },
      {
        pythonName: 'CHCl2F',
        displayName: 'CHCl2F',
        synonyms: ['Dichlorfluormethan (R21) CHCl2F'],
      },
      {
        pythonName: 'CH2Cl2',
        displayName: 'CH2Cl2',
        synonyms: ['Dichlormethan CH2Cl2'],
      },
      {
        pythonName: 'C2N2',
        displayName: 'C2N2',
        synonyms: ['Dicyan C2N2'],
      },
      {
        pythonName: 'C4H11N',
        displayName: 'C4H11N',
        synonyms: ['Diethylamin C4H11N'],
      },
      {
        pythonName: 'C4H10O_2',
        displayName: 'C4H10O',
        synonyms: ['Diethylether C4H10O_2'],
      },
      {
        pythonName: 'C5H10O',
        displayName: 'C5H10O',
        synonyms: ['Diethylketon C5H10O'],
      },
      {
        pythonName: 'C4H10S',
        displayName: 'C4H10S',
        synonyms: ['Diethylsulfid C4H10S'],
      },
      {
        pythonName: 'CH2F2',
        displayName: 'CH2F2',
        synonyms: ['Difluormethan (R32) CH2F2'],
      },
      {
        pythonName: 'C4H6_3',
        displayName: 'C4H6',
        synonyms: ['Dimethylacetylen C4H6_3'],
      },
      {
        pythonName: 'C2H7N',
        displayName: 'C2H7N',
        synonyms: ['Dimethylamin C2H7N'],
      },
      {
        pythonName: 'C2H6O',
        displayName: 'C2H6O',
        synonyms: ['Dimethylether C2H6O'],
      },
      {
        pythonName: 'C2H6S',
        displayName: 'C2H6S',
        synonyms: ['Dimethylsulfid C2H6S'],
      },
      {
        pythonName: 'C12H11N',
        displayName: 'C12H11N',
        synonyms: ['Diphenylamin C12H11N'],
      },
      {
        pythonName: 'C13H12',
        displayName: 'C13H12',
        synonyms: ['Diphenylmethan C13H12'],
      },
      {
        pythonName: 'C6H14O',
        displayName: 'C6H14O',
        synonyms: ['Dipropylether C6H14O'],
      },
      {
        pythonName: 'C7H14O',
        displayName: 'C7H14O',
        synonyms: ['Dipropylketon C7H14O'],
      },
      {
        pythonName: 'N2O',
        displayName: 'N2O',
        synonyms: ['Distickstoffmonoxid N2O'],
      },
      {
        pythonName: 'N2O4',
        displayName: 'N2O4',
        synonyms: ['Distickstofftetroxid N2O4'],
      },
      {
        pythonName: 'C12H26',
        displayName: 'C12H26',
        synonyms: ['Dodekan C12H26'],
      },
      {
        pythonName: 'C20H42',
        displayName: 'C20H42',
        synonyms: ['Eicosan C20H42'],
      },
      {
        pythonName: 'C2H4O2_2',
        displayName: 'C2H4O2',
        synonyms: ['Essigsaeure C2H4O2_2'],
      },
      {
        pythonName: 'C4H6O3',
        displayName: 'C4H6O3',
        synonyms: ['Essigsaeureanhydrid C4H6O3'],
      },
      {
        pythonName: 'C4H8O2_4',
        displayName: 'C4H8O2',
        synonyms: ['Essigsaeureethylester C4H8O2_4'],
      },
      {
        pythonName: 'C3H6O2_2',
        displayName: 'C3H6O2',
        synonyms: ['Essigsaeuremethylester C3H6O2_2'],
      },
      {
        pythonName: 'C5H10O2_2',
        displayName: 'C5H10O2',
        synonyms: ['Essigsaeurepropylester C5H10O2_2'],
      },
      {
        pythonName: 'C2H6',
        displayName: 'C2H6',
        synonyms: ['Ethan C2H6'],
      },
      {
        pythonName: 'C2H6O_2',
        displayName: 'C2H6O',
        synonyms: ['Ethanol C2H6O_2'],
      },
      {
        pythonName: 'C2H4',
        displayName: 'C2H4',
        synonyms: ['Ethen (Ethylen) C2H4'],
      },
      {
        pythonName: 'C4H6_4',
        displayName: 'C4H6',
        synonyms: ['Ethylacetylen C4H6_4'],
      },
      {
        pythonName: 'C2H7N_2',
        displayName: 'C2H7N',
        synonyms: ['Ethylamin C2H7N_2'],
      },
      {
        pythonName: 'C8H10',
        displayName: 'C8H10',
        synonyms: ['Ethylbenzol C8H10'],
      },
      {
        pythonName: 'C8H16',
        displayName: 'C8H16',
        synonyms: ['Ethylcyclohexan C8H16'],
      },
      {
        pythonName: 'C7H14',
        displayName: 'C7H14',
        synonyms: ['Ethylcyclopentan C7H14'],
      },
      {
        pythonName: 'C2H6O2',
        displayName: 'C2H6O2',
        synonyms: ['Ethylenglykol C2H6O2'],
      },
      {
        pythonName: 'C2H4O_2',
        displayName: 'C2H4O',
        synonyms: ['Ethylenoxid C2H4O_2'],
      },
      {
        pythonName: 'C2H6S_2',
        displayName: 'C2H6S',
        synonyms: ['Ethylmercaptan C2H6S_2'],
      },
      {
        pythonName: 'C5H12O',
        displayName: 'C5H12O',
        synonyms: ['Ethylpropylether C5H12O'],
      },
      {
        pythonName: 'F2',
        displayName: 'F2',
        synonyms: ['Fluor F2'],
      },
      {
        pythonName: 'C6H5F',
        displayName: 'C6H5F',
        synonyms: ['Fluorbenzol C6H5F'],
      },
      {
        pythonName: 'C2H5F',
        displayName: 'C2H5F',
        synonyms: ['Fluorethan (R161) C2H5F'],
      },
      {
        pythonName: 'CH3F',
        displayName: 'CH3F',
        synonyms: ['Fluormethan (R41) CH3F'],
      },
      {
        pythonName: 'HF',
        displayName: 'HF',
        synonyms: ['Fluorwasserstoff HF'],
      },
      {
        pythonName: 'CH2O',
        displayName: 'CH2O',
        synonyms: ['Formaldehyd CH2O'],
      },
      {
        pythonName: 'CH3NO',
        displayName: 'CH3NO',
        synonyms: ['Formamid CH3NO'],
      },
      {
        pythonName: 'C4H4O',
        displayName: 'C4H4O',
        synonyms: ['Furan C4H4O'],
      },
      {
        pythonName: 'C5H4O2',
        displayName: 'C5H4O2',
        synonyms: ['Furfural C5H4O2'],
      },
      {
        pythonName: 'C3H8O3',
        displayName: 'C3H8O3',
        synonyms: ['Glyzerin C3H8O3'],
      },
      {
        pythonName: 'He',
        displayName: 'He',
        synonyms: ['Helium He'],
      },
      {
        pythonName: 'C17H36',
        displayName: 'C17H36',
        synonyms: ['Heptadecan C17H36'],
      },
      {
        pythonName: 'C7H16',
        displayName: 'C7H16',
        synonyms: ['Heptan C7H16'],
      },
      {
        pythonName: 'C7H16O',
        displayName: 'C7H16O',
        synonyms: ['Heptanol C7H16O'],
      },
      {
        pythonName: 'C7H14_2',
        displayName: 'C7H14',
        synonyms: ['Hepten (1) C7H14_2'],
      },
      {
        pythonName: 'C2Cl6',
        displayName: 'C2Cl6',
        synonyms: ['Hexachlorethan C2Cl6'],
      },
      {
        pythonName: 'C16H34',
        displayName: 'C16H34',
        synonyms: ['Hexadekan C16H34'],
      },
      {
        pythonName: 'C12H18',
        displayName: 'C12H18',
        synonyms: ['Hexamethylbenzol C12H18'],
      },
      {
        pythonName: 'C6H14_5',
        displayName: 'C6H14',
        synonyms: ['Hexan C6H14_5'],
      },
      {
        pythonName: 'C6H14O_2',
        displayName: 'C6H14O',
        synonyms: ['Hexanol C6H14O_2'],
      },
      {
        pythonName: 'C6H12_2',
        displayName: 'C6H12',
        synonyms: ['Hexen (1) C6H12_2'],
      },
      {
        pythonName: 'C12H18_2',
        displayName: 'C12H18',
        synonyms: ['Hexylbenzol C12H18_2'],
      },
      {
        pythonName: 'C12H24',
        displayName: 'C12H24',
        synonyms: ['Hexylcyclohexan C12H24'],
      },
      {
        pythonName: 'C11H22',
        displayName: 'C11H22',
        synonyms: ['Hexylcyclopentan C11H22'],
      },
      {
        pythonName: 'I2',
        displayName: 'I2',
        synonyms: ['Iod I2'],
      },
      {
        pythonName: 'C6H5I',
        displayName: 'C6H5I',
        synonyms: ['Iodbenzol C6H5I'],
      },
      {
        pythonName: 'HI',
        displayName: 'HI',
        synonyms: ['Iodwasserstoff HI'],
      },
      {
        pythonName: 'C4H10O_3',
        displayName: 'C4H10O',
        synonyms: ['Isobutanol C4H10O_3'],
      },
      {
        pythonName: 'C5H12O_2',
        displayName: 'C5H12O',
        synonyms: ['Isopentanol C5H12O_2'],
      },
      {
        pythonName: 'C3H8O',
        displayName: 'C3H8O',
        synonyms: ['Isopropanol C3H8O'],
      },
      {
        pythonName: 'C9H12_4',
        displayName: 'C9H12',
        synonyms: ['Isopropylbenzol C9H12_4'],
      },
      {
        pythonName: 'C2H2O',
        displayName: 'C2H2O',
        synonyms: ['Keten C2H2O'],
      },
      {
        pythonName: 'CO',
        displayName: 'CO',
        synonyms: ['Kohlenmonoxid CO'],
      },
      {
        pythonName: 'COS',
        displayName: 'COS',
        synonyms: ['Kohlenoxisulfid COS'],
      },
      {
        pythonName: 'C3O2',
        displayName: 'C3O2',
        synonyms: ['Kohlensuboxid C3O2'],
      },
      {
        pythonName: 'Kr',
        displayName: 'Kr',
        synonyms: ['Krypton Kr'],
      },
      {
        pythonName: 'L',
        displayName: 'L',
        synonyms: ['Luft L'],
      },
      {
        pythonName: 'CH4',
        displayName: 'CH4',
        synonyms: ['Methan CH4'],
      },
      {
        pythonName: 'CH4O',
        displayName: 'CH4O',
        synonyms: ['Methanol CH4O'],
      },
      {
        pythonName: 'C3H4',
        displayName: 'C3H4',
        synonyms: ['Methylacetylen C3H4'],
      },
      {
        pythonName: 'CH5N',
        displayName: 'CH5N',
        synonyms: ['Methylamin CH5N'],
      },
      {
        pythonName: 'C7H14_3',
        displayName: 'C7H14',
        synonyms: ['Methylcyclohexan C7H14_3'],
      },
      {
        pythonName: 'C6H12_3',
        displayName: 'C6H12',
        synonyms: ['Methylcyclopentan C6H12_3'],
      },
      {
        pythonName: 'C4H8O',
        displayName: 'C4H8O',
        synonyms: ['Methylethylketon C4H8O'],
      },
      {
        pythonName: 'CH4S',
        displayName: 'CH4S',
        synonyms: ['Methylmercaptan CH4S'],
      },
      {
        pythonName: 'C4H10O_4',
        displayName: 'C4H10O',
        synonyms: ['Methylpropylether C4H10O_4'],
      },
      {
        pythonName: 'C2H3ClO2',
        displayName: 'C2H3ClO2',
        synonyms: ['Monochloressigsaeure C2H3ClO2'],
      },
      {
        pythonName: 'C7H9N',
        displayName: 'C7H9N',
        synonyms: ['N-Methylanilin C7H9N'],
      },
      {
        pythonName: 'C10H15N',
        displayName: 'C10H15N',
        synonyms: ['N.N-Diethylanilin C10H15N'],
      },
      {
        pythonName: 'C8H11N',
        displayName: 'C8H11N',
        synonyms: ['N.N-Dimethylanilin C8H11N'],
      },
      {
        pythonName: 'C10H8',
        displayName: 'C10H8',
        synonyms: ['Naphthalin C10H8'],
      },
      {
        pythonName: 'Ne',
        displayName: 'Ne',
        synonyms: ['Neon Ne'],
      },
      {
        pythonName: 'C6H5NO2',
        displayName: 'C6H5NO2',
        synonyms: ['Nitrobenzol C6H5NO2'],
      },
      {
        pythonName: 'CH3NO2',
        displayName: 'CH3NO2',
        synonyms: ['Nitromethan CH3NO2'],
      },
      {
        pythonName: 'C19H40',
        displayName: 'C19H40',
        synonyms: ['Nonadecan C19H40'],
      },
      {
        pythonName: 'C9H20',
        displayName: 'C9H20',
        synonyms: ['Nonan C9H20'],
      },
      {
        pythonName: 'C18H38',
        displayName: 'C18H38',
        synonyms: ['Oktadekan C18H38'],
      },
      {
        pythonName: 'C8H18',
        displayName: 'C8H18',
        synonyms: ['Oktan C8H18'],
      },
      {
        pythonName: 'C8H18O',
        displayName: 'C8H18O',
        synonyms: ['Oktanol C8H18O'],
      },
      {
        pythonName: 'C8H16_2',
        displayName: 'C8H16',
        synonyms: ['Okten (1) C8H16_2'],
      },
      {
        pythonName: 'C6H12O3',
        displayName: 'C6H12O3',
        synonyms: ['Paraldehyd C6H12O3'],
      },
      {
        pythonName: 'C2HCl5',
        displayName: 'C2HCl5',
        synonyms: ['Pentachlorethan C2HCl5'],
      },
      {
        pythonName: 'C15H32',
        displayName: 'C15H32',
        synonyms: ['Pentadekan C15H32'],
      },
      {
        pythonName: 'C5H8_2',
        displayName: 'C5H8',
        synonyms: ['Pentadien (1.2) C5H8_2'],
      },
      {
        pythonName: 'C5H8_3',
        displayName: 'C5H8',
        synonyms: ['Pentadien (1.4) C5H8_3'],
      },
      {
        pythonName: 'C5H8_4',
        displayName: 'C5H8',
        synonyms: ['Pentadien (2.3) C5H8_4'],
      },
      {
        pythonName: 'C5H8_5',
        displayName: 'C5H8',
        synonyms: ['Pentadien (trans-1.3) C5H8_5'],
      },
      {
        pythonName: 'C11H16',
        displayName: 'C11H16',
        synonyms: ['Pentamethylbenzol C11H16'],
      },
      {
        pythonName: 'C5H12_3',
        displayName: 'C5H12',
        synonyms: ['Pentan C5H12_3'],
      },
      {
        pythonName: 'C5H12O_3',
        displayName: 'C5H12O',
        synonyms: ['Pentanol C5H12O_3'],
      },
      {
        pythonName: 'C5H10_2',
        displayName: 'C5H10',
        synonyms: ['Penten (1) C5H10_2'],
      },
      {
        pythonName: 'C11H16_2',
        displayName: 'C11H16',
        synonyms: ['Pentylbenzol C11H16_2'],
      },
      {
        pythonName: 'C11H22_2',
        displayName: 'C11H22',
        synonyms: ['Pentylcyclohexan C11H22_2'],
      },
      {
        pythonName: 'C10H20_2',
        displayName: 'C10H20',
        synonyms: ['Pentylcyclopentan C10H20_2'],
      },
      {
        pythonName: 'C6H6O',
        displayName: 'C6H6O',
        synonyms: ['Phenol C6H6O'],
      },
      {
        pythonName: 'C6H8N2',
        displayName: 'C6H8N2',
        synonyms: ['Phenylhydrazin C6H8N2'],
      },
      {
        pythonName: 'CCl2O',
        displayName: 'CCl2O',
        synonyms: ['Phosgen CCl2O'],
      },
      {
        pythonName: 'PCl3',
        displayName: 'PCl3',
        synonyms: ['Phosphortrichlorid PCl3'],
      },
      {
        pythonName: 'C5H11N',
        displayName: 'C5H11N',
        synonyms: ['Piperidin C5H11N'],
      },
      {
        pythonName: 'C3H4_2',
        displayName: 'C3H4',
        synonyms: ['Propadien C3H4_2'],
      },
      {
        pythonName: 'C3H8',
        displayName: 'C3H8',
        synonyms: ['Propan C3H8'],
      },
      {
        pythonName: 'C3H8O_2',
        displayName: 'C3H8O',
        synonyms: ['Propanol C3H8O_2'],
      },
      {
        pythonName: 'C3H6_2',
        displayName: 'C3H6',
        synonyms: ['Propen (Propylen) C3H6_2'],
      },
      {
        pythonName: 'C3H5N',
        displayName: 'C3H5N',
        synonyms: ['Propionitril C3H5N'],
      },
      {
        pythonName: 'C3H6O2_3',
        displayName: 'C3H6O2',
        synonyms: ['Propionsaeure C3H6O2_3'],
      },
      {
        pythonName: 'C6H12O2_3',
        displayName: 'C6H12O2',
        synonyms: ['Propionsaeure-n-propylester C6H12O2_3'],
      },
      {
        pythonName: 'C6H10O3',
        displayName: 'C6H10O3',
        synonyms: ['Propionsaeureanhydrid C6H10O3'],
      },
      {
        pythonName: 'C5H10O2_3',
        displayName: 'C5H10O2',
        synonyms: ['Propionsaeureethylester C5H10O2_3'],
      },
      {
        pythonName: 'C4H8O2_5',
        displayName: 'C4H8O2',
        synonyms: ['Propionsaeuremethylester C4H8O2_5'],
      },
      {
        pythonName: 'C9H12_5',
        displayName: 'C9H12',
        synonyms: ['Propylbenzol C9H12_5'],
      },
      {
        pythonName: 'C9H18_2',
        displayName: 'C9H18',
        synonyms: ['Propylcyclohexan C9H18_2'],
      },
      {
        pythonName: 'C8H16_3',
        displayName: 'C8H16',
        synonyms: ['Propylcyclopentan C8H16_3'],
      },
      {
        pythonName: 'C5H5N',
        displayName: 'C5H5N',
        synonyms: ['Pyridin C5H5N'],
      },
      {
        pythonName: 'C7H6O2',
        displayName: 'C7H6O2',
        synonyms: ['Salicylaldehyd C7H6O2'],
      },
      {
        pythonName: 'C8H8O3',
        displayName: 'C8H8O3',
        synonyms: ['Salicylsaeuremethylester C8H8O3'],
      },
      {
        pythonName: 'S',
        displayName: 'S',
        synonyms: ['Schwefel S'],
      },
      {
        pythonName: 'SF6',
        displayName: 'SF6',
        synonyms: ['Schwefelhexafluorid SF6'],
      },
      {
        pythonName: 'CS2',
        displayName: 'CS2',
        synonyms: ['Schwefelkohlenstoff CS2'],
      },
      {
        pythonName: 'H2S',
        displayName: 'H2S',
        synonyms: ['Schwefelwasserstoff H2S'],
      },
      {
        pythonName: 'SiH4',
        displayName: 'SiH4',
        synonyms: ['Silan SiH4'],
      },
      {
        pythonName: 'C8H8',
        displayName: 'C8H8',
        synonyms: ['Styrol C8H8'],
      },
      {
        pythonName: 'Cl2SO2',
        displayName: 'Cl2SO2',
        synonyms: ['Sulfurylchlorid Cl2SO2'],
      },
      {
        pythonName: 'CBr4',
        displayName: 'CBr4',
        synonyms: ['Tetrabrommethan CBr4'],
      },
      {
        pythonName: 'C2Cl4',
        displayName: 'C2Cl4',
        synonyms: ['Tetrachlorethen C2Cl4'],
      },
      {
        pythonName: 'CCl4',
        displayName: 'CCl4',
        synonyms: ['Tetrachlormethan CCl4'],
      },
      {
        pythonName: 'SiCl4',
        displayName: 'SiCl4',
        synonyms: ['Tetrachlorsilan SiCl4'],
      },
      {
        pythonName: 'C14H30',
        displayName: 'C14H30',
        synonyms: ['Tetradekan C14H30'],
      },
      {
        pythonName: 'CF4',
        displayName: 'CF4',
        synonyms: ['Tetrafluormethan (R14) CF4'],
      },
      {
        pythonName: 'C25H20',
        displayName: 'C25H20',
        synonyms: ['Tetraphenylmethan C25H20'],
      },
      {
        pythonName: 'C4H4S',
        displayName: 'C4H4S',
        synonyms: ['Thiophen C4H4S'],
      },
      {
        pythonName: 'C7H8',
        displayName: 'C7H8',
        synonyms: ['Toluol C7H8'],
      },
      {
        pythonName: 'CHBr3',
        displayName: 'CHBr3',
        synonyms: ['Tribrommethan CHBr3'],
      },
      {
        pythonName: 'C2HCl3O2',
        displayName: 'C2HCl3O2',
        synonyms: ['Trichloressigsaeure C2HCl3O2'],
      },
      {
        pythonName: 'C2HCl3',
        displayName: 'C2HCl3',
        synonyms: ['Trichlorethen C2HCl3'],
      },
      {
        pythonName: 'CCl3F',
        displayName: 'CCl3F',
        synonyms: ['Trichlorfluormethan (R11) CCl3F'],
      },
      {
        pythonName: 'CHCl3',
        displayName: 'CHCl3',
        synonyms: ['Trichlormethan CHCl3'],
      },
      {
        pythonName: 'C13H28',
        displayName: 'C13H28',
        synonyms: ['Tridekan C13H28'],
      },
      {
        pythonName: 'C6H15N',
        displayName: 'C6H15N',
        synonyms: ['Triethylamin C6H15N'],
      },
      {
        pythonName: 'CHF3',
        displayName: 'CHF3',
        synonyms: ['Trifluormethan (R23) CHF3'],
      },
      {
        pythonName: 'C3H9N',
        displayName: 'C3H9N',
        synonyms: ['Trimethylamin C3H9N'],
      },
      {
        pythonName: 'C19H16',
        displayName: 'C19H16',
        synonyms: ['Triphenylmethan C19H16'],
      },
      {
        pythonName: 'C11H24',
        displayName: 'C11H24',
        synonyms: ['Undecan C11H24'],
      },
      {
        pythonName: 'C5H10O2_4',
        displayName: 'C5H10O2',
        synonyms: ['Valeriansaeure C5H10O2_4'],
      },
      {
        pythonName: 'C2H3Cl',
        displayName: 'C2H3Cl',
        synonyms: ['Vinylchlorid C2H3Cl'],
      },
      {
        pythonName: 'H2',
        displayName: 'H2',
        synonyms: ['Wasserstoff H2'],
      },
      {
        pythonName: 'Xe',
        displayName: 'Xe',
        synonyms: ['Xenon Xe'],
      },
      {
        pythonName: 'C7H7Cl_2',
        displayName: 'C7H7Cl',
        synonyms: ['m-Chlortoluol C7H7Cl_2'],
      },
      {
        pythonName: 'C7H8O_2',
        displayName: 'C7H8O',
        synonyms: ['m-Kresol C7H8O_2'],
      },
      {
        pythonName: 'C7H7NO2',
        displayName: 'C7H7NO2',
        synonyms: ['m-Nitrotoluol C7H7NO2'],
      },
      {
        pythonName: 'C8H10_2',
        displayName: 'C8H10',
        synonyms: ['m-Xylol C8H10_2'],
      },
      {
        pythonName: 'C4H11N_2',
        displayName: 'C4H11N',
        synonyms: ['n-Butylamin C4H11N_2'],
      },
      {
        pythonName: 'C3H9N_2',
        displayName: 'C3H9N',
        synonyms: ['n-Propylamin C3H9N_2'],
      },
      {
        pythonName: 'C7H8O_3',
        displayName: 'C7H8O',
        synonyms: ['o-Kresol C7H8O_3'],
      },
      {
        pythonName: 'C7H7NO2_2',
        displayName: 'C7H7NO2',
        synonyms: ['o-Nitrotoluol C7H7NO2_2'],
      },
      {
        pythonName: 'C8H10_3',
        displayName: 'C8H10',
        synonyms: ['o-Xylol C8H10_3'],
      },
      {
        pythonName: 'C7H8O_4',
        displayName: 'C7H8O',
        synonyms: ['p-Kresol C7H8O_4'],
      },
      {
        pythonName: 'C7H7NO2_3',
        displayName: 'C7H7NO2',
        synonyms: ['p-Nitrotoluol C7H7NO2_3'],
      },
      {
        pythonName: 'C8H10_4',
        displayName: 'C8H10',
        synonyms: ['p-Xylol C8H10_4'],
      },
      {
        pythonName: 'H2SO4',
        displayName: 'H2SO4',
        synonyms: ['Schwefelsaeure H2SO4'],
      },
      {
        pythonName: 'H2SO3',
        displayName: 'H2SO3',
        synonyms: ['Schwefelige Saeure H2SO3'],
      },
      {
        pythonName: 'HCLO2',
        displayName: 'HCLO2',
        synonyms: ['Chlorige Saeure HCLO2'],
      },
      {
        pythonName: 'HCLO3',
        displayName: 'HCLO3',
        synonyms: ['Chlorsaeure HCLO3'],
      },
      {
        pythonName: 'HNO3',
        displayName: 'HNO3',
        synonyms: ['Salpetersaeure HNO3'],
      },
      {
        pythonName: 'HNO2',
        displayName: 'HNO2',
        synonyms: ['Salpetrige Saeure HNO2'],
      },
      {
        pythonName: 'H2CO3',
        displayName: 'H2CO3',
        synonyms: ['Kohlensaeure H2CO3'],
      },
      {
        pythonName: 'H3PO4',
        displayName: 'H3PO4',
        synonyms: ['Phosphorsaeure H3PO4'],
      },
      {
        pythonName: 'H4SiO4',
        displayName: 'H4SiO4',
        synonyms: ['Kieselsaeure H4SiO4'],
      },
      {
        pythonName: 'VOC',
        displayName: 'VOC',
        synonyms: ['Fluechtigeorganische Verbindungen VOC'],
      },
      {
        pythonName: 'PCDD_PCDF',
        displayName: 'PCDD_PCDF',
        synonyms: [
          'Polychlorierte Dibenzo-p-dioxineund Dibenzofurane PCDD_PCDF',
        ],
      },
      {
        pythonName: 'Hg',
        displayName: 'Hg',
        synonyms: ['Quecksilber Hg'],
      },
    ],
    possibleEfilter: [
      {
        pythonName: 'sef 10',
        displayName: 'sef 10',
        synonyms: ['sef 10'],
      },
      {
        pythonName: 'sef 10+10',
        displayName: 'sef 10+10',
        synonyms: ['sef 10+10'],
      },
      {
        pythonName: 'sef 10+10+10',
        displayName: 'sef 10+10+10',
        synonyms: ['sef 10+10+10'],
      },
      {
        pythonName: 'sef 12',
        displayName: 'sef 12',
        synonyms: ['sef 12'],
      },
      {
        pythonName: 'sef 12+12',
        displayName: 'sef 12+12',
        synonyms: ['sef 12+12'],
      },
      {
        pythonName: 'sef 12+12+12',
        displayName: 'sef 12+12+12',
        synonyms: ['sef 12+12+12'],
      },
      {
        pythonName: 'sef 15',
        displayName: 'sef 15',
        synonyms: ['sef 15'],
      },
      {
        pythonName: 'sef 15+15',
        displayName: 'sef 15+15',
        synonyms: ['sef 15+15'],
      },
      {
        pythonName: 'sef 15+15+15',
        displayName: 'sef 15+15+15',
        synonyms: ['sef 15+15+15'],
      },
      {
        pythonName: 'sef 17',
        displayName: 'sef 17',
        synonyms: ['sef 17'],
      },
      {
        pythonName: 'sef 17+17',
        displayName: 'sef 17+17',
        synonyms: ['sef 17+17'],
      },
      {
        pythonName: 'sef 17+17+17',
        displayName: 'sef 17+17+17',
        synonyms: ['sef 17+17+17'],
      },
      {
        pythonName: 'sef 21',
        displayName: 'sef 21',
        synonyms: ['sef 21'],
      },
      {
        pythonName: 'sef 21+21',
        displayName: 'sef 21+21',
        synonyms: ['sef 21+21'],
      },
      {
        pythonName: 'sef 21+21+21',
        displayName: 'sef 21+21+21',
        synonyms: ['sef 21+21+21'],
      },
      {
        pythonName: 'sef 24',
        displayName: 'sef 24',
        synonyms: ['sef 24'],
      },
      {
        pythonName: 'sef 24+24',
        displayName: 'sef 24+24',
        synonyms: ['sef 24+24'],
      },
      {
        pythonName: 'sef 24+24+24',
        displayName: 'sef 24+24+24',
        synonyms: ['sef 24+24+24'],
      },
      {
        pythonName: 'sef 27',
        displayName: 'sef 27',
        synonyms: ['sef 27'],
      },
      {
        pythonName: 'sef 27+27',
        displayName: 'sef 27+27',
        synonyms: ['sef 27+27'],
      },
      {
        pythonName: 'sef 27+27+27',
        displayName: 'sef 27+27+27',
        synonyms: ['sef 27+27+27'],
      },
      {
        pythonName: 'sef 32',
        displayName: 'sef 32',
        synonyms: ['sef 32'],
      },
      {
        pythonName: 'sef 32+32',
        displayName: 'sef 32+32',
        synonyms: ['sef 32+32'],
      },
      {
        pythonName: 'sef 32+32+32',
        displayName: 'sef 32+32+32',
        synonyms: ['sef 32+32+32'],
      },
      {
        pythonName: 'sef 38',
        displayName: 'sef 38',
        synonyms: ['sef 38'],
      },
      {
        pythonName: 'sef 38+38',
        displayName: 'sef 38+38',
        synonyms: ['sef 38+38'],
      },
      {
        pythonName: 'sef 38+38+38',
        displayName: 'sef 38+38+38',
        synonyms: ['sef 38+38+38'],
      },
      {
        pythonName: 'sef 43',
        displayName: 'sef 43',
        synonyms: ['sef 43'],
      },
      {
        pythonName: 'sef 43+43',
        displayName: 'sef 43+43',
        synonyms: ['sef 43+43'],
      },
      {
        pythonName: 'sef 43+43+43',
        displayName: 'sef 43+43+43',
        synonyms: ['sef 43+43+43'],
      },
      {
        pythonName: 'sef 48',
        displayName: 'sef 48',
        synonyms: ['sef 48'],
      },
      {
        pythonName: 'sef 48+48',
        displayName: 'sef 48+48',
        synonyms: ['sef 48+48'],
      },
      {
        pythonName: 'sef 48+48+48',
        displayName: 'sef 48+48+48',
        synonyms: ['sef 48+48+48'],
      },
      {
        pythonName: 'sef 54',
        displayName: 'sef 54',
        synonyms: ['sef 54'],
      },
      {
        pythonName: 'sef 54+54',
        displayName: 'sef 54+54',
        synonyms: ['sef 54+54'],
      },
      {
        pythonName: 'sef 54+54+54',
        displayName: 'sef 54+54+54',
        synonyms: ['sef 54+54+54'],
      },
      {
        pythonName: 'sef 59',
        displayName: 'sef 59',
        synonyms: ['sef 59'],
      },
      {
        pythonName: 'sef 59+59',
        displayName: 'sef 59+59',
        synonyms: ['sef 59+59'],
      },
      {
        pythonName: 'sef 59+59+59',
        displayName: 'sef 59+59+59',
        synonyms: ['sef 59+59+59'],
      },
      {
        pythonName: 'sef 66',
        displayName: 'sef 66',
        synonyms: ['sef 66'],
      },
      {
        pythonName: 'sef 66+66',
        displayName: 'sef 66+66',
        synonyms: ['sef 66+66'],
      },
      {
        pythonName: 'sef 66+66+66',
        displayName: 'sef 66+66+66',
        synonyms: ['sef 66+66+66'],
      },
      {
        pythonName: 'sef 75',
        displayName: 'sef 75',
        synonyms: ['sef 75'],
      },
      {
        pythonName: 'sef 75+75',
        displayName: 'sef 75+75',
        synonyms: ['sef 75+75'],
      },
      {
        pythonName: 'sef 75+75+75',
        displayName: 'sef 75+75+75',
        synonyms: ['sef 75+75+75'],
      },
      {
        pythonName: 'sef 83',
        displayName: 'sef 83',
        synonyms: ['sef 83'],
      },
      {
        pythonName: 'sef 83+83',
        displayName: 'sef 83+83',
        synonyms: ['sef 83+83'],
      },
      {
        pythonName: 'sef 83+83+83',
        displayName: 'sef 83+83+83',
        synonyms: ['sef 83+83+83'],
      },
      {
        pythonName: 'sef 91',
        displayName: 'sef 91',
        synonyms: ['sef 91'],
      },
      {
        pythonName: 'sef 91+91',
        displayName: 'sef 91+91',
        synonyms: ['sef 91+91'],
      },
      {
        pythonName: 'sef 91+91+91',
        displayName: 'sef 91+91+91',
        synonyms: ['sef 91+91+91'],
      },
      {
        pythonName: 'sef 97',
        displayName: 'sef 97',
        synonyms: ['sef 97'],
      },
      {
        pythonName: 'sef 97+97',
        displayName: 'sef 97+97',
        synonyms: ['sef 97+97'],
      },
      {
        pythonName: 'sef 97+97+97',
        displayName: 'sef 97+97+97',
        synonyms: ['sef 97+97+97'],
      },
      {
        pythonName: 'sef 108',
        displayName: 'sef 108',
        synonyms: ['sef 108'],
      },
      {
        pythonName: 'sef 108+108',
        displayName: 'sef 108+108',
        synonyms: ['sef 108+108'],
      },
      {
        pythonName: 'sef 108+108+108',
        displayName: 'sef 108+108+108',
        synonyms: ['sef 108+108+108'],
      },
      {
        pythonName: 'sef 119',
        displayName: 'sef 119',
        synonyms: ['sef 119'],
      },
      {
        pythonName: 'sef 119+119',
        displayName: 'sef 119+119',
        synonyms: ['sef 119+119'],
      },
      {
        pythonName: 'sef 119+119+119',
        displayName: 'sef 119+119+119',
        synonyms: ['sef 119+119+119'],
      },
      {
        pythonName: 'sef 135',
        displayName: 'sef 135',
        synonyms: ['sef 135'],
      },
      {
        pythonName: 'sef 135+135',
        displayName: 'sef 135+135',
        synonyms: ['sef 135+135'],
      },
      {
        pythonName: 'sef 135+135+135',
        displayName: 'sef 135+135+135',
        synonyms: ['sef 135+135+135'],
      },
      {
        pythonName: 'sef 152',
        displayName: 'sef 152',
        synonyms: ['sef 152'],
      },
      {
        pythonName: 'sef 152+152',
        displayName: 'sef 152+152',
        synonyms: ['sef 152+152'],
      },
      {
        pythonName: 'sef 152+152+152',
        displayName: 'sef 152+152+152',
        synonyms: ['sef 152+152+152'],
      },
      {
        pythonName: 'sef 168',
        displayName: 'sef 168',
        synonyms: ['sef 168'],
      },
      {
        pythonName: 'sef 168+168',
        displayName: 'sef 168+168',
        synonyms: ['sef 168+168'],
      },
      {
        pythonName: 'sef 168+168+168',
        displayName: 'sef 168+168+168',
        synonyms: ['sef 168+168+168'],
      },
      {
        pythonName: 'sef 185',
        displayName: 'sef 185',
        synonyms: ['sef 185'],
      },
      {
        pythonName: 'sef 185+185',
        displayName: 'sef 185+185',
        synonyms: ['sef 185+185'],
      },
      {
        pythonName: 'sef 185+185+185',
        displayName: 'sef 185+185+185',
        synonyms: ['sef 185+185+185'],
      },
      {
        pythonName: 'sef 4,6/8,0-07',
        displayName: 'sef 4,6/8,0-07',
        synonyms: ['sef 4,6/8,0-07'],
      },
      {
        pythonName: 'sef 5,4/7,0-08',
        displayName: 'sef 5,4/7,0-08',
        synonyms: ['sef 5,4/7,0-08'],
      },
      {
        pythonName: 'sef 5,4/8,0-08',
        displayName: 'sef 5,4/8,0-08',
        synonyms: ['sef 5,4/8,0-08'],
      },
      {
        pythonName: 'sef 5,4/5,0x2-08',
        displayName: 'sef 5,4/5,0x2-08',
        synonyms: ['sef 5,4/5,0x2-08'],
      },
      {
        pythonName: 'sef 5,4/5,0x2-09',
        displayName: 'sef 5,4/5,0x2-09',
        synonyms: ['sef 5,4/5,0x2-09'],
      },
      {
        pythonName: 'sef 5,4/6,0x2-08',
        displayName: 'sef 5,4/6,0x2-08',
        synonyms: ['sef 5,4/6,0x2-08'],
      },
      {
        pythonName: 'sef 5,4/6,0x2-09',
        displayName: 'sef 5,4/6,0x2-09',
        synonyms: ['sef 5,4/6,0x2-09'],
      },
      {
        pythonName: 'sef 6,6/6,0x2-08',
        displayName: 'sef 6,6/6,0x2-08',
        synonyms: ['sef 6,6/6,0x2-08'],
      },
      {
        pythonName: 'sef 6,6/6,0x2-09',
        displayName: 'sef 6,6/6,0x2-09',
        synonyms: ['sef 6,6/6,0x2-09'],
      },
      {
        pythonName: 'sef 6,6/6,0x2-10',
        displayName: 'sef 6,6/6,0x2-10',
        synonyms: ['sef 6,6/6,0x2-10'],
      },
      {
        pythonName: 'sef 8,2/6,0x2-09',
        displayName: 'sef 8,2/6,0x2-09',
        synonyms: ['sef 8,2/6,0x2-09'],
      },
      {
        pythonName: 'sef 8,2/6,0x2-10',
        displayName: 'sef 8,2/6,0x2-10',
        synonyms: ['sef 8,2/6,0x2-10'],
      },
      {
        pythonName: 'sef 6,6/6,0x3-09',
        displayName: 'sef 6,6/6,0x3-09',
        synonyms: ['sef 6,6/6,0x3-09'],
      },
      {
        pythonName: 'sef 6,6/6,0x3-10',
        displayName: 'sef 6,6/6,0x3-10',
        synonyms: ['sef 6,6/6,0x3-10'],
      },
      {
        pythonName: 'sef 8,2/6,0x3-09',
        displayName: 'sef 8,2/6,0x3-09',
        synonyms: ['sef 8,2/6,0x3-09'],
      },
      {
        pythonName: 'sef 8,2/6,0x3-10',
        displayName: 'sef 8,2/6,0x3-10',
        synonyms: ['sef 8,2/6,0x3-10'],
      },
      {
        pythonName: 'sef 12,0/5,6x2-11',
        displayName: 'sef 12,0/5,6x2-11',
        synonyms: ['sef 12,0/5,6x2-11'],
      },
      {
        pythonName: 'sef 10,0/5,6x3-10',
        displayName: 'sef 10,0/5,6x3-10',
        synonyms: ['sef 10,0/5,6x3-10'],
      },
      {
        pythonName: 'sef 10,0/5,6x3-11',
        displayName: 'sef 10,0/5,6x3-11',
        synonyms: ['sef 10,0/5,6x3-11'],
      },
      {
        pythonName: 'sef 10,0/5,6x3-12',
        displayName: 'sef 10,0/5,6x3-12',
        synonyms: ['sef 10,0/5,6x3-12'],
      },
      {
        pythonName: 'sef 12,0/5,6x3-11',
        displayName: 'sef 12,0/5,6x3-11',
        synonyms: ['sef 12,0/5,6x3-11'],
      },
      {
        pythonName: 'sef 12,0/5,6x3-12',
        displayName: 'sef 12,0/5,6x3-12',
        synonyms: ['sef 12,0/5,6x3-12'],
      },
    ],
    possibleOldEfilter: [
      {
        pythonName: 'sef 4,6/8,0-07',
        displayName: 'sef 4,6/8,0-07',
        synonyms: ['sef 4,6/8,0-07'],
      },
      {
        pythonName: 'sef 5,4/7,0-08',
        displayName: 'sef 5,4/7,0-08',
        synonyms: ['sef 5,4/7,0-08'],
      },
      {
        pythonName: 'sef 5,4/8,0-08',
        displayName: 'sef 5,4/8,0-08',
        synonyms: ['sef 5,4/8,0-08'],
      },
      {
        pythonName: 'sef 5,4/5,0x2-08',
        displayName: 'sef 5,4/5,0x2-08',
        synonyms: ['sef 5,4/5,0x2-08'],
      },
      {
        pythonName: 'sef 5,4/5,0x2-09',
        displayName: 'sef 5,4/5,0x2-09',
        synonyms: ['sef 5,4/5,0x2-09'],
      },
      {
        pythonName: 'sef 5,4/6,0x2-08',
        displayName: 'sef 5,4/6,0x2-08',
        synonyms: ['sef 5,4/6,0x2-08'],
      },
      {
        pythonName: 'sef 5,4/6,0x2-09',
        displayName: 'sef 5,4/6,0x2-09',
        synonyms: ['sef 5,4/6,0x2-09'],
      },
      {
        pythonName: 'sef 6,6/6,0x2-08',
        displayName: 'sef 6,6/6,0x2-08',
        synonyms: ['sef 6,6/6,0x2-08'],
      },
      {
        pythonName: 'sef 6,6/6,0x2-09',
        displayName: 'sef 6,6/6,0x2-09',
        synonyms: ['sef 6,6/6,0x2-09'],
      },
      {
        pythonName: 'sef 6,6/6,0x2-10',
        displayName: 'sef 6,6/6,0x2-10',
        synonyms: ['sef 6,6/6,0x2-10'],
      },
      {
        pythonName: 'sef 8,2/6,0x2-09',
        displayName: 'sef 8,2/6,0x2-09',
        synonyms: ['sef 8,2/6,0x2-09'],
      },
      {
        pythonName: 'sef 8,2/6,0x2-10',
        displayName: 'sef 8,2/6,0x2-10',
        synonyms: ['sef 8,2/6,0x2-10'],
      },
      {
        pythonName: 'sef 6,6/6,0x3-09',
        displayName: 'sef 6,6/6,0x3-09',
        synonyms: ['sef 6,6/6,0x3-09'],
      },
      {
        pythonName: 'sef 6,6/6,0x3-10',
        displayName: 'sef 6,6/6,0x3-10',
        synonyms: ['sef 6,6/6,0x3-10'],
      },
      {
        pythonName: 'sef 8,2/6,0x3-09',
        displayName: 'sef 8,2/6,0x3-09',
        synonyms: ['sef 8,2/6,0x3-09'],
      },
      {
        pythonName: 'sef 8,2/6,0x3-10',
        displayName: 'sef 8,2/6,0x3-10',
        synonyms: ['sef 8,2/6,0x3-10'],
      },
      {
        pythonName: 'sef 12,0/5,6x2-11',
        displayName: 'sef 12,0/5,6x2-11',
        synonyms: ['sef 12,0/5,6x2-11'],
      },
      {
        pythonName: 'sef 10,0/5,6x3-10',
        displayName: 'sef 10,0/5,6x3-10',
        synonyms: ['sef 10,0/5,6x3-10'],
      },
      {
        pythonName: 'sef 10,0/5,6x3-11',
        displayName: 'sef 10,0/5,6x3-11',
        synonyms: ['sef 10,0/5,6x3-11'],
      },
      {
        pythonName: 'sef 10,0/5,6x3-12',
        displayName: 'sef 10,0/5,6x3-12',
        synonyms: ['sef 10,0/5,6x3-12'],
      },
      {
        pythonName: 'sef 12,0/5,6x3-11',
        displayName: 'sef 12,0/5,6x3-11',
        synonyms: ['sef 12,0/5,6x3-11'],
      },
      {
        pythonName: 'sef 12,0/5,6x3-12',
        displayName: 'sef 12,0/5,6x3-12',
        synonyms: ['sef 12,0/5,6x3-12'],
      },
    ],
    possibleNewEfilter: [
      {
        pythonName: 'sef 10',
        displayName: 'sef 10',
        synonyms: ['sef 10'],
      },
      {
        pythonName: 'sef 12',
        displayName: 'sef 12',
        synonyms: ['sef 12'],
      },
      {
        pythonName: 'sef 15',
        displayName: 'sef 15',
        synonyms: ['sef 15'],
      },
      {
        pythonName: 'sef 17',
        displayName: 'sef 17',
        synonyms: ['sef 17'],
      },
      {
        pythonName: 'sef 21',
        displayName: 'sef 21',
        synonyms: ['sef 21'],
      },
      {
        pythonName: 'sef 24',
        displayName: 'sef 24',
        synonyms: ['sef 24'],
      },
      {
        pythonName: 'sef 27',
        displayName: 'sef 27',
        synonyms: ['sef 27'],
      },
      {
        pythonName: 'sef 32',
        displayName: 'sef 32',
        synonyms: ['sef 32'],
      },
      {
        pythonName: 'sef 38',
        displayName: 'sef 38',
        synonyms: ['sef 38'],
      },
      {
        pythonName: 'sef 43',
        displayName: 'sef 43',
        synonyms: ['sef 43'],
      },
      {
        pythonName: 'sef 48',
        displayName: 'sef 48',
        synonyms: ['sef 48'],
      },
      {
        pythonName: 'sef 54',
        displayName: 'sef 54',
        synonyms: ['sef 54'],
      },
      {
        pythonName: 'sef 59',
        displayName: 'sef 59',
        synonyms: ['sef 59'],
      },
      {
        pythonName: 'sef 66',
        displayName: 'sef 66',
        synonyms: ['sef 66'],
      },
      {
        pythonName: 'sef 75',
        displayName: 'sef 75',
        synonyms: ['sef 75'],
      },
      {
        pythonName: 'sef 83',
        displayName: 'sef 83',
        synonyms: ['sef 83'],
      },
      {
        pythonName: 'sef 91',
        displayName: 'sef 91',
        synonyms: ['sef 91'],
      },
      {
        pythonName: 'sef 97',
        displayName: 'sef 97',
        synonyms: ['sef 97'],
      },
      {
        pythonName: 'sef 108',
        displayName: 'sef 108',
        synonyms: ['sef 108'],
      },
      {
        pythonName: 'sef 119',
        displayName: 'sef 119',
        synonyms: ['sef 119'],
      },
      {
        pythonName: 'sef 135',
        displayName: 'sef 135',
        synonyms: ['sef 135'],
      },
      {
        pythonName: 'sef 152',
        displayName: 'sef 152',
        synonyms: ['sef 152'],
      },
      {
        pythonName: 'sef 168',
        displayName: 'sef 168',
        synonyms: ['sef 168'],
      },
      {
        pythonName: 'sef 185',
        displayName: 'sef 185',
        synonyms: ['sef 185'],
      },
    ],
    uit400_Data: [
      {
        pythonName: 'uit400_data1',
        displayName: 'Data1',
        synonyms: ['1 eins Eins'],
      },
      {
        pythonName: 'uit400_data2',
        displayName: 'Data2',
        synonyms: ['2 zwei Zwei'],
      },
      {
        pythonName: 'uit400_data3',
        displayName: 'Data3',
        synonyms: ['3 drei Drei'],
      },
    ],
  },
  'uit300_List.json': {
    items: [
      {
        name: 'uit300_List',
        type: 'TITLE',
      },
      {
        name: 'EINS',
        type: 'LIST',
        initItemCount: 2,
        maxItemCount: 4,
        listItems: [
          {
            name: 'EINS_numberInput',
            type: 'INPUT',
            inputType: 'number',
            default: 5.5,
          },
        ],
      },
      {
        name: 'ZWEI',
        type: 'LIST',
        initItemCount: 0,
        maxItemCount: 3,
        listItems: [
          {
            name: 'ZWEI_numberInputFirst',
            type: 'INPUT',
            inputType: 'number',
            default: 12.5,
          },
          {
            name: 'ZWEI_numberInputSecond',
            type: 'INPUT',
            inputType: 'number',
            default: 4923.0,
          },
        ],
      },
      {
        name: 'DREI',
        type: 'LIST',
        initItemCount: 0,
        maxItemCount: 3,
        listItems: [
          {
            name: 'DREI_searchInputSpecies',
            type: 'INPUT',
            inputType: 'search',
            data: ['speciesSearch'],
          },
          {
            name: 'DREI_numberInputConcentration',
            type: 'INPUT',
            inputType: 'number',
            units: [
              'Concentration',
              'ConcentrationVolumePpm',
              'ConcentrationMass',
            ],
          },
        ],
      },
      {
        name: 'VIER',
        type: 'LIST',
        initItemCount: 0,
        maxItemCount: 3,
        listItems: [
          {
            name: 'VIER_mandatoryInput',
            type: 'INPUT',
            inputType: 'number',
          },
          {
            name: 'VIER_optionalInput',
            type: 'INPUT',
            inputType: 'number',
            importance: 'optional',
          },
        ],
      },
    ],
  },
  'uit200_RadioGroup.json': {
    items: [
      {
        name: '200_RadioGroup',
        type: 'TITLE',
      },
      {
        name: 'EINS',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'A',
            items: [
              {
                name: 'eins_A_Input1',
                type: 'INPUT',
                inputType: 'text',
              },
            ],
          },
          {
            name: 'B',
          },
          {
            name: 'C',
            checked: true,
            items: [
              {
                name: 'eins_C_Input1',
                type: 'INPUT',
                inputType: 'number',
                units: ['Time'],
              },
            ],
          },
        ],
      },
      {
        name: 'ZWEI',
        type: 'RADIO_GROUP',
        disabled: true,
        radioItems: [
          {
            name: 'A2',
            items: [
              {
                name: 'ZWEI_A2_Input1',
                type: 'INPUT',
                inputType: 'number',
                default: 14.1,
                units: ['Time'],
              },
            ],
          },
          {
            name: 'B2',
            checked: true,
            items: [
              {
                name: 'ZWEI_B2_Input1',
                type: 'INPUT',
                inputType: 'number',
                default: 8.31,
                defaultUnit: 'min',
                units: ['Time'],
              },
              {
                name: 'ZWEI_B2_Input2',
                type: 'INPUT',
                inputType: 'number',
                default: 4.11,
              },
            ],
          },
        ],
      },
      {
        name: 'DREI',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'A3',
          },
          {
            name: 'B3',
            checked: true,
          },
          {
            name: 'C3',
            disabled: true,
          },
        ],
      },
    ],
  },
  'uit000_basicSolutions.json': {
    items: [
      {
        name: 'MyTitle',
        type: 'TITLE',
      },
      {
        name: 'myInput',
        type: 'INPUT',
        inputType: 'number',
        default: 3,
        disabled: true,
      },
    ],
  },
  'heatSource.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M37.2178 7.17004C36.6213 7.17004 36.1378 7.65358 36.1378 8.25004V73.25C36.1378 73.8465 36.6213 74.33 37.2178 74.33H91.2178C91.8142 74.33 92.2978 73.8465 92.2978 73.25V8.25004C92.2978 7.65358 91.8142 7.17004 91.2178 7.17004H37.2178Z" fill="#0095DB"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M29.9678 2.25C29.9678 1.55964 30.5274 1 31.2178 1H85.2178C85.9081 1 86.4678 1.55964 86.4678 2.25V67.25C86.4678 67.9404 85.9081 68.5 85.2178 68.5H31.2178C30.5274 68.5 29.9678 67.9404 29.9678 67.25V2.25ZM32.4678 3.5V66H83.9678V3.5H32.4678Z" fill="#0095DB"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M46.2178 24C46.9081 24 47.4678 24.5596 47.4678 25.25L47.4678 81.7696C47.4678 81.7699 47.4678 81.77 46.2178 81.77C44.9678 81.77 44.9678 81.7699 44.9678 81.7696L44.9678 25.25C44.9678 24.5596 45.5274 24 46.2178 24ZM46.2178 83.02C45.5274 83.02 44.9678 82.46 44.9678 81.7696L46.2178 81.77L47.4678 81.7696C47.4678 82.46 46.9081 83.02 46.2178 83.02Z" fill="#00569D"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M70.2178 24C70.9081 24 71.4678 24.5596 71.4678 25.25L71.4678 81.77C71.4678 82.4604 70.9081 83.02 70.2178 83.02C69.5274 83.02 68.9678 82.4604 68.9678 81.77L68.9678 25.25C68.9678 24.5596 69.5274 24 70.2178 24Z" fill="#FF6128"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M70.9986 24.274C71.5377 24.7052 71.6251 25.4918 71.1938 26.0309L65.1938 33.5309C64.9566 33.8274 64.5975 34 64.2177 34C63.838 34 63.4789 33.8274 63.2416 33.5309L58.2177 27.251L53.1938 33.5309C52.9566 33.8274 52.5975 34 52.2177 34C51.838 34 51.4789 33.8274 51.2416 33.5309L45.2416 26.0309C44.8104 25.4918 44.8978 24.7052 45.4369 24.274C45.9759 23.8427 46.7626 23.9301 47.1938 24.4692L52.2177 30.7491L57.2416 24.4692C57.4789 24.1727 57.838 24 58.2177 24C58.5975 24 58.9566 24.1727 59.1938 24.4692L64.2177 30.7491L69.2416 24.4692C69.6729 23.9301 70.4595 23.8427 70.9986 24.274Z" fill="#0095DB"/>\n</svg>\n',
  'uit202_ListinRadio.json': {
    items: [
      {
        name: '202_ListinRadio',
        type: 'TITLE',
      },
      {
        name: 'EINS',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'A',
            items: [
              {
                name: 'eins_Radio_A_list',
                type: 'LIST',
                initItemCount: 0,
                maxItemCount: 9,
                listItems: [
                  {
                    name: 'eins_Radio_A_list_Input1',
                    type: 'INPUT',
                    inputType: 'text',
                  },
                ],
              },
            ],
          },
          {
            name: 'B',
            items: [
              {
                name: 'eins_Radio_B_list',
                type: 'LIST',
                initItemCount: 1,
                maxItemCount: 3,
                listItems: [
                  {
                    name: 'eins_Radio_B_list_Input1',
                    type: 'INPUT',
                    inputType: 'text',
                  },
                  {
                    name: 'eins_Radio_B_list_Input2',
                    type: 'INPUT',
                    inputType: 'number',
                    units: ['ConcentrationVolumePercentDry'],
                  },
                ],
              },
            ],
          },
          {
            name: 'C',
            checked: true,
            items: [
              {
                name: 'eins_Radio_C_Input',
                type: 'INPUT',
                inputType: 'number',
                units: ['Conductivity'],
              },
            ],
          },
        ],
      },
    ],
  },
  'uit202_ListinRadio.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'uit001_nestedSolutions.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="58" y="50" fill="red">001</text>\n</svg>\n',
  'scr.svg':
    '<svg width="123" height="86" viewBox="0 0 123 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path opacity="0.2" d="M106.33 85.9995H50.9838C50.2771 85.9995 49.7066 85.429 49.7066 84.7222V37.8821L40.766 46.448V84.7137C40.766 85.4204 40.1955 85.9909 39.4888 85.9909H20.3304C19.6236 85.9909 19.0531 85.4204 19.0531 84.7137V25.544C19.0531 25.1864 19.1979 24.8458 19.4618 24.6074L38.3733 7.15197C38.6969 6.85395 39.1397 6.74325 39.5654 6.85395L106.662 24.3094C107.224 24.4541 107.616 24.965 107.616 25.544V84.7222C107.616 85.429 107.046 85.9995 106.339 85.9995H106.33Z" fill="#0094DA"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M102.073 79.1876H46.7264C46.0196 79.1876 45.4491 78.6171 45.4491 77.9103V31.0702L36.5086 39.6361V77.9018C36.5086 78.6086 35.9381 79.179 35.2313 79.179H16.0729C15.3662 79.179 14.7957 78.6086 14.7957 77.9018V18.7321C14.7957 18.3745 14.9405 18.0339 15.2044 17.7955L34.1159 0.340078C34.4395 0.042058 34.8822 -0.068635 35.308 0.042058L102.405 17.4975C102.967 17.6422 103.359 18.1531 103.359 18.7321V77.9103C103.359 78.6171 102.788 79.1876 102.081 79.1876H102.073ZM47.7652 76.565L100.557 76.9056L100.597 70.6727H47.7949L47.7567 76.565H47.7652ZM47.8778 57.9005H100.68L100.729 50.2371H47.9276L47.8778 57.9005ZM48.0105 37.4648L48.0717 28.0304C48.0802 27.3236 47.4927 26.7446 46.786 26.7446C46.4539 26.7446 46.1389 26.8638 45.9004 27.0937L34.3543 38.0183C34.0989 38.2567 33.9541 38.5888 33.9541 38.9379L33.7157 76.4713L17.1117 76.3606L17.4779 19.0217L35.5719 2.53691L100.923 19.9923L100.811 37.4648H48.0105Z" fill="#0094DA"/>\n</svg>\n',
  'heatSource.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        type: 'SUBTITLE',
        name: 'targetValues',
      },
      {
        name: 'airToAirHeatExchanger',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'heatSourceLabel',
            checked: true,
            items: [
              {
                name: 'heatSource',
                type: 'INPUT',
                inputType: 'number',
                units: ['Power'],
                groupUserInputs: 'target',
              },
            ],
          },
          {
            name: 'ToutLabel',
            items: [
              {
                name: 'Tout',
                type: 'INPUT',
                inputType: 'number',
                units: ['Temperature'],
                groupUserInputs: 'target',
              },
            ],
          },
        ],
      },
      {
        configFile: 'componentGlobalSettings.json',
      },
    ],
  },
  'eco.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'Wasserseite_Subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'WasserTemperatur_Eintritt_label',
        type: 'INPUT',
        inputType: 'number',
        units: ['Temperature'],
      },
      {
        name: 'WasserVolumenstrom_label',
        type: 'INPUT',
        inputType: 'number',
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'preSelectionSubtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'Rohrmaterial_label',
        type: 'INPUT',
        inputType: 'select',
        options: ['RohrMaterial_liste'],
      },
      {
        name: 'productSelectionRadio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'noSelection',
            checked: true,
          },
          {
            name: 'productKey',
            items: [
              {
                name: 'ECO_TypLabel',
                type: 'INPUT',
                inputType: 'select',
                options: ['ECO_TypListe'],
              },
            ],
          },
          {
            name: 'manualSelection',
            items: [
              {
                name: 'Rohrlaenge',
                type: 'INPUT',
                inputType: 'number',
                units: ['aufstellungshoehe'],
                defaultUnit: 'm',
              },
              {
                name: 'Rohre_nebeneinander',
                type: 'INPUT',
                inputType: 'number',
              },
              {
                name: 'Rohre_pro_Buendel',
                type: 'INPUT',
                inputType: 'number',
              },
              {
                name: 'Buendelanzahl',
                type: 'INPUT',
                inputType: 'number',
              },
              {
                name: 'Wege_pro_Buendel',
                type: 'INPUT',
                inputType: 'number',
              },
              {
                name: 'd_außen',
                type: 'INPUT',
                inputType: 'number',
                units: ['laengeKurz'],
                defaultUnit: 'mm',
                default: 18,
              },
              {
                name: 'Wand_Rohr_s',
                type: 'INPUT',
                inputType: 'number',
                units: ['laengeKurz'],
                defaultUnit: 'mm',
                default: 1.0,
              },
              {
                name: 'Rohrrauhigkeit',
                type: 'INPUT',
                inputType: 'number',
                units: ['laengeKurz'],
                defaultUnit: 'mm',
                default: 0.2,
              },
              {
                name: 'Dicke_Schmutz',
                type: 'INPUT',
                inputType: 'number',
                units: ['laengeKurz'],
                defaultUnit: 'mm',
                default: 0.1,
              },
              {
                name: 'Teilung_horizontal',
                type: 'INPUT',
                inputType: 'number',
                units: ['laengeKurz'],
                defaultUnit: 'mm',
                default: 30,
              },
              {
                name: 'Teilung_vertikal',
                type: 'INPUT',
                inputType: 'number',
                units: ['laengeKurz'],
                defaultUnit: 'mm',
                default: 30,
              },
              {
                name: 'Umlenkung',
                type: 'INPUT',
                inputType: 'select',
                options: ['UmlenkungOptions'],
              },
              {
                name: 'Buendelanordnung',
                type: 'INPUT',
                inputType: 'select',
                options: ['BuendelanordnungOptions'],
              },
              {
                name: 'RohranschlussId',
                type: 'INPUT',
                inputType: 'select',
                options: ['RohranschlussOptions'],
              },
            ],
          },
        ],
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'expertModeSubtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'expertMode_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'expertMode_no',
            checked: true,
          },
          {
            name: 'expertMode_yes',
            items: [
              {
                name: 'powerReserve',
                type: 'INPUT',
                inputType: 'number',
                units: ['Percent'],
                default: 5.0,
                disabled: true,
              },
            ],
          },
        ],
      },
    ],
  },
  'uit400_Transtlations.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'x_mytitle',
        type: 'TITLE',
      },
      {
        name: 'x_mysubtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'x_untranslatedLabel',
        type: 'INPUT',
        inputType: 'text',
        importance: 'optional',
      },
      {
        name: 'x_translatedText',
        type: 'INPUT',
        inputType: 'text',
        importance: 'optional',
      },
      {
        name: 'x_translatedNumber',
        type: 'INPUT',
        inputType: 'number',
        importance: 'optional',
      },
      {
        name: 'x_translatedNumber2',
        type: 'INPUT',
        inputType: 'number',
        units: ['Area'],
        defaultUnit: 'm2',
        importance: 'optional',
      },
      {
        name: 'x_translatedSearch',
        type: 'INPUT',
        inputType: 'search',
        data: ['uit400_Data'],
        default: 'uit400_data1',
        importance: 'optional',
      },
      {
        name: 'x_translatedSelect',
        type: 'INPUT',
        inputType: 'select',
        options: ['uit400_Select'],
      },
      {
        name: 'x_translatedMultiSearch',
        type: 'INPUT',
        inputType: 'multi-select',
        options: ['uit400_MS'],
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'x_translatedRadio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'x_translatedRadioItem1',
          },
          {
            name: 'x_translatedRadioItem2',
            checked: true,
          },
          {
            name: 'x_untranslatedRadioItem1',
          },
        ],
      },
      {
        name: 'x_translatedList',
        type: 'LIST',
        initItemCount: 0,
        maxItemCount: 2,
        listItems: [
          {
            name: 'x_translatedTextInList',
            type: 'INPUT',
            inputType: 'text',
            importance: 'optional',
          },
        ],
      },
      {
        name: 'x_untranslatedRadio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'x_translatedRadioItem1_secondRadio',
          },
          {
            name: 'x_translatedRadioItem2_secondRadio',
            checked: true,
          },
          {
            name: 'x_untranslatedRadioItem1_secondRadio',
          },
        ],
      },
      {
        name: 'x_untranslatedList',
        type: 'LIST',
        initItemCount: 0,
        maxItemCount: 2,
        listItems: [
          {
            name: 'x_translatedTextInList_secondList',
            type: 'INPUT',
            inputType: 'text',
            importance: 'optional',
          },
        ],
      },
    ],
  },
  hierarchy:
    'drySorb/sorbensReactor\ndust/bagFilter\ndust/eFilter\ndust/fua\nfluidFlow/pipe\nfluidFlow/pipe_simple\nnox/scr\npressure/fan\nsources/eco\nsources/heatSource\nstreamModifier/streamModifier\nzzCodes/addCodes\nzzUiTests/htmlTranslations\nzzUiTests/uit000_basicSolutions\nzzUiTests/uit001_nestedSolutions\nzzUiTests/uit100_Text\nzzUiTests/uit101_Number\nzzUiTests/uit102_Select\nzzUiTests/uit103_MultiSelect\nzzUiTests/uit104_Search\nzzUiTests/uit200_RadioGroup\nzzUiTests/uit201_RadioinRadio\nzzUiTests/uit202_ListinRadio\nzzUiTests/uit300_List\nzzUiTests/uit301_RadioInList_1\nzzUiTests/uit302_RadioInList_2\nzzUiTests/uit303_ListinList\nzzUiTests/uit400_Transtlations\n',
  'uit400_Transtlations.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'uit100_Text.json': {
    items: [
      {
        name: '100_Text',
        type: 'TITLE',
      },
      {
        name: 'EINS',
        type: 'INPUT',
        inputType: 'text',
      },
      {
        name: 'DREI',
        type: 'INPUT',
        inputType: 'text',
        disabled: false,
      },
      {
        name: 'VIER',
        type: 'INPUT',
        inputType: 'text',
        importance: 'optional',
      },
      {
        name: 'FÜNF',
        type: 'INPUT',
        inputType: 'text',
        importance: 'mandatory',
      },
      {
        name: 'SECHS',
        type: 'INPUT',
        inputType: 'text',
        disabled: true,
        default: 'Test',
      },
      {
        name: 'SIEBEN',
        type: 'INPUT',
        inputType: 'text',
        default: 'Test',
      },
    ],
  },
  'pipe.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'geometry',
        type: 'SUBTITLE',
      },
      {
        name: 'GeometrieRadio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'mitZetaItem',
            checked: true,
            items: [
              {
                name: 'ZetaInput',
                type: 'INPUT',
                inputType: 'number',
              },
              {
                name: 'QuerschnittOderGasGeschw',
                type: 'RADIO_GROUP',
                radioItems: [
                  {
                    name: 'RundItem',
                    checked: true,
                    items: [
                      {
                        name: 'DurchmesserInput',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Length'],
                      },
                    ],
                  },
                  {
                    name: 'KanalItem',
                    items: [
                      {
                        name: 'KanalBreiteInput',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Length'],
                      },
                      {
                        name: 'KanalTiefeInput',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Length'],
                      },
                    ],
                  },
                  {
                    name: 'QuerschnittItem',
                    items: [
                      {
                        name: 'QuerschnittInput',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Area'],
                      },
                    ],
                  },
                  {
                    name: 'GasGeschwindigkeitItem',
                    items: [
                      {
                        name: 'GasGeschwindigkeitInput',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Speed'],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            name: 'RohrlaengeUndRauigkeitItem',
            items: [
              {
                name: 'RohrlaengeInput',
                type: 'INPUT',
                inputType: 'number',
                units: ['Length'],
              },
              {
                name: 'RauigkeitInput',
                type: 'INPUT',
                inputType: 'number',
                units: ['laengeKurz'],
              },
              {
                name: 'QuerschnittRadio',
                type: 'RADIO_GROUP',
                radioItems: [
                  {
                    name: 'ohneZetaRundItem',
                    checked: true,
                    items: [
                      {
                        name: 'ohneZetaDurchmesserInput',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Length'],
                      },
                    ],
                  },
                  {
                    name: 'ohneZetaKanalItem',
                    items: [
                      {
                        name: 'ohneZetaKanalBreiteInput',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Length'],
                      },
                      {
                        name: 'ohneZetaKanalTiefeInput',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Length'],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  'uit000_basicSolutions.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="58" y="50" fill="red">000</text>\n</svg>\n',
  'htmlTranslations.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'uit200_RadioGroup.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'addCodes.json': {
    items: [
      {
        name: 'addCodesTitle',
        type: 'TITLE',
      },
      {
        name: 'codes_list',
        type: 'LIST',
        initItemCount: 0,
        maxItemCount: 15,
        listItems: [
          {
            name: 'codes_select',
            type: 'INPUT',
            inputType: 'select',
            options: ['codeTypeOptions'],
            default: 'code_info',
          },
        ],
      },
    ],
  },
  'fua.svg':
    '<?xml version="1.0" encoding="utf-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" width="124" height="86" viewBox="0 0 124 86" xmlns:bx="https://boxy-svg.com">\n  <defs>\n    <bx:export>\n      <bx:file format="svg" path="Unbetitelt.svg"/>\n    </bx:export>\n  </defs>\n  <path style="fill: rgb(204, 234, 248); stroke: rgb(204, 234, 248);" d="M 2.132 27.941 L 32.732 27.941 L 78.626 6.989 L 94.795 6.989 L 94.795 27.941 L 123.55 27.941 L 123.55 44.208 L 94.795 44.208 L 94.795 85.498 L 78.626 85.513 L 78.626 66.811 L 30.903 44.237 L 2.132 44.237 L 2.132 27.941 Z"/>\n  <g style="" transform="matrix(1.164239, 0, 0, 1.508651, -11.060891, -23.238171)">\n    <rect x="10.036" y="30.018" width="24.99" height="1.4" style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);"/>\n    <rect x="10" y="40" width="25.009" height="1.4" style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);"/>\n    <rect x="31.204" y="30.148" width="40.543" height="1.4" style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219); transform-box: fill-box; transform-origin: 50% 50%;" transform="matrix(0.939677, -0.342062, 0.338083, 0.941126, 3.073933, -7.186243)"/>\n    <rect x="31.221" y="30.148" width="40.565" height="1.4" style="transform-origin: 51.504px 30.848px; fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" transform="matrix(0.939708, 0.341978, -0.345957, 0.93826, 3.10423, 16.89752)"/>\n    <rect x="40.158" y="55.873" width="15.001" height="1.4" style="transform-box: fill-box; transform-origin: 50% 50%; fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" transform="matrix(0, 1, -1, 0, 25.701314, 5.199169)"/>\n    <rect x="77.69" y="55.873" width="29.021" height="1.4" style="transform-origin: 92.201px 56.573px; fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" transform="matrix(0, 1, -1, 0, -8.501598, -2.050976)"/>\n    <rect x="74.241" y="15.927" width="10.161" height="1.4" style="transform-origin: 79.321px 16.627px; fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);"/>\n    <rect x="41.398" y="55.873" width="15.465" height="1.4" style="transform-origin: 49.13px 56.573px; fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" transform="matrix(0, 1, -1, 0, 34.585175, -32.906044)"/>\n    <rect x="83.3" y="40" width="25.009" height="1.4" style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);"/>\n    <rect x="83.3" y="30" width="24.99" height="1.4" style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);"/>\n  </g>\n  <path style="fill: rgba(216, 216, 216, 0); stroke-dasharray: 1; stroke: rgb(0, 149, 219);" d="M 117.527 31.914 L 94.275 31.912 C 87.83 32.067 80.991 31.97 80.726 28.895 C 78.783 -11.435 72.043 17.966 70.788 29.11 C 69.533 40.254 64.745 64.281 59.973 31.139 C 56.376 8.905 53.133 16.185 49.633 31.776 C 46.133 47.367 43.242 37.312 41.837 30.98 C 38.922 19.278 34.654 29.094 31.813 31.935 C 30.054 32.422 0.155 32.094 0.155 32.094"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="79.025" cy="71.071" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="82.88" cy="55.772" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="82.835" cy="70.171" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="80.589" cy="67.956" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="76.966" cy="69.094" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="77.086" cy="61.847" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="76.846" cy="55.679" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="79.966" cy="57.011" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="82.541" cy="58.795" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="80.535" cy="60.352" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="77.306" cy="58.822" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="83.145" cy="62.535" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="78.175" cy="66.248" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="82.935" cy="66.249" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="79.531" cy="63.94" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="80.317" cy="73.931" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="77.394" cy="73.502" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="77.871" cy="76.647" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="83.206" cy="76.399" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="79.276" cy="79.992" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="80.44" cy="77.11" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="83.259" cy="73.124" rx="0.543" ry="0.479"/>\n  <ellipse style="fill: rgb(0, 149, 219); stroke: rgb(0, 149, 219);" cx="82.644" cy="79.169" rx="0.543" ry="0.479"/>\n  <path style="fill: rgb(0, 149, 219); stroke: rgba(0, 0, 0, 0);" d="M 118.319 29.631 L 122.615 31.914 L 118.319 34.253 L 118.319 29.631 Z"/>\n</svg>',
  'sorbensReactor.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'saureKomponenten_title',
        type: 'TITLE',
      },
      {
        name: 'Zielwerte_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'SOx_Out',
        type: 'INPUT',
        inputType: 'number',
        importance: 'optional',
        units: [
          'Concentration_mg',
          'AdditiveUnit_kgh',
          'ConcentrationVolumePpm',
        ],
        groupUserInputs: 'target',
        tooltip: 'SOx_Tooltip',
      },
      {
        name: 'HCl_Out',
        type: 'INPUT',
        inputType: 'number',
        importance: 'optional',
        units: [
          'Concentration_mg',
          'AdditiveUnit_kgh',
          'ConcentrationVolumePpm',
        ],
        groupUserInputs: 'target',
      },
      {
        name: 'HF_Out',
        type: 'INPUT',
        inputType: 'number',
        importance: 'optional',
        units: [
          'Concentration_mg',
          'AdditiveUnit_kgh',
          'ConcentrationVolumePpm',
        ],
        groupUserInputs: 'target',
      },
      {
        name: 'saureZielwerte_List',
        type: 'LIST',
        initItemCount: 0,
        maxItemCount: 2,
        listItems: [
          {
            name: 'saureZielwerte_species',
            type: 'INPUT',
            inputType: 'select',
            options: ['saureZielwerte_options'],
          },
          {
            name: 'saureZielwerte_value',
            type: 'INPUT',
            inputType: 'number',
            units: [
              'Concentration_mg',
              'AdditiveUnit_kgh',
              'ConcentrationVolumePpm',
            ],
          },
        ],
      },
      {
        name: 'saureAdditive_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'saureAdditiv_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'keineVorauswahl_radioItem',
            checked: true,
          },
          {
            name: 'Vorauswahl_radioItem',
            items: [
              {
                name: 'feasibleAdditiv_MS',
                type: 'INPUT',
                inputType: 'multi-select',
                options: ['saureAdditiv_options'],
              },
            ],
          },
          {
            name: 'Vorgabe_radioItem',
            items: [
              {
                name: 'saureAdditiv_Vorgabe_select',
                type: 'INPUT',
                inputType: 'select',
                options: ['saureAdditiv_options'],
              },
              {
                name: 'saureAdditiv_Vorgabe_radio',
                type: 'RADIO_GROUP',
                radioItems: [
                  {
                    name: 'calcStoechMassFlow_radioItem',
                    checked: true,
                  },
                  {
                    name: 'setStoech_radioItem',
                    items: [
                      {
                        name: 'setStoech_input',
                        type: 'INPUT',
                        inputType: 'number',
                      },
                    ],
                  },
                  {
                    name: 'setMassFlow_radioItem',
                    items: [
                      {
                        name: 'setMassFlow_input',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['AdditiveUnit_kgh'],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'Aktivkohle_Schadstoffe_title',
        type: 'TITLE',
      },
      {
        name: 'Hg_Out',
        type: 'INPUT',
        inputType: 'number',
        importance: 'optional',
        units: [
          'Concentration_mg',
          'Concentration_mug',
          'ConcentrationVolumePpm',
          'AdditiveUnit_kgh',
        ],
        groupUserInputs: 'target',
      },
      {
        name: 'PCDD_PCDF_Out',
        type: 'INPUT',
        inputType: 'number',
        importance: 'optional',
        units: ['Concentration_ng', 'ConcentrationVolumePpm'],
        groupUserInputs: 'target',
      },
      {
        name: 'ACDosierung_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'ACDosierung_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'acdosierung_keineVorauswahl',
            checked: true,
          },
          {
            name: 'acdosierung_Vorauswahl',
            items: [
              {
                name: 'acdosierung_vorauswahl_input',
                type: 'INPUT',
                inputType: 'number',
                units: ['AdditiveUnitsPAC'],
              },
            ],
          },
        ],
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'Sonstiges',
        type: 'TITLE',
      },
      {
        name: 'Kombidosierung_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'Kombidosierung_yes',
          },
          {
            name: 'Kombidosierung_no',
            checked: true,
          },
        ],
      },
      {
        name: 'Lagerdauer_input',
        type: 'INPUT',
        inputType: 'number',
        default: 7,
        units: ['Time_Days'],
        tooltip: 'lagerdauer_tooltip',
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'expertMode_subtitle',
        type: 'TITLE',
      },
      {
        name: 'expertMode_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'expertMode_no',
            checked: true,
          },
          {
            name: 'expertMode_yes',
            items: [
              {
                name: 'volFlowAirStreamGes_input',
                type: 'INPUT',
                inputType: 'number',
                units: ['volFlow_NormWetPerHour'],
                importance: 'optional',
              },
              {
                name: 'Kalkhydrat_expert_subtitle',
                type: 'SUBTITLE',
              },
              {
                name: 'reserveZuschlag_Kalkhydrat_input',
                type: 'INPUT',
                inputType: 'number',
                units: ['Percent'],
                default: 30,
              },
              {
                name: 'DichteUberschreiben_Kalkhydrat_input',
                type: 'INPUT',
                inputType: 'number',
                units: ['Density_Solids'],
                default: 450,
              },
              {
                name: 'Bicar_expert_subtitle',
                type: 'SUBTITLE',
              },
              {
                name: 'reserveZuschlag_Bicar_input',
                type: 'INPUT',
                inputType: 'number',
                units: ['Percent'],
                default: 10,
              },
              {
                name: 'DichteUberschreiben_Bicar_input',
                type: 'INPUT',
                inputType: 'number',
                units: ['Density_Solids'],
                default: 975,
              },
              {
                name: 'Aktivkohle_expert_subtitle',
                type: 'SUBTITLE',
              },
              {
                name: 'reserveZuschlag_Aktivkohle_input',
                type: 'INPUT',
                inputType: 'number',
                units: ['Percent'],
                default: 20,
              },
              {
                name: 'DichteUberschreiben_Aktivkohle_input',
                type: 'INPUT',
                inputType: 'number',
                units: ['Density_Solids'],
                default: 1000,
              },
            ],
          },
        ],
      },
    ],
  },
  'uit102_Select.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'limitsPresets.json': {
    'Vorlage 3': {
      NOx: {
        unit: 'mg_Nm3_fe_betrO2',
        value: 17.0,
      },
      SOx: {
        unit: 'mg_Nm3_fe_betrO2',
        value: 10.0,
      },
      solids: {
        unit: 'g_Bm3_tr_betrO2',
        value: 5.0,
      },
      NH3: {
        unit: 'mg_Nm3_fe_betrO2',
        value: 24.0,
      },
      HCl: {
        unit: 'mg_Nm3_fe_betrO2',
        value: 13.0,
      },
      HF: {
        unit: 'mg_Nm3_fe_betrO2',
        value: 14.0,
      },
    },
    'Vorlage 2': {
      NOx: {
        unit: 'mg_Nm3_fe_betrO2',
        value: 20.0,
      },
      solids: {
        unit: 'mg_Nm3_tr_bezO2',
        value: 3.0,
      },
      NH3: {
        unit: 'mg_Nm3_fe_betrO2',
        value: 25.0,
      },
      CO: {
        unit: 'mg_Nm3_tr_betrO2',
        value: 25.0,
      },
    },
    'Vorlage 1': {
      SOx: {
        unit: 'mg_Nm3_fe_betrO2',
        value: 10.0,
      },
      solids: {
        unit: 'mg_Bm3_tr_betrO2',
        value: 7.0,
      },
      HCl: {
        unit: 'mg_Nm3_fe_betrO2',
        value: 13.0,
      },
      HF: {
        unit: 'mg_Nm3_fe_betrO2',
        value: 15.0,
      },
    },
  },
  'uit104_Search.json': {
    items: [
      {
        name: 'uit104_Search',
        type: 'TITLE',
      },
      {
        name: 'EINS',
        type: 'INPUT',
        inputType: 'search',
        data: ['speciesSearch'],
      },
      {
        name: 'ZWEI',
        type: 'INPUT',
        inputType: 'search',
        data: ['zz_UI_TestSingleSearch'],
      },
      {
        name: 'DREI',
        type: 'INPUT',
        inputType: 'search',
        data: ['speciesSearch'],
        default: 'Staub',
      },
      {
        name: 'VIER',
        type: 'INPUT',
        inputType: 'search',
        data: ['speciesSearch'],
        disabled: true,
        default: 'H2O',
      },
      {
        name: 'FÜNF',
        type: 'INPUT',
        inputType: 'search',
        data: ['speciesSearch'],
        disabled: false,
      },
      {
        name: 'SECHS',
        type: 'INPUT',
        inputType: 'search',
        data: ['opex_EntsorgungSearch'],
        importance: 'optional',
      },
      {
        name: 'SIEBEN',
        type: 'INPUT',
        inputType: 'search',
        data: ['opex_EntsorgungSearch'],
        importance: 'mandatory',
      },
      {
        name: 'ACHT',
        type: 'INPUT',
        inputType: 'search',
        data: ['opex_EntsorgungSearch', 'speciesSearch'],
        importance: 'optional',
      },
    ],
  },
  'bagFilter.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M12.5904 1.89149C12.5904 1.12542 13.2114 0.504395 13.9775 0.504395H107.291C108.057 0.504395 108.678 1.12542 108.678 1.89149V13.2405C108.678 14.0065 108.057 14.6276 107.291 14.6276H13.9775C13.2114 14.6276 12.5904 14.0065 12.5904 13.2405V1.89149ZM15.3646 3.27859V11.8534H105.904V3.27859H15.3646ZM12.5904 20.8064C12.5904 20.0404 13.2114 19.4194 13.9775 19.4194H107.291C108.057 19.4194 108.678 20.0404 108.678 20.8064V57.3754C108.678 57.5907 108.628 57.8031 108.532 57.9957L96.8677 81.3241C96.6328 81.7941 96.1525 82.0909 95.6271 82.0909C95.1017 82.0909 94.6214 81.7941 94.3864 81.3241L83.9629 60.477L73.5393 81.3241C73.3043 81.7941 72.824 82.0909 72.2986 82.0909C71.7732 82.0909 71.2929 81.7941 71.058 81.3241L60.6344 60.477L50.2108 81.3241C49.9759 81.7941 49.4956 82.0909 48.9702 82.0909C48.4448 82.0909 47.9645 81.7941 47.7295 81.3241L37.306 60.477L26.8824 81.3241C26.6474 81.7941 26.1671 82.0909 25.6417 82.0909C25.1164 82.0909 24.636 81.7941 24.4011 81.3241L12.7369 57.9957C12.6406 57.8031 12.5904 57.5907 12.5904 57.3754V20.8064ZM15.3646 22.1935V57.0479L25.6417 77.6022L36.0653 56.755C36.3003 56.2851 36.7806 55.9883 37.306 55.9883C37.8314 55.9883 38.3117 56.2851 38.5466 56.755L48.9702 77.6022L59.3938 56.755C59.6287 56.2851 60.109 55.9883 60.6344 55.9883C61.1598 55.9883 61.6401 56.2851 61.8751 56.755L72.2986 77.6022L82.7222 56.755C82.9572 56.2851 83.4375 55.9883 83.9629 55.9883C84.4883 55.9883 84.9686 56.2851 85.2035 56.755L95.6271 77.6022L105.904 57.0479V22.1935H15.3646Z" fill="#0095DB"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M13.722 27.2081H13.246V26.2833H13.722V27.2081ZM15.6261 27.2081H14.6741V26.2833H15.6261V27.2081ZM16.5666 26.2833H17.0542V26.7457H17.4914V27.2138H16.5666V26.2833ZM24.1326 26.2833H25.0678V27.2081H25.0573V27.2138H24.1326V26.2833ZM26.9593 27.2081H26.0136V26.2833H26.9593V27.2081ZM28.8508 27.2081H27.9051V26.2833H28.8508V27.2081ZM30.7423 27.2081H29.7966V26.2833H30.7423V27.2081ZM31.6986 27.2081H31.6881V26.2833H32.6233V27.2138H31.6986V27.2081ZM39.8951 26.2833H40.8303V27.2081H40.8198V27.2138H39.8951V26.2833ZM42.7218 27.2081H41.7761V26.2833H42.7218V27.2081ZM44.6133 27.2081H43.6676V26.2833H44.6133V27.2081ZM46.5048 27.2081H45.5591V26.2833H46.5048V27.2081ZM47.4611 27.2081H47.4505V26.2833H48.3858V27.2138H47.4611V27.2081ZM55.6575 26.2833H56.5928V27.2081H56.5823V27.2138H55.6575V26.2833ZM58.4843 27.2081H57.5385V26.2833H58.4843V27.2081ZM60.3758 27.2081H59.43V26.2833H60.3758V27.2081ZM62.2673 27.2081H61.3215V26.2833H62.2673V27.2081ZM63.2235 27.2081H63.213V26.2833H64.1483V27.2138H63.2235V27.2081ZM70.7895 26.2833H71.7247V27.2081H71.7142V27.2138H70.7895V26.2833ZM73.6162 27.2081H72.6705V26.2833H73.6162V27.2081ZM75.5077 27.2081H74.562V26.2833H75.5077V27.2081ZM77.3992 27.2081H76.4535V26.2833H77.3992V27.2081ZM78.3555 27.2081H78.345V26.2833H79.2802V27.2138H78.3555V27.2081ZM86.552 26.2833H87.4872V27.2081H87.4767V27.2138H86.552V26.2833ZM89.3787 27.2081H88.433V26.2833H89.3787V27.2081ZM91.2702 27.2081H90.3244V26.2833H91.2702V27.2081ZM93.1617 27.2081H92.2159V26.2833H93.1617V27.2081ZM94.1179 27.2081H94.1074V26.2833H95.0427V27.2138H94.1179V27.2081ZM102.314 26.2833H103.253V27.2081H103.239V27.2138H102.314V26.2833ZM105.157 27.2081H104.205V26.2833H105.157V27.2081ZM106.585 27.2081H106.109V26.2833H106.585V27.2081ZM25.0573 28.1501V29.0864H24.1326V28.1501H25.0573ZM40.8198 28.1501V29.0864H39.8951V28.1501H40.8198ZM56.5823 28.1501V29.0864H55.6575V28.1501H56.5823ZM71.7142 28.1501V29.0864H70.7895V28.1501H71.7142ZM87.4767 28.1501V29.0864H86.552V28.1501H87.4767ZM103.239 28.1501V29.0864H102.314V28.1501H103.239ZM16.5666 29.0864V28.1501H17.4914V29.0864H16.5666ZM31.6986 29.0864V28.1501H32.6233V29.0864H31.6986ZM47.4611 29.0864V28.1501H48.3858V29.0864H47.4611ZM63.2235 29.0864V28.1501H64.1483V29.0864H63.2235ZM78.3555 29.0864V28.1501H79.2802V29.0864H78.3555ZM94.1179 29.0864V28.1501H95.0427V29.0864H94.1179ZM25.0573 30.0227V30.959H24.1326V30.0227H25.0573ZM40.8198 30.0227V30.959H39.8951V30.0227H40.8198ZM56.5823 30.0227V30.959H55.6575V30.0227H56.5823ZM71.7142 30.0227V30.959H70.7895V30.0227H71.7142ZM87.4767 30.0227V30.959H86.552V30.0227H87.4767ZM103.239 30.0227V30.959H102.314V30.0227H103.239ZM16.5666 30.959V30.0227H17.4914V30.959H16.5666ZM31.6986 30.959V30.0227H32.6233V30.959H31.6986ZM47.4611 30.959V30.0227H48.3858V30.959H47.4611ZM63.2235 30.959V30.0227H64.1483V30.959H63.2235ZM78.3555 30.959V30.0227H79.2802V30.959H78.3555ZM94.1179 30.959V30.0227H95.0427V30.959H94.1179ZM16.5666 32.8316V31.8953H17.4914V32.8316H16.5666ZM31.6986 32.8316V31.8953H32.6233V32.8316H31.6986ZM47.4611 32.8316V31.8953H48.3858V32.8316H47.4611ZM63.2235 32.8316V31.8953H64.1483V32.8316H63.2235ZM78.3555 32.8316V31.8953H79.2802V32.8316H78.3555ZM94.1179 32.8316V31.8953H95.0427V32.8316H94.1179ZM25.0573 31.8953V32.8316H24.1326V31.8953H25.0573ZM40.8198 31.8953V32.8316H39.8951V31.8953H40.8198ZM56.5823 31.8953V32.8316H55.6575V31.8953H56.5823ZM71.7142 31.8953V32.8316H70.7895V31.8953H71.7142ZM87.4767 31.8953V32.8316H86.552V31.8953H87.4767ZM103.239 31.8953V32.8316H102.314V31.8953H103.239ZM16.5666 34.7042V33.7679H17.4914V34.7042H16.5666ZM31.6986 34.7042V33.7679H32.6233V34.7042H31.6986ZM47.4611 34.7042V33.7679H48.3858V34.7042H47.4611ZM63.2235 34.7042V33.7679H64.1483V34.7042H63.2235ZM78.3555 34.7042V33.7679H79.2802V34.7042H78.3555ZM94.1179 34.7042V33.7679H95.0427V34.7042H94.1179ZM25.0573 33.7679V34.7042H24.1326V33.7679H25.0573ZM40.8198 33.7679V34.7042H39.8951V33.7679H40.8198ZM56.5823 33.7679V34.7042H55.6575V33.7679H56.5823ZM71.7142 33.7679V34.7042H70.7895V33.7679H71.7142ZM87.4767 33.7679V34.7042H86.552V33.7679H87.4767ZM103.239 33.7679V34.7042H102.314V33.7679H103.239ZM16.5666 36.5767V35.6404H17.4914V36.5767H16.5666ZM31.6986 36.5767V35.6404H32.6233V36.5767H31.6986ZM47.4611 36.5767V35.6404H48.3858V36.5767H47.4611ZM63.2235 36.5767V35.6404H64.1483V36.5767H63.2235ZM78.3555 36.5767V35.6404H79.2802V36.5767H78.3555ZM94.1179 36.5767V35.6404H95.0427V36.5767H94.1179ZM25.0573 35.6405V36.5767H24.1326V35.6405H25.0573ZM40.8198 35.6405V36.5767H39.8951V35.6405H40.8198ZM56.5823 35.6405V36.5767H55.6575V35.6405H56.5823ZM71.7142 35.6405V36.5767H70.7895V35.6405H71.7142ZM87.4767 35.6405V36.5767H86.552V35.6405H87.4767ZM103.239 35.6405V36.5767H102.314V35.6405H103.239ZM16.5666 38.4493V37.513H17.4914V38.4493H16.5666ZM31.6986 38.4493V37.513H32.6233V38.4493H31.6986ZM47.4611 38.4493V37.513H48.3858V38.4493H47.4611ZM63.2235 38.4493V37.513H64.1483V38.4493H63.2235ZM78.3555 38.4493V37.513H79.2802V38.4493H78.3555ZM94.1179 38.4493V37.513H95.0427V38.4493H94.1179ZM25.0573 37.513V38.4493H24.1326V37.513H25.0573ZM40.8198 37.513V38.4493H39.8951V37.513H40.8198ZM56.5823 37.513V38.4493H55.6575V37.513H56.5823ZM71.7142 37.513V38.4493H70.7895V37.513H71.7142ZM87.4767 37.513V38.4493H86.552V37.513H87.4767ZM103.239 37.513V38.4493H102.314V37.513H103.239ZM16.5666 40.3219V39.3856H17.4914V40.3219H16.5666ZM31.6986 40.3219V39.3856H32.6233V40.3219H31.6986ZM47.4611 40.3219V39.3856H48.3858V40.3219H47.4611ZM63.2235 40.3219V39.3856H64.1483V40.3219H63.2235ZM78.3555 40.3219V39.3856H79.2802V40.3219H78.3555ZM94.1179 40.3219V39.3856H95.0427V40.3219H94.1179ZM25.0573 39.3856V40.3219H24.1326V39.3856H25.0573ZM40.8198 39.3856V40.3219H39.8951V39.3856H40.8198ZM56.5823 39.3856V40.3219H55.6575V39.3856H56.5823ZM71.7142 39.3856V40.3219H70.7895V39.3856H71.7142ZM87.4767 39.3856V40.3219H86.552V39.3856H87.4767ZM103.239 39.3856V40.3219H102.314V39.3856H103.239ZM16.5666 42.1945V41.2582H17.4914V42.1945H16.5666ZM31.6986 42.1945V41.2582H32.6233V42.1945H31.6986ZM47.4611 42.1945V41.2582H48.3858V42.1945H47.4611ZM63.2235 42.1945V41.2582H64.1483V42.1945H63.2235ZM78.3555 42.1945V41.2582H79.2802V42.1945H78.3555ZM94.1179 42.1945V41.2582H95.0427V42.1945H94.1179ZM25.0573 41.2582V42.1945H24.1326V41.2582H25.0573ZM40.8198 41.2582V42.1945H39.8951V41.2582H40.8198ZM56.5823 41.2582V42.1945H55.6575V41.2582H56.5823ZM71.7142 41.2582V42.1945H70.7895V41.2582H71.7142ZM87.4767 41.2582V42.1945H86.552V41.2582H87.4767ZM103.239 41.2582V42.1945H102.314V41.2582H103.239ZM16.5666 44.0671V43.1308H17.4914V44.0671H16.5666ZM31.6986 44.0671V43.1308H32.6233V44.0671H31.6986ZM47.4611 44.0671V43.1308H48.3858V44.0671H47.4611ZM63.2235 44.0671V43.1308H64.1483V44.0671H63.2235ZM78.3555 44.0671V43.1308H79.2802V44.0671H78.3555ZM94.1179 44.0671V43.1308H95.0427V44.0671H94.1179ZM25.0573 43.1308V44.0671H24.1326V43.1308H25.0573ZM40.8198 43.1308V44.0671H39.8951V43.1308H40.8198ZM56.5823 43.1308V44.0671H55.6575V43.1308H56.5823ZM71.7142 43.1308V44.0671H70.7895V43.1308H71.7142ZM87.4767 43.1308V44.0671H86.552V43.1308H87.4767ZM103.239 43.1308V44.0671H102.314V43.1308H103.239ZM16.5666 45.9396V45.0034H17.4914V45.9396H16.5666ZM25.0573 45.0034V45.9396H24.1326V45.0034H25.0573ZM31.6986 45.9396V45.0034H32.6233V45.9396H31.6986ZM40.8198 45.0034V45.9396H39.8951V45.0034H40.8198ZM47.4611 45.9396V45.0034H48.3858V45.9396H47.4611ZM56.5823 45.0034V45.9396H55.6575V45.0034H56.5823ZM63.2235 45.9396V45.0034H64.1483V45.9396H63.2235ZM71.7142 45.0034V45.9396H70.7895V45.0034H71.7142ZM78.3555 45.9396V45.0034H79.2802V45.9396H78.3555ZM87.4767 45.0034V45.9396H86.552V45.0034H87.4767ZM94.1179 45.9396V45.0034H95.0427V45.9396H94.1179ZM103.239 45.0034V45.9396H102.314V45.0034H103.239ZM25.0573 46.8759V47.8122H24.1326V46.8759H25.0573ZM40.8198 46.8759V47.8122H39.8951V46.8759H40.8198ZM56.5823 46.8759V47.8122H55.6575V46.8759H56.5823ZM71.7142 46.8759V47.8122H70.7895V46.8759H71.7142ZM87.4767 46.8759V47.8122H86.552V46.8759H87.4767ZM103.239 46.8759V47.8122H102.314V46.8759H103.239ZM16.5666 47.8122V46.8759H17.4914V47.8122H16.5666ZM31.6986 47.8122V46.8759H32.6233V47.8122H31.6986ZM47.4611 47.8122V46.8759H48.3858V47.8122H47.4611ZM63.2235 47.8122V46.8759H64.1483V47.8122H63.2235ZM78.3555 47.8122V46.8759H79.2802V47.8122H78.3555ZM94.1179 47.8122V46.8759H95.0427V47.8122H94.1179ZM25.0573 48.7485V49.679H24.1221V48.7543H24.1326V48.7485H25.0573ZM40.8198 48.7485V49.679H39.8452V48.7543H39.8951V48.7485H40.8198ZM56.5823 48.7485V49.679H55.6076V48.7543H55.6575V48.7485H56.5823ZM71.7142 48.7485V49.679H70.779V48.7543H70.7895V48.7485H71.7142ZM87.4767 48.7485V49.679H86.5021V48.7543H86.552V48.7485H87.4767ZM103.239 48.7485V49.679H102.265V48.7543H102.314V48.7485H103.239ZM16.5666 48.7485H17.4914V48.7543H17.5019V49.679H16.5666V48.7485ZM31.6986 48.7485H32.6233V48.7543H32.6732V49.679H31.6986V48.7485ZM47.4611 48.7485H48.3858V48.7543H48.4357V49.679H47.4611V48.7485ZM63.2235 48.7485H64.1483V48.7543H64.1588V49.679H63.2235V48.7485ZM78.3555 48.7485H79.2802V48.7543H79.3301V49.679H78.3555V48.7485ZM94.1179 48.7485H95.0427V48.7543H95.0926V49.679H94.1179V48.7485ZM19.3934 49.679H18.4476V48.7543H19.3934V49.679ZM21.2849 49.679H20.3391V48.7543H21.2849V49.679ZM23.1764 49.679H22.2306V48.7543H23.1764V49.679ZM34.7224 49.679H33.6978V48.7543H34.7224V49.679ZM36.7715 49.679H35.7469V48.7543H36.7715V49.679ZM38.8206 49.679H37.796V48.7543H38.8206V49.679ZM50.4848 49.679H49.4603V48.7543H50.4848V49.679ZM52.5339 49.679H51.5094V48.7543H52.5339V49.679ZM54.5831 49.679H53.5585V48.7543H54.5831V49.679ZM66.0503 49.679H65.1045V48.7543H66.0503V49.679ZM67.9418 49.679H66.996V48.7543H67.9418V49.679ZM69.8332 49.679H68.8875V48.7543H69.8332V49.679ZM81.3793 49.679H80.3547V48.7543H81.3793V49.679ZM83.4284 49.679H82.4038V48.7543H83.4284V49.679ZM85.4775 49.679H84.4529V48.7543H85.4775V49.679ZM97.1417 49.679H96.1172V48.7543H97.1417V49.679ZM99.1908 49.679H98.1663V48.7543H99.1908V49.679ZM101.24 49.679H100.215V48.7543H101.24V49.679Z" fill="#0095DB"/>\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n</svg>\n',
  'pipe_simple.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        type: 'SUBTITLE',
        name: 'targetValues',
      },
      {
        name: 'DruckverlustInput',
        type: 'INPUT',
        inputType: 'number',
        units: ['PressureAbs'],
      },
    ],
  },
  'globalSettings.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        type: 'TITLE',
        name: 'globals',
      },
      {
        type: 'SUBTITLE',
        name: 'general',
      },
      {
        type: 'INPUT',
        name: 'ambientTemp',
        inputType: 'number',
        units: ['Temperature'],
        importance: 'mandatory',
      },
      {
        type: 'INPUT',
        name: 'height',
        inputType: 'number',
        units: ['aufstellungshoehe'],
        importance: 'mandatory',
      },
      {
        type: 'INPUT',
        name: 'O2RefVolTr',
        inputType: 'number',
        default: 11,
        defaultUnit: 'vol_tr',
        units: ['ConcentrationVolumePercentDry'],
      },
      {
        name: 'humidity',
        type: 'INPUT',
        inputType: 'number',
        default: 60,
        defaultUnit: 'percent',
        units: ['Percent', 'ConcentrationMass_gkg'],
      },
      {
        name: 'allowO2Transformation_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'allowO2Transformation_yes',
          },
          {
            name: 'allowO2Transformation_no',
            checked: true,
          },
        ],
      },
    ],
  },
  'uit302_RadioInList_2.json': {
    items: [
      {
        name: '302_RadioInList_2',
        type: 'TITLE',
      },
      {
        name: 'EINS',
        type: 'SUBTITLE',
      },
      {
        name: 'list',
        type: 'LIST',
        initItemCount: 0,
        maxItemCount: 3,
        listItems: [
          {
            name: 'radio',
            type: 'RADIO_GROUP',
            radioItems: [
              {
                name: 'A',
                items: [
                  {
                    name: 'list2',
                    type: 'LIST',
                    initItemCount: 0,
                    maxItemCount: 3,
                    listItems: [
                      {
                        name: 'text1',
                        type: 'INPUT',
                        inputType: 'text',
                      },
                      {
                        name: 'number1',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Length'],
                      },
                    ],
                  },
                ],
              },
              {
                name: 'B',
              },
              {
                name: 'C',
                checked: true,
                items: [
                  {
                    name: 'text2',
                    type: 'INPUT',
                    inputType: 'text',
                  },
                ],
              },
              {
                name: 'D',
              },
            ],
          },
        ],
      },
    ],
  },
  'eFilter.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'Zielwert',
        type: 'SUBTITLE',
      },
      {
        name: 'reserve',
        type: 'INPUT',
        inputType: 'number',
        units: ['Percent'],
      },
      {
        name: 'dust_eFilter_OUT',
        type: 'INPUT',
        inputType: 'number',
        units: ['Concentration_g', 'Concentration_mg', 'AdditiveUnit_kgh'],
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'Filter_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'HS_aggregat',
        type: 'INPUT',
        inputType: 'select',
        options: ['HS_aggregate'],
      },
      {
        name: 'calcMode',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'auto',
            checked: true,
          },
          {
            name: 'espNewSelect',
            items: [
              {
                name: 'productKeyNewInput',
                type: 'INPUT',
                inputType: 'search',
                data: ['possibleNewEfilter'],
              },
              {
                name: 'nEFieldsInput',
                type: 'INPUT',
                inputType: 'select',
                options: ['nEFieldsOptions'],
                default: 'efields_1',
              },
            ],
          },
          {
            name: 'espOldSelect',
            items: [
              {
                name: 'productKeyOldInput',
                type: 'INPUT',
                inputType: 'search',
                data: ['possibleOldEfilter'],
              },
            ],
          },
        ],
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'ExpertMode_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'expertMode_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'expertMode_no',
            checked: true,
          },
          {
            name: 'expertMode_yes',
            items: [
              {
                name: 'gluehverlust_in_flugasche',
                type: 'INPUT',
                inputType: 'number',
                units: ['ConcentrationMassPercent'],
                default: 10,
              },
            ],
          },
        ],
      },
    ],
  },
  'scr.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'Zielwerte_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'NOx_out',
        type: 'INPUT',
        inputType: 'number',
        units: [
          'Concentration_mg',
          'AdditiveUnit_kgh',
          'ConcentrationVolumePpm',
        ],
      },
      {
        name: 'NH3_out',
        type: 'INPUT',
        inputType: 'number',
        units: [
          'Concentration_mg',
          'AdditiveUnit_kgh',
          'ConcentrationVolumePpm',
        ],
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'Einstellungen_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'additiv_type',
        type: 'INPUT',
        inputType: 'select',
        options: ['solvents'],
      },
      {
        name: 'Garantiezeit',
        type: 'INPUT',
        inputType: 'select',
        options: ['garantie_options'],
        default: 'garantie_2',
      },
      {
        name: 'useVorverdampfer_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'notUseVorverdampfer',
          },
          {
            name: 'useVorverdampfer',
            checked: true,
          },
        ],
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'ExpertMode_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'expertMode_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'expertMode_no',
            checked: true,
          },
          {
            name: 'expertMode_yes',
            items: [
              {
                name: 'additionalReserve',
                type: 'INPUT',
                inputType: 'number',
                importance: 'optional',
                units: ['Percent'],
              },
              {
                name: 'reserveAdditivOverwrite',
                type: 'INPUT',
                inputType: 'number',
                importance: 'optional',
                units: ['Percent'],
              },
              {
                name: 'modultyp_select',
                type: 'INPUT',
                inputType: 'select',
                options: ['modultyp_options'],
                default: 'modultyp_standard',
                disabled: false,
              },
              {
                name: 'ModultypGeometrie_Radio',
                type: 'RADIO_GROUP',
                radioItems: [
                  {
                    name: 'ModultypGeometrie_standard',
                    checked: true,
                  },
                  {
                    name: 'ModultypGeometrie_sonder',
                    items: [
                      {
                        name: 'Geometrie_subtitle',
                        type: 'SUBTITLE',
                      },
                      {
                        name: 'geometrie_length',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Length'],
                      },
                      {
                        name: 'geometry_width',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Length'],
                      },
                    ],
                  },
                ],
              },
              {
                name: 'reserveStockwerk_radio',
                type: 'RADIO_GROUP',
                radioItems: [
                  {
                    name: 'reserveStockwerk_auto',
                    checked: true,
                  },
                  {
                    name: 'reserveStockwerk_no',
                  },
                  {
                    name: 'reserveStockwerk_yes',
                  },
                ],
              },
              {
                name: 'zelligkeit_select',
                type: 'INPUT',
                inputType: 'select',
                options: ['zelligkeit_options'],
                default: 'keineVorgabe',
              },
              {
                name: 'ReaktionsEnthalpie_radio',
                type: 'RADIO_GROUP',
                radioItems: [
                  {
                    name: 'ReaktionsEnthalpie_no',
                    checked: true,
                  },
                  {
                    name: 'ReaktionsEnthalpie_yes',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  'opexPresets.json': {
    DACH: {
      water_cost: {
        unit: 'euro_per_m3',
        value: 1.0,
      },
      Staub_Kalkhydrat: {
        unit: 'euro_per_t',
        value: 120.0,
      },
      Staub: {
        unit: 'euro_per_t',
        value: 120.0,
      },
      gas_cost: {
        unit: 'euro_per_MWh',
        value: 120.0,
      },
      Staub_Bicar: {
        unit: 'euro_per_t',
        value: 140.0,
      },
      energy_cost: {
        unit: 'euro_per_MWh',
        value: 170.0,
      },
      Ammoniakwasser_24_5: {
        unit: 'euro_per_t',
        value: 255.0,
      },
      Harnstoff_40: {
        unit: 'euro_per_t',
        value: 265.0,
      },
      CaOH2: {
        unit: 'euro_per_t',
        value: 275.0,
      },
      SorbacalCDS: {
        unit: 'euro_per_t',
        value: 325.0,
      },
      SorbacalSP: {
        unit: 'euro_per_t',
        value: 330.0,
      },
      SorbacalSPS: {
        unit: 'euro_per_t',
        value: 350.0,
      },
      NaHCO3: {
        unit: 'euro_per_t',
        value: 530.0,
      },
      Aktivkohle: {
        unit: 'euro_per_t',
        value: 800.0,
      },
      Aktivkohle_bromiert: {
        unit: 'euro_per_t',
        value: 2000.0,
      },
    },
    Zentraleuropa: {
      water_cost: {
        unit: 'euro_per_m3',
        value: 1.0,
      },
      gas_cost: {
        unit: 'euro_per_MWh',
        value: 120.0,
      },
      Staub: {
        unit: 'euro_per_t',
        value: 120.0,
      },
      Staub_Kalkhydrat: {
        unit: 'euro_per_t',
        value: 120.0,
      },
      Staub_Bicar: {
        unit: 'euro_per_t',
        value: 140.0,
      },
      energy_cost: {
        unit: 'euro_per_MWh',
        value: 170.0,
      },
      Ammoniakwasser_24_5: {
        unit: 'euro_per_t',
        value: 255.0,
      },
      Harnstoff_40: {
        unit: 'euro_per_t',
        value: 265.0,
      },
      CaOH2: {
        unit: 'euro_per_t',
        value: 275.0,
      },
      SorbacalCDS: {
        unit: 'euro_per_t',
        value: 325.0,
      },
      SorbacalSP: {
        unit: 'euro_per_t',
        value: 330.0,
      },
      SorbacalSPS: {
        unit: 'euro_per_t',
        value: 350.0,
      },
      NaHCO3: {
        unit: 'euro_per_t',
        value: 530.0,
      },
      Aktivkohle: {
        unit: 'euro_per_t',
        value: 800.0,
      },
      Aktivkohle_bromiert: {
        unit: 'euro_per_t',
        value: 2000.0,
      },
    },
    Skandinavien: {
      water_cost: {
        unit: 'euro_per_m3',
        value: 1.0,
      },
      Staub_Kalkhydrat: {
        unit: 'euro_per_t',
        value: 120.0,
      },
      Staub: {
        unit: 'euro_per_t',
        value: 120.0,
      },
      gas_cost: {
        unit: 'euro_per_MWh',
        value: 120.0,
      },
      Staub_Bicar: {
        unit: 'euro_per_t',
        value: 140.0,
      },
      energy_cost: {
        unit: 'euro_per_MWh',
        value: 170.0,
      },
      Ammoniakwasser_24_5: {
        unit: 'euro_per_t',
        value: 255.0,
      },
      Harnstoff_40: {
        unit: 'euro_per_t',
        value: 265.0,
      },
      CaOH2: {
        unit: 'euro_per_t',
        value: 275.0,
      },
      SorbacalCDS: {
        unit: 'euro_per_t',
        value: 325.0,
      },
      SorbacalSP: {
        unit: 'euro_per_t',
        value: 330.0,
      },
      SorbacalSPS: {
        unit: 'euro_per_t',
        value: 350.0,
      },
      NaHCO3: {
        unit: 'euro_per_t',
        value: 560.0,
      },
      Aktivkohle: {
        unit: 'euro_per_t',
        value: 800.0,
      },
      Aktivkohle_bromiert: {
        unit: 'euro_per_t',
        value: 2000.0,
      },
    },
    Südeuropa: {
      water_cost: {
        unit: 'euro_per_m3',
        value: 1.0,
      },
      Staub: {
        unit: 'euro_per_t',
        value: 120.0,
      },
      Staub_Kalkhydrat: {
        unit: 'euro_per_t',
        value: 120.0,
      },
      gas_cost: {
        unit: 'euro_per_MWh',
        value: 120.0,
      },
      Staub_Bicar: {
        unit: 'euro_per_t',
        value: 140.0,
      },
      energy_cost: {
        unit: 'euro_per_MWh',
        value: 170.0,
      },
      Ammoniakwasser_24_5: {
        unit: 'euro_per_t',
        value: 255.0,
      },
      Harnstoff_40: {
        unit: 'euro_per_t',
        value: 265.0,
      },
      CaOH2: {
        unit: 'euro_per_t',
        value: 275.0,
      },
      SorbacalCDS: {
        unit: 'euro_per_t',
        value: 325.0,
      },
      SorbacalSP: {
        unit: 'euro_per_t',
        value: 330.0,
      },
      SorbacalSPS: {
        unit: 'euro_per_t',
        value: 350.0,
      },
      NaHCO3: {
        unit: 'euro_per_t',
        value: 505.0,
      },
      Aktivkohle: {
        unit: 'euro_per_t',
        value: 800.0,
      },
      Aktivkohle_bromiert: {
        unit: 'euro_per_t',
        value: 2000.0,
      },
    },
    BeNeLux: {
      water_cost: {
        unit: 'euro_per_m3',
        value: 1.0,
      },
      gas_cost: {
        unit: 'euro_per_MWh',
        value: 120.0,
      },
      Staub: {
        unit: 'euro_per_t',
        value: 120.0,
      },
      Staub_Kalkhydrat: {
        unit: 'euro_per_t',
        value: 120.0,
      },
      Staub_Bicar: {
        unit: 'euro_per_t',
        value: 140.0,
      },
      energy_cost: {
        unit: 'euro_per_MWh',
        value: 170.0,
      },
      Ammoniakwasser_24_5: {
        unit: 'euro_per_t',
        value: 255.0,
      },
      Harnstoff_40: {
        unit: 'euro_per_t',
        value: 265.0,
      },
      CaOH2: {
        unit: 'euro_per_t',
        value: 275.0,
      },
      SorbacalCDS: {
        unit: 'euro_per_t',
        value: 325.0,
      },
      SorbacalSP: {
        unit: 'euro_per_t',
        value: 330.0,
      },
      SorbacalSPS: {
        unit: 'euro_per_t',
        value: 350.0,
      },
      NaHCO3: {
        unit: 'euro_per_t',
        value: 505.0,
      },
      Aktivkohle: {
        unit: 'euro_per_t',
        value: 800.0,
      },
      Aktivkohle_bromiert: {
        unit: 'euro_per_t',
        value: 2000.0,
      },
    },
    Frankreich: {
      water_cost: {
        unit: 'euro_per_m3',
        value: 1.0,
      },
      Staub: {
        unit: 'euro_per_t',
        value: 120.0,
      },
      Staub_Kalkhydrat: {
        unit: 'euro_per_t',
        value: 120.0,
      },
      gas_cost: {
        unit: 'euro_per_MWh',
        value: 120.0,
      },
      Staub_Bicar: {
        unit: 'euro_per_t',
        value: 140.0,
      },
      energy_cost: {
        unit: 'euro_per_MWh',
        value: 170.0,
      },
      Ammoniakwasser_24_5: {
        unit: 'euro_per_t',
        value: 255.0,
      },
      Harnstoff_40: {
        unit: 'euro_per_t',
        value: 265.0,
      },
      CaOH2: {
        unit: 'euro_per_t',
        value: 275.0,
      },
      SorbacalCDS: {
        unit: 'euro_per_t',
        value: 325.0,
      },
      SorbacalSP: {
        unit: 'euro_per_t',
        value: 330.0,
      },
      SorbacalSPS: {
        unit: 'euro_per_t',
        value: 350.0,
      },
      NaHCO3: {
        unit: 'euro_per_t',
        value: 530.0,
      },
      Aktivkohle: {
        unit: 'euro_per_t',
        value: 800.0,
      },
      Aktivkohle_bromiert: {
        unit: 'euro_per_t',
        value: 2000.0,
      },
    },
  },
  'sorbensReactor.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M13.6751 27.8131C13.1228 27.8131 12.6751 28.2608 12.6751 28.8131V57.8914C12.6751 58.1025 12.7419 58.3082 12.866 58.479L24.397 74.3578C24.7963 74.9077 25.616 74.9077 26.0153 74.3578L37.5463 58.479C37.6703 58.3082 37.7371 58.1025 37.7371 57.8914V28.8131C37.7371 28.2608 37.2894 27.8131 36.7371 27.8131H13.6751Z" fill="#0095DB"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M7.43018 23.7239C7.43018 23.0855 7.9477 22.568 8.58609 22.568H33.6481C34.2865 22.568 34.804 23.0855 34.804 23.7239V54.127C34.804 54.371 34.7268 54.6088 34.5834 54.8062L22.0524 72.0621C21.8349 72.3615 21.4872 72.5388 21.1171 72.5388C20.747 72.5388 20.3993 72.3615 20.1818 72.0621L7.65078 54.8062C7.5074 54.6088 7.43018 54.371 7.43018 54.127V23.7239ZM9.742 24.8798V53.7516L21.1171 69.4157L32.4922 53.7516V24.8798H9.742Z" fill="#0095DB"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M63.5577 14.2851C63.8405 14.5434 63.8603 14.9821 63.6019 15.2649L47.6944 32.6754V78.6765V79.1646H47.0009H21.1171H20.4236V78.6765V76.425C20.4236 76.042 20.7341 75.7315 21.1171 75.7315C21.5002 75.7315 21.8107 76.042 21.8107 76.425V77.7775H46.3073V32.1371L62.5779 14.3293C62.8362 14.0465 63.2749 14.0267 63.5577 14.2851Z" fill="#00569D"/>\n<path d="M94.7342 13.5123C95.1419 13.8571 95.7376 13.8613 96.15 13.5224L103.083 7.82461H115.674V26.3535H111.989C111.379 26.3535 110.884 26.8484 110.884 27.459V77.9238H95.4153H79.8155V20.8853C79.8155 20.2748 79.3205 19.7798 78.71 19.7798H66.9394V7.82461H88.0095L94.7342 13.5123Z" fill="#0094DA" fill-opacity="0.2" stroke="#0095DB" stroke-width="2.21098" stroke-linejoin="round"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M96.7608 14.557C96.868 14.4932 96.9716 14.4207 97.0705 14.3395L103.606 8.97314H114.28V24.6611H111.997C110.616 24.6611 109.497 25.7804 109.497 27.1611V76.1022H95.4512H81.2739V20.6039C81.2739 19.2232 80.1547 18.1039 78.7739 18.1039H68.4194V8.97314H87.5471L93.8703 14.3169C93.9936 14.421 94.1244 14.5114 94.2608 14.588L94.2608 65.6559C94.2608 66.3463 94.8205 66.9059 95.5108 66.9059C96.2012 66.9059 96.7608 66.3463 96.7608 65.6559L96.7608 14.557ZM114.28 6.47314H102.711L95.484 12.4074L88.462 6.47314H68.4194H65.9194V8.97314V18.1039V20.6039H68.4194H76.2739H78.7739V23.1039V76.1022V78.6022H81.2739H95.4512H109.497H111.997V76.1022V29.6611V27.1611H114.28H114.497H116.78V24.6611V8.97314V6.47314H114.28Z" fill="#0095DB"/>\n</svg>\n',
  'cyclone.svg':
    '<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path opacity="0.2" d="M18.2728 27.5C17.8782 27.5 17.4998 27.658 17.2209 27.9393C16.9419 28.2206 16.7852 28.6022 16.7852 29V56C16.7852 56.363 16.9161 56.714 17.1521 56.988L44.5538 88.564V106C44.5538 106.398 44.7105 106.779 44.9895 107.061C45.2684 107.342 45.6468 107.5 46.0414 107.5H66.8678C67.2623 107.5 67.6407 107.342 67.9197 107.061C68.1987 106.779 68.3554 106.398 68.3554 106V88.564L95.7561 56.988C95.993 56.7143 96.1234 56.3633 96.123 56V29C96.123 28.6022 95.9663 28.2206 95.6873 27.9393C95.4083 27.658 95.0299 27.5 94.6354 27.5H18.2728Z" fill="#0095DB"/>\n<path d="M51.7602 8L48.897 13H54.6233L51.7602 8ZM52.2561 14.56V13.55H51.2643V14.56H52.2561ZM52.2561 16.578V15.568H51.2643V16.578H52.2561ZM52.2561 18.596V17.587H51.2643V18.597L52.2561 18.596ZM52.2561 20.615V19.605H51.2643V20.615H52.2561ZM52.2561 22.633V21.623H51.2643V22.633H52.2561ZM52.2561 24.651V23.642H51.2643V24.652H52.2561V24.651ZM52.2561 26.67V25.66H51.2643V26.67H52.2561ZM52.2561 28.688V27.678H51.2643V28.688H52.2561ZM52.2561 30.706V29.697H51.2643V30.707H52.2561V30.706ZM52.2561 32.725V31.715H51.2643V32.725H52.2561ZM25.6528 33.444C25.4507 33.4433 25.2491 33.4651 25.0518 33.509L25.2689 34.485C25.385 34.459 25.5129 34.445 25.6528 34.445H26.1357V33.445H25.6537L25.6528 33.444ZM28.0637 33.444H27.0997V34.444H28.0637V33.444ZM29.9926 33.444H29.0286V34.444H29.9926V33.444ZM31.9215 33.444H30.9566V34.444H31.9215V33.444ZM33.8494 33.444H32.8855V34.444H33.8494V33.444ZM35.7784 33.444H34.8144V34.444H35.7784V33.444ZM37.7073 33.444H36.7423V34.444H37.7073V33.444Z" fill="#0095DB"/>\n<path d="M39.5948 33.444H38.6715V34.444H39.5938V39.78L38.7012 39.632L38.5406 40.619L39.5244 40.782L39.5938 40.355V52C39.5938 52.3978 39.7505 52.7794 40.0295 53.0607C40.3085 53.342 40.6868 53.5 41.0814 53.5C41.4759 53.5 41.8543 53.342 42.1333 53.0607C42.4123 52.7794 42.569 52.3978 42.569 52V41.288L43.3683 41.421L43.529 40.434L42.5829 40.277L42.57 40.356V16C42.57 15.6022 42.4132 15.2206 42.1343 14.9393C41.8553 14.658 41.4769 14.5 41.0824 14.5C40.6878 14.5 40.3095 14.658 40.0305 14.9393C39.7515 15.2206 39.5948 15.6022 39.5948 16V23.5H13.3138C12.9192 23.5 12.5409 23.658 12.2619 23.9393C11.9829 24.2206 11.8262 24.6022 11.8262 25V52C11.8262 52.363 11.9571 52.714 12.1931 52.988L39.5948 84.564V102C39.5948 102.398 39.7515 102.779 40.0305 103.061C40.3095 103.342 40.6878 103.5 41.0824 103.5C41.4769 103.5 41.8553 103.342 42.1343 103.061C42.4132 102.779 42.57 102.398 42.57 102V84C42.5701 83.6366 42.4393 83.2855 42.202 83.012L14.8004 51.436V26.5H39.5938L39.5948 33.444ZM63.3964 34.444H64.3882V33.444H63.3964V26.5H104.553C104.948 26.5 105.326 26.342 105.605 26.0607C105.884 25.7794 106.041 25.3978 106.041 25C106.041 24.6022 105.884 24.2206 105.605 23.9393C105.326 23.658 104.948 23.5 104.553 23.5H63.3964V16C63.3964 15.6022 63.2397 15.2206 62.9607 14.9393C62.6817 14.658 62.3034 14.5 61.9088 14.5C61.5143 14.5 61.1359 14.658 60.8569 14.9393C60.5779 15.2206 60.4212 15.6022 60.4212 16V43.24L59.6229 43.107L59.4612 44.094L60.4083 44.251L60.4212 44.171V52C60.4212 52.3978 60.5779 52.7794 60.8569 53.0607C61.1359 53.342 61.5143 53.5 61.9088 53.5C62.3034 53.5 62.6817 53.342 62.9607 53.0607C63.2397 52.7794 63.3964 52.3978 63.3964 52V44.748L64.1184 44.868L64.2791 43.881L63.3964 43.734V34.444Z" fill="#0095DB"/>\n<path d="M65.3806 34.4438H66.3724V33.4438H65.3806V34.4438ZM67.3641 34.4438H68.3559V33.4438H67.3641V34.4438ZM69.3476 34.4438H70.3393V33.4438H69.3476V34.4438ZM71.3311 34.4438H72.3228V33.4438H71.3311V34.4438ZM73.3145 34.4438H74.3063V33.4438H73.3145V34.4438ZM75.298 34.4438H76.2897V33.4438H75.298V34.4438ZM77.2815 34.4438H78.2732V33.4438H77.2815V34.4438ZM79.2649 34.4438H80.2567V33.4438H79.2649V34.4438ZM81.2484 34.4438H82.2402V33.4438H81.2484V34.4438ZM83.2319 34.4438H84.2236V33.4438H83.2319V34.4438ZM85.2154 34.4438H86.2071V33.4438H85.2154V34.4438ZM87.1988 34.4438H88.1906V33.4438H87.1988V34.4438ZM89.1823 34.4438H90.174V33.4438H89.1823V34.4438ZM91.1658 34.4438H92.1575V33.4438H91.1658V34.4438ZM93.1492 34.4438H94.141V33.4438H93.1492V34.4438ZM95.1327 34.4438H96.1245V33.4438H95.1327V34.4438ZM97.1162 34.4438H98.1079V33.4438H97.1162V34.4438ZM99.0997 34.4438H100.091V33.4438H99.0997V34.4438ZM101.083 34.4438H102.075V33.4438H101.083V34.4438ZM103.067 34.4438H104.058V33.4438H103.067V34.4438ZM105.05 34.4438H106.042V33.4438H105.05V34.4438ZM107.034 34.4438H108.025V33.4438H107.034V34.4438ZM109.017 34.4438H110.009V33.4438H109.017V34.4438ZM52.257 34.7428V33.7328H51.2653V34.7428H52.257ZM23.9549 34.0878C23.652 34.3761 23.4271 34.7375 23.3013 35.1378L24.2454 35.4448C24.3195 35.2064 24.4526 34.991 24.6322 34.8188L23.9549 34.0878ZM52.257 36.7608V35.7518H51.2653V36.7618L52.257 36.7608ZM23.2031 36.3528C23.2626 36.7578 23.4183 37.1558 23.6792 37.4958L24.4646 36.8858C24.3154 36.6868 24.2188 36.4528 24.184 36.2058L23.2031 36.3528ZM24.6689 38.2478C24.8494 38.3218 25.0438 38.3758 25.2511 38.4108L25.743 38.4928L25.9046 37.5058L25.4127 37.4238C25.285 37.4034 25.16 37.3688 25.0398 37.3208L24.6689 38.2478ZM26.7278 38.6558L27.7125 38.8198L27.8732 37.8328L26.8894 37.6688L26.7278 38.6558ZM52.257 38.7798V37.7698H51.2653V38.7798H52.257ZM28.6963 38.9828L29.6811 39.1468L29.8418 38.1598L28.858 37.9968L28.6963 38.9828ZM30.6649 39.3098L31.6497 39.4738L31.8114 38.4868L30.8266 38.3238L30.6649 39.3098ZM32.6345 39.6368L33.6193 39.8008L33.78 38.8138L32.7962 38.6508L32.6345 39.6368ZM34.6031 39.9638L35.5879 40.1278L35.7486 39.1408L34.7648 38.9778L34.6031 39.9638ZM36.5727 40.2908L37.5565 40.4548L37.7182 39.4678L36.7334 39.3048L36.5727 40.2908ZM52.257 40.7978V39.7878H51.2653V40.7978H52.257ZM44.3152 41.5778L45.2623 41.7348L45.423 40.7478L44.4768 40.5908L44.3152 41.5778ZM46.2084 41.8918L47.1555 42.0498L47.3172 41.0628L46.3701 40.9058L46.2084 41.8918ZM48.1016 42.2068L49.0487 42.3638L49.2104 41.3778L48.2633 41.2198L48.1016 42.2068ZM49.9959 42.5208L50.942 42.6788L51.1036 41.6918L50.1565 41.5348L49.9959 42.5208ZM52.257 41.8068V41.8838L52.9968 42.0068L52.8352 42.9928L51.8891 42.8358L51.8921 42.8158H51.2653V41.8068H52.257ZM53.7823 43.1498L54.7284 43.3078L54.8901 42.3208L53.943 42.1638L53.7823 43.1498ZM55.6755 43.4648L56.6216 43.6218L56.7833 42.6358L55.8362 42.4778L55.6755 43.4648ZM57.5687 43.7798L58.5149 43.9368L58.6765 42.9498L57.7304 42.7928L57.5687 43.7798ZM52.257 44.8348V43.8248H51.2653V44.8348H52.257ZM65.0355 45.0198L65.9509 45.1718L66.1125 44.1848L65.1962 44.0328L65.0355 45.0198ZM66.8673 45.3238L67.7836 45.4758L67.9443 44.4898L67.0289 44.3368L66.8673 45.3238ZM68.7 45.6288L69.6154 45.7808L69.777 44.7938L68.8606 44.6418L68.7 45.6288ZM70.5327 45.9328L71.4481 46.0848L71.6087 45.0988L70.6934 44.9458L70.5327 45.9328ZM72.3644 46.2368L73.2798 46.3898L73.4415 45.4028L72.5251 45.2508L72.3644 46.2368ZM74.1962 46.5418L74.6544 46.6178C74.7932 46.6408 74.9172 46.6758 75.0273 46.7208L75.3982 45.7938C75.2107 45.7181 75.0154 45.6634 74.816 45.6308L74.3578 45.5548L74.1962 46.5418ZM52.257 46.8528V45.8428H51.2653V46.8528H52.257ZM75.6025 47.1548C75.7512 47.3498 75.8454 47.5848 75.8831 47.8368L76.8639 47.6888C76.8044 47.2729 76.6405 46.8791 76.3879 46.5448L75.6025 47.1548ZM52.257 48.8708V47.8618H51.2653V48.8718H52.257V48.8708ZM75.8216 48.5968C75.7476 48.8353 75.6145 49.0507 75.4349 49.2228L76.1122 49.9528C76.4147 49.6644 76.6393 49.3031 76.7648 48.9028L75.8216 48.5968ZM74.7972 49.5568C74.6708 49.5844 74.5417 49.5979 74.4124 49.5968H73.8917V50.5968H74.4124C74.6226 50.5968 74.824 50.5758 75.0134 50.5328L74.7972 49.5568ZM32.5006 49.5978C32.2982 49.5971 32.0963 49.6189 31.8987 49.6628L32.1159 50.6388C32.2319 50.6128 32.3598 50.5978 32.5006 50.5978H33.0362V49.5978H32.5006ZM35.1823 49.5978H34.1102V50.5978H35.1823V49.5978ZM37.3284 49.5978H36.2554V50.5978H37.3284V49.5978ZM39.4735 49.5978H38.4005V50.5978H39.4735V49.5978ZM64.5139 49.5978H63.4725V50.5978H64.5139V49.5978ZM66.5985 49.5978H65.5562V50.5978H66.5975L66.5985 49.5978ZM68.6821 49.5978H67.6408V50.5978H68.6821V49.5978ZM70.7658 49.5978H69.7244V50.5978H70.7658V49.5978ZM72.8494 49.5978H71.8081V50.5978H72.8494V49.5978ZM52.257 50.8898V49.8798H51.2653V50.8898H52.257ZM30.7998 50.2428C30.4971 50.5318 30.2725 50.8939 30.1473 51.2948L31.0914 51.6008C31.1687 51.3578 31.2997 51.1408 31.4782 50.9728L30.7998 50.2428ZM52.257 52.9078V51.8978H51.2653V52.9078H52.257ZM30.0501 52.5108C30.1106 52.9158 30.2673 53.3138 30.5281 53.6548L31.3125 53.0428C31.1628 52.8437 31.0658 52.6093 31.0309 52.3618L30.0501 52.5108ZM31.5208 54.4038C31.7023 54.4778 31.8977 54.5318 32.1049 54.5658L32.5929 54.6458L32.7516 53.6578L32.2626 53.5778C32.135 53.5577 32.0099 53.5235 31.8897 53.4758L31.5208 54.4038ZM33.5687 54.8048L34.5446 54.9638L34.7033 53.9768L33.7274 53.8168L33.5687 54.8048ZM52.257 54.9258V53.9168H51.2653V54.9268L52.257 54.9258ZM35.5205 55.1228L36.4973 55.2828L36.656 54.2948L35.6792 54.1358L35.5205 55.1228ZM37.4732 55.4418L38.4491 55.6018L38.6078 54.6138L37.6309 54.4538L37.4732 55.4418ZM39.4249 55.7598L40.4008 55.9198L40.5595 54.9328L39.5836 54.7728L39.4249 55.7598ZM41.3777 56.0788L42.3535 56.2388L42.5122 55.2508L41.5354 55.0908L41.3777 56.0788ZM43.3294 56.3978L44.3053 56.5568L44.464 55.5698L43.4881 55.4098L43.3294 56.3978ZM45.2811 56.7158L46.258 56.8758L46.4167 55.8878L45.4398 55.7288L45.2811 56.7158ZM52.257 56.9448V56.9418L52.2729 56.8438L52.257 56.8418V55.9348H51.2653V56.8798L51.1383 57.6718L52.1142 57.8318L52.257 56.9448ZM47.2339 57.0348L48.2097 57.1938L48.3684 56.2068L47.3925 56.0468L47.2339 57.0348ZM49.1856 57.3528L50.1625 57.5128L50.3211 56.5258L49.3443 56.3658L49.1856 57.3528ZM53.0901 57.9898L54.0659 58.1498L54.2246 57.1628L53.2487 57.0028L53.0901 57.9898ZM55.0418 58.3098L56.0187 58.4678L56.1773 57.4808L55.2005 57.3208L55.0418 58.3088V58.3098ZM56.9945 58.6278L57.9704 58.7868L58.1291 57.7998L57.1532 57.6398L56.9945 58.6278ZM52.257 58.9628V57.9528H51.2653V58.9628H52.257ZM58.9463 58.9458L59.9231 59.1058L60.0818 58.1178L59.1049 57.9588L58.9463 58.9458ZM60.899 59.2648L61.3869 59.3448C61.5258 59.3668 61.6497 59.4018 61.7608 59.4468L62.1287 58.5188C61.9409 58.4434 61.7453 58.389 61.5456 58.3568L61.0577 58.2768L60.899 59.2648ZM62.337 59.8798C62.4858 60.0738 62.581 60.3098 62.6187 60.5608L63.6005 60.4108C63.5402 59.995 63.3757 59.6016 63.1225 59.2678L62.337 59.8798ZM52.257 60.9808V59.9718H51.2653V60.9818L52.257 60.9808ZM62.5592 61.3218C62.4808 61.5648 62.3499 61.7818 62.1724 61.9498L62.8497 62.6798C63.1525 62.3909 63.3771 62.0288 63.5023 61.6278L62.5582 61.3218H62.5592ZM52.257 62.9998V61.9898H51.2653V62.3248H51.1264V63.3248H52.0805V62.9998H52.257ZM61.5337 62.2838C61.4073 62.3118 61.2783 62.3255 61.1489 62.3248H60.6719V63.3248H61.1489C61.3592 63.3248 61.5605 63.3028 61.7509 63.2598L61.5337 62.2838ZM38.2388 62.3248C37.9879 62.3248 37.7479 62.3608 37.5238 62.4268L37.8035 63.3868C37.9363 63.3468 38.0811 63.3248 38.2398 63.3248H38.7159V62.3248H38.2388ZM40.6259 62.3248H39.6699V63.3248H40.6249L40.6259 62.3248ZM42.535 62.3248H41.58V63.3248H42.535V62.3248ZM44.4441 62.3248H43.4891V63.3248H44.4441V62.3248ZM46.3532 62.3248H45.3982V63.3248H46.3532V62.3248ZM48.2623 62.3248H47.3082V63.3248H48.2623V62.3248ZM50.1724 62.3248H49.2173V63.3248H50.1714L50.1724 62.3248ZM53.9906 62.3248H53.0355V63.3248H53.9896L53.9906 62.3248ZM55.8987 62.3248H54.9446V63.3248H55.8987V62.3248ZM57.8087 62.3248H56.8537V63.3248H57.8078L57.8087 62.3248ZM59.7178 62.3248H58.7628V63.3248H59.7168L59.7178 62.3248ZM36.3228 63.2348C36.0159 63.6159 35.8242 64.078 35.7704 64.5658L36.7562 64.6758C36.7889 64.3798 36.9069 64.0958 37.0934 63.8658L36.3228 63.2348ZM52.257 65.0178V64.0079H51.2653V65.0178H52.257ZM36.0431 65.9949C36.1542 66.2029 36.298 66.3998 36.4735 66.5798L36.8345 66.9498L37.5406 66.2468L37.1797 65.8778C37.0756 65.7725 36.9871 65.6526 36.9168 65.5219L36.0441 65.9949H36.0431ZM52.257 67.0359V66.0268H51.2653V67.0368L52.257 67.0359ZM37.5555 67.6868L38.2765 68.4239L38.9826 67.7218L38.2616 66.9848L37.5555 67.6868ZM52.257 69.0548V68.0448H51.2653V69.0548H52.257ZM38.9975 69.1609L39.7185 69.8988L40.4246 69.1968L39.7036 68.4588L38.9975 69.1609ZM40.4405 70.6358L41.1615 71.3738L41.8676 70.6708L41.1466 69.9338L40.4405 70.6358ZM52.257 71.0728V70.0629H51.2653V71.0728H52.257ZM41.8825 72.1108L42.6035 72.8478L43.3096 72.1459L42.5886 71.4088L41.8825 72.1108ZM52.257 73.0909V72.0818H51.2653V73.0919L52.257 73.0909ZM43.3244 73.5858L44.0454 74.3228L44.7516 73.6208L44.0306 72.8839L43.3244 73.5858ZM52.257 75.1098V74.0998H51.2653V75.1098H52.257ZM44.7674 75.0598L45.4884 75.7978L46.1945 75.0958L45.4735 74.3578L44.7674 75.0598ZM46.2094 76.5349L46.9304 77.2729L47.6365 76.5708L46.9155 75.8328L46.2094 76.5349ZM52.257 76.6228V76.1189H51.2653V76.6228C51.2653 76.7828 51.2425 76.9308 51.2038 77.0658L52.1549 77.3488C52.2213 77.1208 52.257 76.8788 52.257 76.6228ZM47.6514 78.0098L48.0124 78.3788C48.1899 78.5598 48.3843 78.7088 48.5906 78.8228L49.0706 77.9478C48.9409 77.875 48.8223 77.7838 48.7185 77.6768L48.3575 77.3078L47.6514 78.0098ZM50.0137 79.1148C50.5007 79.0644 50.9629 78.8731 51.3446 78.5639L50.7228 77.7838C50.4905 77.9722 50.2091 78.0889 49.9125 78.1199L50.0137 79.1148ZM82.736 41.4998C82.3415 41.4998 81.9631 41.6579 81.6841 41.9392C81.4051 42.2205 81.2484 42.602 81.2484 42.9998C81.2484 43.3977 81.4051 43.7792 81.6841 44.0605C81.9631 44.3418 82.3415 44.4998 82.736 44.4998H88.1906V51.4358L60.7889 83.0118C60.552 83.2855 60.4216 83.6366 60.422 83.9998V102C60.422 102.398 60.5787 102.779 60.8577 103.061C61.1367 103.342 61.515 103.5 61.9096 103.5C62.3041 103.5 62.6825 103.342 62.9615 103.061C63.2404 102.779 63.3972 102.398 63.3972 102V84.5639L90.7978 52.9878C91.0348 52.7142 91.1651 52.3631 91.1648 51.9998V44.4998H104.554C104.949 44.4998 105.327 44.3418 105.606 44.0605C105.885 43.7792 106.042 43.3977 106.042 42.9998C106.042 42.602 105.885 42.2205 105.606 41.9392C105.327 41.6579 104.949 41.4998 104.554 41.4998H82.736Z" fill="#0095DB"/>\n</svg>\n',
  'inputStream.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'stream',
        type: 'TITLE',
      },
      {
        name: 'primaryData',
        type: 'SUBTITLE',
      },
      {
        name: 'flow',
        type: 'INPUT',
        inputType: 'number',
        units: ['VolumeFlow', 'MassFlow_kgX'],
      },
      {
        name: 'pressure',
        type: 'INPUT',
        inputType: 'number',
        units: ['Pressure'],
      },
      {
        name: 'temperature',
        type: 'INPUT',
        inputType: 'number',
        units: ['Temperature'],
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'gasComponentsSubtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'gasComponents',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'air',
            items: [
              {
                name: 'gasComponentUnits_air',
                type: 'INPUT',
                inputType: 'select',
                options: ['volumePercent'],
                default: 'vol_tr',
                disabled: true,
              },
              {
                name: 'N2_air',
                type: 'INPUT',
                inputType: 'number',
                default: 78.12,
                disabled: true,
              },
              {
                name: 'O2_air',
                type: 'INPUT',
                inputType: 'number',
                default: 20.96,
                disabled: true,
              },
              {
                name: 'Ar_air',
                type: 'INPUT',
                inputType: 'number',
                default: 0.92,
                disabled: true,
              },
            ],
          },
          {
            name: 'notAir',
            checked: true,
            items: [
              {
                name: 'gasComponentUnits',
                type: 'INPUT',
                inputType: 'select',
                options: ['massPercent', 'volumePercent'],
              },
              {
                name: 'O2',
                type: 'INPUT',
                inputType: 'number',
              },
              {
                name: 'H2O',
                type: 'INPUT',
                inputType: 'number',
              },
              {
                name: 'CO2',
                type: 'INPUT',
                inputType: 'number',
              },
            ],
          },
        ],
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'concentrations',
        type: 'LIST',
        importance: 'optional',
        initItemCount: 0,
        maxItemCount: 10,
        listItems: [
          {
            name: 'loadSpecies',
            type: 'INPUT',
            inputType: 'search',
            data: ['speciesSearch'],
          },
          {
            name: 'loadValue',
            type: 'INPUT',
            inputType: 'number',
            units: [
              'ConcentrationMass',
              'ConcentrationMassPercent',
              'ConcentrationVolumePercent',
              'ConcentrationVolumePercentDry',
              'Concentration',
              'ConcentrationVolumePpm',
            ],
          },
        ],
      },
    ],
  },
  'uit103_MultiSelect.json': {
    items: [
      {
        name: '103_MultiSelect',
        type: 'TITLE',
      },
      {
        name: 'EINS',
        type: 'INPUT',
        inputType: 'multi-select',
        options: ['categories'],
      },
      {
        name: 'ZWEI',
        type: 'INPUT',
        inputType: 'multi-select',
        options: ['optionSingleElement'],
      },
      {
        name: 'DREI',
        type: 'INPUT',
        inputType: 'multi-select',
        options: ['categories'],
        default: ['fipp', 'fim'],
      },
      {
        name: 'VIER',
        type: 'INPUT',
        inputType: 'multi-select',
        options: ['categories'],
        disabled: true,
        default: ['fipp'],
      },
      {
        name: 'FÜNF',
        type: 'INPUT',
        inputType: 'multi-select',
        disabled: false,
        options: ['categories'],
      },
      {
        name: 'SECHS',
        type: 'INPUT',
        inputType: 'multi-select',
        options: ['categories'],
        importance: 'optional',
      },
      {
        name: 'SIEBEN',
        type: 'INPUT',
        inputType: 'multi-select',
        importance: 'mandatory',
        options: ['categories'],
      },
      {
        name: 'ACHT',
        type: 'INPUT',
        inputType: 'multi-select',
        options: ['optionSingleElement', 'categories'],
      },
      {
        name: 'NEUN',
        type: 'INPUT',
        inputType: 'multi-select',
        options: ['categories'],
        default: ['fipp'],
      },
    ],
  },
  'uit301_RadioInList_1.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'fua.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'targetValues',
        type: 'SUBTITLE',
      },
      {
        name: 'dustSeparation',
        type: 'INPUT',
        inputType: 'number',
        units: ['Percent'],
        default: 30,
        defaultUnit: 'percent',
        disabled: true,
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'productSelectionSubtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'autoDirectRadio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'auto',
            checked: true,
          },
          {
            name: 'direct',
            items: [
              {
                name: 'productKeyInput',
                type: 'INPUT',
                inputType: 'select',
                options: ['products'],
              },
            ],
          },
        ],
      },
    ],
  },
  'eFilter.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M35.8774 10.9625C35.1285 10.9625 34.5213 11.5697 34.5213 12.3186V24.9141H21.9258C21.1768 24.9141 20.5697 25.5213 20.5697 26.2702V28.6374L15.1271 34.3957C14.8891 34.6474 14.7565 34.9807 14.7565 35.3272V47.4651C14.7565 47.7253 14.8314 47.9801 14.9722 48.1989L20.5697 56.8974V59.9867C20.5697 60.2022 20.6211 60.4147 20.7196 60.6065L31.474 81.5339C31.7063 81.986 32.1719 82.2702 32.6802 82.2702C33.1884 82.2702 33.654 81.986 33.8863 81.5339L43.4345 62.9536L52.9828 81.5339C53.2151 81.986 53.6807 82.2702 54.1889 82.2702C54.6972 82.2702 55.1628 81.986 55.3951 81.5339L64.9433 62.9536L74.4915 81.5339C74.7238 81.986 75.1894 82.2702 75.6977 82.2702C76.2059 82.2702 76.6715 81.986 76.9038 81.5339L86.4521 62.9536L96.0003 81.5339C96.2326 81.986 96.6982 82.2702 97.2064 82.2702C97.7147 82.2702 98.1803 81.986 98.4126 81.5339L109.167 60.6065C109.266 60.4147 109.317 60.2022 109.317 59.9867V56.8974L114.914 48.1989C115.055 47.9801 115.13 47.7253 115.13 47.4651V35.3272C115.13 34.9807 114.997 34.6474 114.76 34.3957L109.317 28.6374V26.2702C109.317 25.5213 108.71 24.9141 107.961 24.9141H49.4412V12.3186C49.4412 11.5697 48.834 10.9625 48.0851 10.9625H35.8774Z" fill="#0095DB"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M29.0659 5.08607C29.0659 4.32 29.6869 3.69897 30.453 3.69897H42.6607C43.4267 3.69897 44.0477 4.32 44.0477 5.08607V17.6506H102.536C103.302 17.6506 103.923 18.2716 103.923 19.0377V21.3925L109.358 27.1418C109.601 27.3993 109.737 27.7403 109.737 28.0946V40.2325C109.737 40.4987 109.66 40.7593 109.516 40.9832L103.923 49.6739V52.7541C103.923 52.9746 103.871 53.192 103.77 53.3881L93.0157 74.3156C92.7781 74.7779 92.3019 75.0687 91.782 75.0687C91.2621 75.0687 90.7859 74.7779 90.5483 74.3156L81.0276 55.7889L71.507 74.3156C71.2693 74.7779 70.7931 75.0687 70.2732 75.0687C69.7534 75.0687 69.2771 74.7779 69.0395 74.3156L59.5189 55.7889L49.9982 74.3156C49.7606 74.7779 49.2844 75.0687 48.7645 75.0687C48.2446 75.0687 47.7684 74.7779 47.5308 74.3156L38.0101 55.7889L28.4895 74.3156C28.2518 74.7779 27.7756 75.0687 27.2557 75.0687C26.7359 75.0687 26.2596 74.7779 26.022 74.3156L15.2676 53.3881C15.1668 53.192 15.1143 52.9746 15.1143 52.7541V49.6739L9.52173 40.9832C9.37768 40.7593 9.30109 40.4987 9.30109 40.2325V28.0946C9.30109 27.7403 9.43671 27.3993 9.68012 27.1418L15.1143 21.3925V19.0377C15.1143 18.2716 15.7353 17.6506 16.5014 17.6506H29.0659V5.08607ZM31.8401 6.47317V19.0377C31.8401 19.8038 31.2191 20.4248 30.453 20.4248H17.8885V21.9443C17.8885 22.2986 17.7528 22.6396 17.5094 22.8971L12.0753 28.6464V39.8248L17.6678 48.5156C17.8119 48.7395 17.8885 49 17.8885 49.2662V52.4186L27.2557 70.6468L36.7764 52.1201C37.014 51.6577 37.4902 51.367 38.0101 51.367C38.53 51.367 39.0062 51.6577 39.2438 52.1201L48.7645 70.6468L58.2851 52.1201C58.5228 51.6577 58.999 51.367 59.5189 51.367C60.0387 51.367 60.515 51.6577 60.7526 52.1201L70.2732 70.6468L79.7939 52.1201C80.0315 51.6577 80.5077 51.367 81.0276 51.367C81.5475 51.367 82.0237 51.6577 82.2613 52.1201L91.782 70.6468L101.149 52.4186V49.2662C101.149 49 101.226 48.7395 101.37 48.5156L106.962 39.8248V28.6464L101.528 22.8971C101.285 22.6396 101.149 22.2986 101.149 21.9443V20.4248H42.6607C41.8946 20.4248 41.2736 19.8038 41.2736 19.0377V6.47317H31.8401Z" fill="#0095DB"/>\n<g clip-path="url(#clip0_1862_13075)">\n<path d="M40.059 27.5872L33.0263 38.3559C32.5934 39.0271 33.1711 39.8967 33.9584 39.7623L41.3712 38.5228L38.657 45.7218C38.5347 46.0513 38.6644 46.4282 38.9702 46.6048C39.31 46.8009 39.7322 46.6974 39.9397 46.3641L46.9724 35.5955C47.4053 34.9243 46.8276 34.0547 46.0403 34.189L38.6274 35.4286L41.3416 28.2296C41.4639 27.9001 41.3342 27.5231 41.0284 27.3466C40.8676 27.2515 40.6758 27.2234 40.4944 27.2684C40.3131 27.3134 40.1567 27.4279 40.059 27.5872Z" fill="#0095DB"/>\n</g>\n<defs>\n<clipPath id="clip0_1862_13075">\n<rect width="22.1935" height="22.1935" fill="white" transform="translate(26.4086 29.129) rotate(-15)"/>\n</clipPath>\n</defs>\n</svg>\n',
  'uit001_nestedSolutions.json': {
    items: [
      {
        name: 'MyTitle',
        type: 'TITLE',
      },
      {
        name: 'myInput',
        type: 'INPUT',
        inputType: 'number',
        default: 3,
        disabled: true,
      },
    ],
  },
  'uit102_Select.json': {
    items: [
      {
        name: '102_Select',
        type: 'TITLE',
      },
      {
        name: 'EINS',
        type: 'INPUT',
        inputType: 'select',
        options: ['option1'],
      },
      {
        name: 'ZWEI',
        type: 'INPUT',
        inputType: 'select',
        options: ['optionSingleElement'],
        default: 'singleElement',
      },
      {
        name: 'DREI',
        type: 'INPUT',
        inputType: 'select',
        options: ['option1'],
        default: 'element1',
      },
      {
        name: 'VIER',
        type: 'INPUT',
        inputType: 'select',
        options: ['option1'],
        disabled: true,
        default: 'element1',
      },
      {
        name: 'FÜNF',
        type: 'INPUT',
        inputType: 'select',
        disabled: false,
        options: ['option1'],
      },
      {
        name: 'SECHS',
        type: 'INPUT',
        inputType: 'select',
        options: ['emptyOption', 'option1'],
        importance: 'optional',
      },
      {
        name: 'SIEBEN',
        type: 'INPUT',
        inputType: 'select',
        importance: 'mandatory',
        options: ['option1'],
      },
      {
        name: 'ACHT',
        type: 'INPUT',
        inputType: 'select',
        options: ['option1', 'optionSingleElement'],
      },
    ],
  },
  'uit103_MultiSelect.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'bagFilter.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'targetValues',
        type: 'SUBTITLE',
      },
      {
        name: 'FFB',
        type: 'INPUT',
        inputType: 'number',
        units: ['FFB'],
      },
      {
        name: 'dustOut',
        type: 'INPUT',
        inputType: 'number',
        units: ['Concentration_g', 'Concentration_mg', 'AdditiveUnit_kgh'],
        defaultUnit: 'mg_Nm3_tr_betrO2',
        default: 2,
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'verluste_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'tempVerlust_input',
        type: 'INPUT',
        inputType: 'number',
        units: ['Temperature'],
        default: 5,
        defaultUnit: 'gradC',
      },
      {
        name: 'pressVerlust_input',
        type: 'INPUT',
        inputType: 'number',
        units: ['PressureAbs'],
        default: 1400,
        defaultUnit: 'Pa_abs',
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'filterSelection',
        type: 'SUBTITLE',
      },
      {
        name: 'preSelection',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'noSelection',
            checked: true,
          },
          {
            name: 'productKey',
            items: [
              {
                name: 'productKeyInput',
                type: 'INPUT',
                inputType: 'text',
              },
            ],
          },
          {
            name: 'filterParameters',
            items: [
              {
                name: 'category',
                type: 'INPUT',
                inputType: 'multi-select',
                options: ['categories'],
                importance: 'optional',
                default: ['fi pp', 'fi m'],
              },
              {
                name: 'maxHoseLength',
                type: 'INPUT',
                inputType: 'number',
                hoverText: 'maxHoseLength_hover',
                units: ['Length'],
                importance: 'optional',
              },
              {
                name: 'maxWidth',
                type: 'INPUT',
                inputType: 'number',
                units: ['Length'],
                importance: 'optional',
              },
              {
                name: 'maxDepth',
                type: 'INPUT',
                inputType: 'number',
                units: ['Length'],
                importance: 'optional',
              },
            ],
          },
        ],
      },
    ],
  },
  'uit302_RadioInList_2.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'uit303_ListinList.json': {
    items: [
      {
        name: '303_ListinList',
        type: 'TITLE',
      },
      {
        name: 'EINS',
        type: 'LIST',
        initItemCount: 0,
        maxItemCount: 5,
        listItems: [
          {
            name: 'eins_select',
            type: 'INPUT',
            inputType: 'select',
            options: ['massPercent', 'volumePercent'],
          },
          {
            name: 'eins_search',
            type: 'INPUT',
            inputType: 'search',
            data: ['opex_AdditivSearch', 'opex_EntsorgungSearch'],
          },
          {
            name: 'eins_List',
            type: 'LIST',
            initItemCount: 0,
            maxItemCount: 2,
            listItems: [
              {
                name: 'eins_List_Input1',
                type: 'INPUT',
                inputType: 'text',
              },
              {
                name: 'eins_List_Input2',
                type: 'INPUT',
                inputType: 'number',
                units: ['Length'],
              },
              {
                name: 'eins_List_RadioGroup',
                type: 'RADIO_GROUP',
                radioItems: [
                  {
                    name: 'Ohne Input',
                    checked: true,
                  },
                  {
                    name: 'Mit Input',
                    items: [
                      {
                        name: 'eins_List_RG_Input',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Length'],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  'uit301_RadioInList_1.json': {
    items: [
      {
        name: '301_RadioInList_1',
        type: 'TITLE',
      },
      {
        name: 'EINS',
        type: 'SUBTITLE',
      },
      {
        name: 'list',
        type: 'LIST',
        initItemCount: 0,
        maxItemCount: 4,
        listItems: [
          {
            name: 'radio',
            type: 'RADIO_GROUP',
            radioItems: [
              {
                name: 'A',
                items: [
                  {
                    name: 'text',
                    type: 'INPUT',
                    inputType: 'text',
                  },
                ],
              },
              {
                name: 'B',
              },
              {
                name: 'C',
                checked: true,
                items: [
                  {
                    name: 'number',
                    type: 'INPUT',
                    inputType: 'number',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  'emissionLimit.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'template_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'templateSearch',
        type: 'INPUT',
        inputType: 'search',
        data: ['limits_templateSearch'],
        importance: 'optional',
      },
      {
        name: 'species_list',
        type: 'LIST',
        importance: 'optional',
        initItemCount: 0,
        maxItemCount: 50,
        listItems: [
          {
            name: 'limitSpecies',
            type: 'INPUT',
            inputType: 'search',
            data: ['speciesSearch'],
          },
          {
            name: 'limitValue',
            type: 'INPUT',
            inputType: 'number',
            units: ['Concentration', 'MassFlow'],
          },
        ],
      },
    ],
  },
  'componentGlobalSettings.json': {
    items: [
      {
        name: 'componentGlobal',
        type: 'TITLE',
      },
      {
        name: 'ambientTemp',
        type: 'INPUT',
        inputType: 'number',
        units: ['Temperature'],
        importance: 'optional',
      },
      {
        name: 'height',
        type: 'INPUT',
        inputType: 'number',
        units: ['Length'],
        importance: 'optional',
      },
    ],
  },
  'uit104_Search.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'uit300_List.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'addCodes.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
  'fan.svg':
    '<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g opacity="0.2">\n<path d="M51.0004 50C50.0798 50 49.1969 50.3688 48.546 51.0251C47.895 51.6815 47.5293 52.5717 47.5293 53.5C47.5293 54.4283 47.895 55.3185 48.546 55.9749C49.1969 56.6312 50.0798 57 51.0004 57C51.921 57 52.8038 56.6312 53.4548 55.9749C54.1057 55.3185 54.4714 54.4283 54.4714 53.5C54.4714 52.5717 54.1057 51.6815 53.4548 51.0251C52.8038 50.3688 51.921 50 51.0004 50Z" fill="#0095DB"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M51.0001 16C30.4613 16 13.8101 32.79 13.8101 53.5C13.8101 74.21 30.4613 91 51.0001 91C58.3023 91.0114 65.4447 88.8453 71.5291 84.774L107.121 64.409C107.292 64.3113 107.442 64.1806 107.563 64.0242C107.683 63.8678 107.772 63.689 107.823 63.4979C107.875 63.3069 107.888 63.1074 107.863 62.9111C107.838 62.7148 107.774 62.5254 107.676 62.354L97.7585 45.034C97.6549 44.8529 97.515 44.6957 97.3477 44.5723C97.1803 44.449 96.9893 44.3622 96.7867 44.3177C96.5842 44.2732 96.3747 44.2718 96.1716 44.3137C95.9685 44.3556 95.7763 44.4398 95.6074 44.561L88.0306 49.996C86.2762 30.928 70.3668 16 50.9982 16H51.0001ZM34.6365 53.5C34.6365 44.387 41.9625 37 51.0001 37C60.0378 37 67.3638 44.387 67.3638 53.5C67.3638 62.613 60.0378 70 51.0001 70C41.9625 70 34.6365 62.613 34.6365 53.5Z" fill="#0095DB"/>\n<path d="M105.289 37.1849C105.191 37.0142 105.061 36.8646 104.906 36.7446C104.751 36.6246 104.574 36.5366 104.386 36.4856C104.197 36.4347 104 36.4217 103.806 36.4475C103.613 36.4732 103.426 36.5373 103.257 36.6359L98.1038 39.6359C97.9344 39.7343 97.7859 39.8654 97.6668 40.0217C97.5477 40.178 97.4603 40.3565 97.4097 40.5469C97.359 40.7373 97.3461 40.9359 97.3716 41.1313C97.3971 41.3268 97.4606 41.5152 97.5584 41.6859L109.956 63.3359C110.054 63.5067 110.183 63.6564 110.338 63.7764C110.493 63.8965 110.67 63.9845 110.859 64.0355C111.048 64.0865 111.245 64.0995 111.438 64.0736C111.632 64.0478 111.819 63.9836 111.988 63.8849L117.141 60.8849C117.31 60.7864 117.459 60.6552 117.578 60.4989C117.697 60.3425 117.784 60.164 117.835 59.9737C117.885 59.7833 117.898 59.5847 117.873 59.3893C117.847 59.1939 117.783 59.0055 117.686 58.8349L105.289 37.1849ZM23.2317 92.9999C22.8372 92.9999 22.4588 93.1579 22.1799 93.4392C21.9009 93.7205 21.7441 94.1021 21.7441 94.4999V103.5C21.7441 103.898 21.9009 104.279 22.1799 104.561C22.4588 104.842 22.8372 105 23.2317 105H78.7689C79.1635 105 79.5418 104.842 79.8208 104.561C80.0998 104.279 80.2565 103.898 80.2565 103.5V94.4999C80.2565 94.1021 80.0998 93.7205 79.8208 93.4392C79.5418 93.1579 79.1635 92.9999 78.7689 92.9999H23.2317Z" fill="#0095DB"/>\n</g>\n<path d="M46.0413 51.4999C46.2248 51.4999 46.4033 51.4749 46.5719 51.4279L46.8506 51.9149L47.7094 51.4149L47.4307 50.9269C47.6882 50.6723 47.872 50.3518 47.9623 49.9999H48.5206V48.9999H47.9623C47.8721 48.6478 47.6883 48.3273 47.4307 48.0729L47.7104 47.5849L46.8515 47.0849L46.5729 47.5729C46.2254 47.4756 45.8582 47.4756 45.5107 47.5729L45.2311 47.0849L44.3722 47.5849L44.6519 48.0729C44.398 48.3229 44.2115 48.6429 44.1203 48.9999H43.562V49.9999H44.1203C44.2115 50.3569 44.398 50.6759 44.6509 50.9269L44.3712 51.4149L45.2301 51.9149L45.5097 51.4269C45.6783 51.4749 45.8568 51.4999 46.0413 51.4999ZM50.5041 49.9999H49.5124V48.9999H50.5041V49.9999ZM52.4876 49.9999H51.4958V48.9999H52.4876V49.9999ZM54.471 49.9999H53.4793V48.9999H54.471V49.9999ZM56.4545 49.9999H55.4628V48.9999H56.4545V49.9999ZM58.438 49.9999H57.4463V48.9999H58.438V49.9999ZM60.4215 49.9999H59.4297V48.9999H60.4215V49.9999ZM42.5702 48.9999H41.5785V49.9999H42.5702V48.9999ZM40.5868 48.9999H39.595V49.9999H40.5868V48.9999ZM38.6033 48.9999H37.6115V49.9999H38.6033V48.9999ZM36.6198 48.9999H35.6281V49.9999H36.6198V48.9999ZM34.6363 48.9999H33.6446V49.9999H34.6363V48.9999ZM32.6529 48.9999H31.6611V49.9999H32.6529V48.9999ZM47.8423 53.6469L47.3464 52.7809L48.2053 52.2809L48.7011 53.1469L47.8423 53.6469ZM48.834 55.3799L48.3382 54.5129L49.197 54.0129L49.6929 54.8789L48.834 55.3799ZM49.8258 57.1109L49.3299 56.2449L50.1887 55.7449L50.6846 56.6109L49.8258 57.1109ZM50.8175 58.8429L50.3216 57.9769L51.1805 57.4769L51.6763 58.3429L50.8175 58.8429ZM51.8092 60.5749L51.3134 59.7089L52.1722 59.2089L52.6681 60.0749L51.8092 60.5749ZM52.801 62.3069L52.3051 61.4409L53.1639 60.9409L53.6598 61.8069L52.801 62.3069ZM43.8753 52.2809L43.3795 53.1469L44.2383 53.6469L44.7342 52.7809L43.8753 52.2809ZM42.8836 54.0129L42.3877 54.8789L43.2466 55.3789L43.7425 54.5129L42.8836 54.0129ZM41.8919 55.7449L41.396 56.6109L42.2549 57.1109L42.7507 56.2449L41.8919 55.7449ZM40.9001 57.4769L40.4043 58.3429L41.2631 58.8429L41.759 57.9769L40.9001 57.4769ZM39.9084 59.2099L39.4125 60.0749L40.2714 60.5749L40.7672 59.7089L39.9084 59.2099ZM38.9167 60.9409L38.4208 61.8069L39.2796 62.3069L39.7755 61.4409L38.9167 60.9409ZM44.2393 45.3529L44.7352 46.2189L43.8763 46.7189L43.3805 45.8529L44.2393 45.3529ZM43.2476 43.6199L43.7434 44.4869L42.8846 44.9869L42.3887 44.1209L43.2476 43.6199ZM42.2558 41.8889L42.7517 42.7549L41.8929 43.2549L41.397 42.3889L42.2558 41.8889ZM41.2641 40.1569L41.76 41.0229L40.9011 41.5229L40.4053 40.6569L41.2641 40.1569ZM40.2724 38.4249L40.7682 39.2909L39.9094 39.7909L39.4135 38.9249L40.2724 38.4249ZM39.2806 36.6929L39.7765 37.5589L38.9177 38.0589L38.4218 37.1929L39.2806 36.6929ZM48.2063 46.7189L48.7021 45.8529L47.8433 45.3529L47.3474 46.2189L48.2063 46.7189ZM49.198 44.9869L49.6939 44.1209L48.835 43.6209L48.3392 44.4869L49.198 44.9869ZM50.1897 43.2549L50.6856 42.3889L49.8268 41.8889L49.3309 42.7549L50.1897 43.2549ZM51.1815 41.5229L51.6773 40.6569L50.8185 40.1569L50.3226 41.0229L51.1815 41.5229ZM52.1732 39.7899L52.6691 38.9249L51.8102 38.4249L51.3144 39.2909L52.1732 39.7899ZM53.1649 38.0589L53.6608 37.1929L52.802 36.6929L52.3061 37.5589L53.1649 38.0589Z" fill="#0095DB"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M46.0415 30C35.3605 30 26.7026 38.73 26.7026 49.5C26.7026 60.27 35.3605 69 46.0415 69C56.7225 69 65.3803 60.27 65.3803 49.5C65.3803 38.73 56.7225 30 46.0415 30ZM29.6848 49C29.8534 43.28 32.9089 38.292 37.4332 35.465L37.9261 36.327L38.785 35.827L38.2911 34.964C40.6728 33.6707 43.3364 32.9957 46.0415 33C48.8451 33 51.4851 33.711 53.7919 34.965L53.298 35.827L54.1569 36.327L54.6507 35.465C59.173 38.292 62.2286 43.281 62.3972 49H61.4134V50H62.3972C62.2286 55.72 59.174 60.708 54.6497 63.535L54.1559 62.673L53.297 63.173L53.7909 64.036C51.4095 65.3292 48.7463 66.0042 46.0415 66C43.2369 66 40.5969 65.289 38.2911 64.035L38.784 63.173L37.9251 62.673L37.4322 63.535C32.9099 60.708 29.8534 55.719 29.6848 50H30.6696V49H29.6848ZM54.4593 35.348C54.2951 35.2479 54.1287 35.1512 53.9605 35.058L54.4593 35.348ZM37.6048 35.359L38.1403 35.047C37.9598 35.147 37.7813 35.252 37.6048 35.359ZM37.6236 63.652C37.7873 63.752 37.9539 63.849 38.1225 63.942L37.6236 63.652ZM54.4782 63.641L53.9426 63.953C54.1221 63.853 54.3016 63.748 54.4782 63.641Z" fill="#0095DB"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M65.7598 81.3C59.8507 85.0351 53.0153 87.011 46.0412 87C25.5023 87 8.85107 70.21 8.85107 49.5C8.85107 28.79 25.5023 12 46.0412 12C65.4613 12 81.4045 27.009 83.0845 46.15L90.6335 40.572C90.8021 40.4474 90.9949 40.36 91.1992 40.3155C91.4035 40.2711 91.6148 40.2705 91.8194 40.3139C92.0239 40.3573 92.2171 40.4437 92.3863 40.5674C92.5555 40.6912 92.697 40.8495 92.8015 41.032L102.719 58.352C102.817 58.5234 102.881 58.7126 102.906 58.9088C102.931 59.105 102.918 59.3044 102.867 59.4954C102.815 59.6863 102.727 59.8652 102.607 60.0217C102.487 60.1781 102.337 60.3091 102.166 60.407L65.7598 81.3ZM11.8263 49.5C11.8263 30.446 27.1446 15 46.0412 15C64.9377 15 80.256 30.446 80.256 49.5C80.256 61.817 73.8554 72.626 64.2246 78.73L61.6689 80.196C56.8352 82.703 51.4768 84.0073 46.0412 84C27.1446 84.001 11.8263 68.554 11.8263 49.5ZM75.6792 72.156L99.3935 58.546L91.054 43.981L83.2292 49.761C83.1865 57.8539 80.5368 65.7136 75.6792 72.156ZM16.785 90.5C16.785 90.1022 16.9417 89.7206 17.2207 89.4393C17.4996 89.158 17.878 89 18.2726 89H73.8098C74.2043 89 74.5827 89.158 74.8616 89.4393C75.1406 89.7206 75.2974 90.1022 75.2974 90.5V99.5C75.2974 99.8978 75.1406 100.279 74.8616 100.561C74.5827 100.842 74.2043 101 73.8098 101H18.2726C17.878 101 17.4996 100.842 17.2207 100.561C16.9417 100.279 16.785 99.8978 16.785 99.5V90.5ZM19.7602 92V98H72.3221V92H19.7602ZM92.6002 37.685C92.5025 37.5144 92.4392 37.326 92.4138 37.1306C92.3883 36.9353 92.4013 36.7368 92.452 36.5466C92.5026 36.3563 92.59 36.178 92.709 36.0217C92.828 35.8655 92.9764 35.7344 93.1456 35.636L98.2977 32.636C98.4669 32.5376 98.6537 32.4737 98.8474 32.4481C99.0412 32.4224 99.238 32.4355 99.4267 32.4866C99.6154 32.5377 99.7923 32.6257 99.9472 32.7457C100.102 32.8657 100.232 33.0153 100.33 33.186L112.726 54.836C112.824 55.0066 112.888 55.1949 112.913 55.3902C112.939 55.5855 112.926 55.784 112.875 55.9743C112.825 56.1646 112.738 56.343 112.619 56.4993C112.5 56.6555 112.351 56.7866 112.182 56.885L107.029 59.885C106.86 59.9834 106.673 60.0473 106.479 60.0729C106.285 60.0986 106.089 60.0855 105.9 60.0344C105.711 59.9833 105.534 59.8953 105.379 59.7753C105.224 59.6553 105.094 59.5057 104.997 59.335L92.6002 37.685ZM95.9205 37.485L106.83 56.537L109.406 55.037L98.497 35.984L95.9205 37.485Z" fill="#0095DB"/>\n</svg>\n',
  'eco.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M37.2178 7.17004C36.6213 7.17004 36.1378 7.65358 36.1378 8.25004V73.25C36.1378 73.8465 36.6213 74.33 37.2178 74.33H91.2178C91.8142 74.33 92.2978 73.8465 92.2978 73.25V8.25004C92.2978 7.65358 91.8142 7.17004 91.2178 7.17004H37.2178Z" fill="#0095DB"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M29.9678 2.25C29.9678 1.55964 30.5274 1 31.2178 1H85.2178C85.9081 1 86.4678 1.55964 86.4678 2.25V67.25C86.4678 67.9404 85.9081 68.5 85.2178 68.5H31.2178C30.5274 68.5 29.9678 67.9404 29.9678 67.25V2.25ZM32.4678 3.5V66H83.9678V3.5H32.4678Z" fill="#0095DB"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M46.2178 25 L46.2178 63Z" style="fill:none;stroke:#e31a00;stroke-width:2.6"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M46.2178 70 L46.2178 80Z" style="fill:none;stroke:#e31a00;stroke-width:2.6"/>\n\n<path fill-rule="evenodd" clip-rule="evenodd" d="M70.2178 25 L70.2178 63Z" style="fill:none;stroke:#e37b2b;stroke-width:2.6"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M70.2178 73 L70.2178 85Z" style="fill:none;stroke:#e37b2b;stroke-width:2.6"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M70.9986 24.274C71.5377 24.7052 71.6251 25.4918 71.1938 26.0309L65.1938 33.5309C64.9566 33.8274 64.5975 34 64.2177 34C63.838 34 63.4789 33.8274 63.2416 33.5309L58.2177 27.251L53.1938 33.5309C52.9566 33.8274 52.5975 34 52.2177 34C51.838 34 51.4789 33.8274 51.2416 33.5309L45.2416 26.0309C44.8104 25.4918 44.8978 24.7052 45.4369 24.274C45.9759 23.8427 46.7626 23.9301 47.1938 24.4692L52.2177 30.7491L57.2416 24.4692C57.4789 24.1727 57.838 24 58.2177 24C58.5975 24 58.9566 24.1727 59.1938 24.4692L64.2177 30.7491L69.2416 24.4692C69.6729 23.9301 70.4595 23.8427 70.9986 24.274Z" fill="#ff4c28"/>\n  <path d="M46.2178 83 L48.25 80 L44.2178 80Z" style="fill:none;stroke:#e31a00;stroke-width:2" />\n  <path d="M70.2178 72 L72.2178 75 L68.2178 75Z" style="fill:none;stroke:#e37b2b;stroke-width:2" />\n</svg>\n',
  'streamModifier.json': {
    items: [
      {
        type: 'SEPARATOR',
      },
      {
        name: 'press_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'pressure_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'deltaPressure',
            checked: true,
            items: [
              {
                name: 'deltaPressure_Input',
                type: 'INPUT',
                inputType: 'number',
                units: ['PressureAbs'],
                defaultUnit: 'Pa_abs',
                default: 0.0,
                importance: 'optional',
              },
            ],
          },
          {
            name: 'newPressure',
            items: [
              {
                name: 'newPressure_Input',
                type: 'INPUT',
                inputType: 'number',
                units: ['Pressure'],
                importance: 'optional',
              },
            ],
          },
        ],
      },
      {
        name: 'temp_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'temperature_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'deltaTemperature',
            checked: true,
            items: [
              {
                name: 'deltaTemperature_Input',
                type: 'INPUT',
                inputType: 'number',
                units: ['Temperature'],
                defaultUnit: 'gradC',
                default: 0.0,
                importance: 'optional',
              },
            ],
          },
          {
            name: 'newTemperature',
            items: [
              {
                name: 'newTemperature_Input',
                type: 'INPUT',
                inputType: 'number',
                units: ['Temperature'],
                importance: 'optional',
              },
            ],
          },
        ],
      },
      {
        name: 'flow_subtitle',
        type: 'SUBTITLE',
      },
      {
        name: 'Flow_radio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'deltaFlow',
            checked: true,
            items: [
              {
                name: 'deltaFlow_Input',
                type: 'INPUT',
                inputType: 'number',
                units: ['Percent', 'VolumeFlow', 'MassFlow_kgX'],
                defaultUnit: 'percent',
                default: 0.0,
                importance: 'optional',
              },
            ],
          },
          {
            name: 'newFlow',
            items: [
              {
                name: 'newFlow_Input',
                type: 'INPUT',
                inputType: 'number',
                units: ['VolumeFlow', 'MassFlow_kgX'],
                importance: 'optional',
              },
            ],
          },
        ],
      },
      {
        type: 'SEPARATOR',
      },
      {
        name: 'Konz_list',
        type: 'LIST',
        initItemCount: 0,
        maxItemCount: 10,
        listItems: [
          {
            name: 'loadSpecies',
            type: 'INPUT',
            inputType: 'search',
            data: ['speciesSearch'],
          },
          {
            name: 'konz_radio',
            type: 'RADIO_GROUP',
            radioItems: [
              {
                name: 'deltaConc',
                checked: true,
                items: [
                  {
                    name: 'delteConc_Input',
                    type: 'INPUT',
                    inputType: 'number',
                    units: ['Percent', 'Concentration', 'AdditiveUnit_kgh'],
                  },
                ],
              },
              {
                name: 'newConc',
                items: [
                  {
                    name: 'newConc_Input',
                    type: 'INPUT',
                    inputType: 'number',
                    units: ['Concentration', 'AdditiveUnit_kgh'],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  'cyclone.json': {
    items: [
      {
        name: 'cyclone',
        type: 'TITLE',
      },
      {
        name: 'particleDensity',
        type: 'INPUT',
        inputType: 'number',
        units: ['Density'],
      },
      {
        name: 'bulkDensity',
        type: 'INPUT',
        inputType: 'number',
        units: ['Density'],
      },
      {
        name: 'productSelection',
        type: 'SUBTITLE',
      },
      {
        name: 'inletGeometry',
        type: 'INPUT',
        inputType: 'select',
        options: ['inletGeometryOptions'],
        default: 'tangential',
      },
      {
        name: 'exhaustSpiral',
        type: 'INPUT',
        inputType: 'select',
        options: ['exhaustSpiralOptions'],
        default: 'False',
      },
      {
        name: 'numberOfCyclones',
        type: 'INPUT',
        inputType: 'select',
        options: ['numberOfCyclonesOptions', 'emptyOption'],
        default: '',
        importance: 'optional',
      },
      {
        name: 'productSelectionRadio',
        type: 'RADIO_GROUP',
        radioItems: [
          {
            name: 'noSelection',
            checked: true,
            items: [
              {
                name: 'dustSeparation',
                type: 'INPUT',
                inputType: 'number',
                units: ['Percent'],
              },
              {
                name: 'pressureDrop',
                type: 'INPUT',
                inputType: 'number',
                units: ['PressureAbs'],
              },
              {
                name: 'filterProducts',
                type: 'RADIO_GROUP',
                radioItems: [
                  {
                    name: 'noFilter',
                    checked: true,
                  },
                  {
                    name: 'filter',
                    items: [
                      {
                        name: 'cycloneType',
                        type: 'INPUT',
                        inputType: 'multi-select',
                        options: ['cycloneTypes'],
                        importance: 'optional',
                      },
                      {
                        name: 'totalHeight',
                        type: 'INPUT',
                        inputType: 'number',
                        units: ['Length'],
                        importance: 'optional',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            name: 'productKey',
            items: [
              {
                name: 'productKeyInput',
                type: 'INPUT',
                inputType: 'text',
              },
            ],
          },
        ],
      },
    ],
  },
  'streamModifier.svg':
    '<?xml version="1.0" encoding="iso-8859-1"?>\n<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\n<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n<svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"\n\t width="800px" height="800px" viewBox="0 0 120 120"\n\t xml:space="preserve">\n<path fill-rule="evenodd" fill-opacity=".2" fill="#0095DB" d="M107 82.44V45.555a9.112 9.112 0 0 0-4.611-7.898L70.111 19.221a9.314 9.314 0 0 0-9.222 0L28.61 37.658C25.757 39.291 24 42.304 24 45.561v36.883a9.095 9.095 0 0 0 4.611 7.898l32.278 18.437a9.317 9.317 0 0 0 9.222 0l32.278-18.437c2.854-1.633 4.611-4.646 4.611-7.903Z"></path>\n<path fill-rule="evenodd" fill-opacity="1" fill="#0095DB" d="m100.4 41.559-.004-.251a7.6 7.6 0 0 0-.458-2.343L62 60.868v43.485a7.815 7.815 0 0 0 2.355-.876l32.2-18.437a7.617 7.617 0 0 0 3.845-6.6V41.558ZM60.5 15.5a7.777 7.777 0 0 0-3.856 1.023h.001l-32.2 18.437v-.001a7.696 7.696 0 0 0-1.817 1.446L60.5 58.27l37.875-21.866a7.607 7.607 0 0 0-1.816-1.441l-.003-.002-32.2-18.437A7.776 7.776 0 0 0 60.5 15.5Zm42.9 62.94c0 3.798-2.044 7.306-5.354 9.204l-32.2 18.436-.002.001a10.77 10.77 0 0 1-10.688 0l-.001-.001-32.2-18.436a10.6 10.6 0 0 1-5.355-9.2V41.56c0-1.78.45-3.498 1.269-5.015a1.492 1.492 0 0 1 .551-.911 10.677 10.677 0 0 1 3.534-3.278l32.2-18.436.002-.001.307-.169a10.774 10.774 0 0 1 10.074 0l.307.169h.001l32.198 18.436.301.178a10.606 10.606 0 0 1 3.244 3.11c.145.114.272.256.37.425.086.15.142.31.172.471a10.605 10.605 0 0 1 1.27 5.015v36.885Zm-82.8.003a7.6 7.6 0 0 0 3.845 6.597l32.2 18.437c.735.42 1.531.713 2.355.876V60.868L21.062 38.965c-.3.82-.46 1.697-.46 2.595v36.883Z"></path>\n</svg>',
  'uit201_RadioinRadio.svg':
    '<svg width="124" height="86" viewBox="0 0 124 86" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g clip-path="url(#clip0_1862_13098)">\n<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M19.1314 4.54541C18.303 4.54541 17.6314 5.21698 17.6314 6.04541V18.3181C17.6314 19.1466 18.303 19.8181 19.1314 19.8181H120.041C120.869 19.8181 121.541 19.1466 121.541 18.3181V6.04541C121.541 5.21698 120.869 4.54541 120.041 4.54541H19.1314ZM19.1314 25C18.303 25 17.6314 25.6715 17.6314 26.5V66.0454C17.6314 66.2783 17.6857 66.508 17.7898 66.7162L30.4034 91.9435C30.6575 92.4517 31.1769 92.7727 31.7451 92.7727C32.3132 92.7727 32.8326 92.4517 33.0867 91.9435L44.3587 69.3995L55.6307 91.9435C55.8848 92.4517 56.4042 92.7727 56.9723 92.7727C57.5405 92.7727 58.0599 92.4517 58.314 91.9435L69.586 69.3995L80.858 91.9435C81.1121 92.4517 81.6315 92.7727 82.1996 92.7727C82.7678 92.7727 83.2872 92.4517 83.5413 91.9435L94.8133 69.3995L106.085 91.9435C106.339 92.4517 106.859 92.7727 107.427 92.7727C107.995 92.7727 108.514 92.4517 108.769 91.9435L121.382 66.7162C121.486 66.508 121.541 66.2783 121.541 66.0454V26.5C121.541 25.6715 120.869 25 120.041 25H19.1314Z" fill="#0095DB"/>\n<path d="M70 5  L20 45 L70 80 L120 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n<path d="M70 16 L35 45 L70 70 L105 45 Z" style="fill:none;stroke:green;stroke-width:3" />\n</g>\n<defs>\n<clipPath id="clip0_1862_13098">\n<rect width="122.989" height="86" fill="white" transform="translate(0.989258)"/>\n</clipPath>\n</defs>\n<text x="62.5" y="50" fill="red">??</text>\n</svg>\n',
};
